<template>
	<div>
		<div v-if="insureType == 6 && (isFgkCommon(productId) || isFgkCommonYear(productId))">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1、订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							2、
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>3、保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							4、
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							5、
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							6、
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							7、保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>经营范围涉及高空作业的企业。</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>
							自生效日起，保险期限{{
								isFgkCommonYear(productId)
									? '仅支持选择12个月，可进行人员批增'
									: '可由企业根据实际用工需求，选择1个月、3个月或者6个月'
							}}。
						</p>

						<h3>3.3 特别约定</h3>
						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、本保单可承保4-6类工种(含高处作业）：电梯/升降梯安装维修、通信工程安装及维护（不含铁塔架设和拆除）、焊工、电力建设及检修、广告牌安装及维修及路灯安装、外墙清洗、玻璃幕墙安装及维修、建筑工程（仅限工业、民用建房工程以及装修）等。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							7、
							<span class="red-bold">
								本保单不承保工种：水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种、金属冶炼、钢缆生产加工工种、船舶制造/维修/拆除的工种、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构安装或拆除的工种、机械设备拆除工。如施工合同中的项目名称或者作业内容含有保险人不承保的工种字眼，如“桥梁”等，保险人不承担任何赔偿责任。
							</span>
							8、建筑拆除（含钢结构）是指对已经建成或部分建成的建筑物或构筑物等进行拆除的工程作业。屋面防水、屋面防腐、屋面翻新维修、屋面更换均不属于建筑拆除范畴。
							9、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。如属于第7条特约的不承保工种，保险人不承担任何赔偿责任。
							</span>
							10、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							11、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							12、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							13、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							14、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，
							<span class="red-bold">
								六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例10%，九级伤残给付比例7%，十级伤残给付比例5%。
							</span>
							15、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							16、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							17、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							18、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							高处作业证及其他特种作业操作证必须由应急管理部门颁发。 19、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							20、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							21、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							22、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							23、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							24、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							25、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							26、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							1、保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							2、
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="insureType == 6 && isFgkZungui(productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1、订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							2、
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>3、保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							4、
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							5、
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							6、
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							7、保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>经营范围涉及高空作业的企业。</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月或者6个月。</p>

						<h3>3.3 特别约定</h3>
						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、本保单可承保4-6类工种(含高处作业）：电梯/升降梯安装维修、通信工程安装及维护（不含铁塔架设和拆除）、焊工、电力建设及检修、广告牌安装及维修及路灯安装、外墙清洗、玻璃幕墙安装及维修、建筑工程（仅限工业、民用建房工程以及装修）等。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							7、
							<span class="red-bold">
								本保单不承保工种：水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种、金属冶炼、钢缆生产加工工种、船舶制造/维修/拆除的工种、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构安装或拆除的工种、机械设备拆除工。如施工合同中的项目名称或者作业内容含有保险人不承保的工种字眼，如“桥梁”等，保险人不承担任何赔偿责任。
							</span>
							8、建筑拆除（含钢结构）是指对已经建成或部分建成的建筑物或构筑物等进行拆除的工程作业。屋面防水、屋面防腐、屋面翻新维修、屋面更换均不属于建筑拆除范畴。
							9、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。如属于第7条特约的不承保工种，保险人不承担任何赔偿责任。
							</span>
							10、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），
							<span class="red-bold">保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。</span>
							11、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							12、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							13、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							14、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，
							<span class="red-bold">
								六级伤残给付比例50%，七级伤残给付比例40%，八级伤残给付比例20%，九级伤残给付比例10%，十级伤残给付比例5%。
							</span>
							15、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							16、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							17、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							18、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							高处作业证及其他特种作业操作证必须由应急管理部门颁发。 19、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							20、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							21、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							22、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							23、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							24、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							25、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							26、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							1、保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							2、
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="insureType == 6 && isFgkGangZungui(productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1、订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							2、
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>3、保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							4、
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							5、
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							6、
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							7、保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>经营范围涉及高空作业的企业。</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月或者6个月。</p>

						<h3>3.3 特别约定</h3>
						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、
							<span class="red-bold">
								本保单仅承保以下工种（含高处作业）：钢结构安装工、钢骨结构工人、机械设备拆除工等。
							</span>
							本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。 7、
							<span class="red-bold">
								本保单不承保工种：水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种、金属冶炼、钢缆生产加工工种、船舶制造/维修/拆除的工种、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构拆除的工种。如施工合同中的项目名称或者作业内容含有保险人不承保的职业类别，如“桥梁”等等，保险人不承担任何赔偿责任。
							</span>
							8、建筑拆除（含钢结构）是指对已经建成或部分建成的建筑物或构筑物等进行拆除的工程作业。屋面防水、屋面防腐、屋面翻新维修、屋面更换均不属于建筑拆除范畴。
							9、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。如属于第7条特约的不承保工种，保险人不承担任何赔偿责任。
							</span>
							10、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），
							<span class="red-bold">保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。</span>
							11、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							12、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							13、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							14、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，
							<span class="red-bold">
								六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例10%，九级伤残给付比例7%，十级伤残给付比例5%。
							</span>
							15、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							16、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							17、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							18、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔35%后赔付。高处作业证及其他特种作业操作证必须由应急管理部门颁发。
							</span>
							19、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							20、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							21、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							22、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							23、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							24、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							25、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							26、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4。</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							1、保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							2、
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-if="insureType == 6 && isFgkGangCommon(productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							2
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							4
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							5
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							6
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>经营范围涉及高空作业的企业。</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月或者6个月。</p>

						<h3>3.3 特别约定</h3>
						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、
							<span class="red-bold">
								本保单仅承保以下工种（含高处作业）：钢结构安装工、钢骨结构工人、机械设备拆除工等。
							</span>
							本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。 7、
							<span class="red-bold">
								本保单不承保工种：水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种、金属冶炼、钢缆生产加工工种、船舶制造/维修/拆除的工种、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构拆除的工种。如施工合同中的项目名称或者作业内容含有保险人不承保的职业类别，如“桥梁”等等，保险人不承担任何赔偿责任。
							</span>
							8、建筑拆除（含钢结构）是指对已经建成或部分建成的建筑物或构筑物等进行拆除的工程作业。屋面防水、屋面防腐、屋面翻新维修、屋面更换均不属于建筑拆除范畴。
							9、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。如属于第7条特约的不承保工种，保险人不承担任何赔偿责任。
							</span>
							10、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							11、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							12、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							13、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							14、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，
							<span class="red-bold">
								六级伤残给付比例30%，七级伤残给付比例10%，八级伤残给付比例5%，九级伤残给付比例3%，十级伤残给付比例1%。
							</span>
							15、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							16、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							17、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							18、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔35%后赔付。高处作业证及其他特种作业操作证必须由应急管理部门颁发。
							</span>
							19、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							20、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							21、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							22、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							23、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							24、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							25、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							26、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4。</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							2
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-if="insureType == 6 && isFgkGuangfu(productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1、订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							2、
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>3、保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							4、
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							5、
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							6、
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							7、保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>经营范围涉及高空作业的企业。</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月、6个月或者12个月。</p>

						<h3>3.3 特别约定</h3>

						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、
							<span class="red-bold">
								本保单仅承保光伏行业安装维修工程（含高处作业），具体工程含光伏安装工程、光伏维修工程、光伏并网工程。
							</span>
							具体承保工种为：光伏安装维修工。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							7、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作不属于光伏行业工作内容，保险人不承担任何赔偿责任。
							</span>
							8、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							9、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							10、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							11、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							<span v-html="getGuangfu"></span>
							13、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							14、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							15、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							16、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证、电工证等），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							高处作业证及其他特种作业操作证必须由应急管理部门颁发。 17、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							18、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							19、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							20、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							21、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							22、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							23、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							24、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							1、保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							2、
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-if="insureType == 6 && isFgkDoor(productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1、订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							2、
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>3、保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							4、
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							5、
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							6、
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							7、保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>经营范围涉及高空作业的企业。</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月或者6个月。</p>

						<h3>3.3 特别约定</h3>
						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。
							</span>
							如果事故实际发生日期早于本保单生效日期，但被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							2、出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打400-180-1616或太平洋产险全国统一客服电话95500，取得报案号后才是报案成功（否则报案失败）。
							<span class="red-bold">
								如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、
							<span class="red-bold">被保险人雇员的年龄限16-65周岁（含），本方案每人限投1份，超过部分无效。</span>
							被保险人雇员由于工作原因受到伤害，依照《工伤保险条例》及相关法律应当认定为工伤或视同工伤的，对于被保险人依法应承担的经济赔偿责任，保险人在本保单的责任限额内予以赔付。
							<span class="red-bold">本保单不承保承揽关系。</span>
							4、
							<span class="red-bold">
								本保单可加人（保险期限不足1个月的按1个月收费），不可减人。保险期限1-3个月（含）的保单不可换人，
							</span>
							保险期限超过3个月的保单可以换人，
							<span class="red-bold">任何保险期限的已出险人员不可替换。</span>
							换人规则：原4-5类工种人员可替换为新的4-5类工种人员，原6类工种人员可替换为新的6类工种人员，4-5类工种人员和6类工种人员之间不可互换。
							5、
							<span class="red-bold">
								保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。
							</span>
							最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							6、
							<span class="red-bold">
								本保单仅承保光伏行业安装维修工程（含高处作业），具体工程含光伏安装工程、光伏维修工程、光伏并网工程。
							</span>
							具体承保工种为：光伏安装维修工。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							7、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作不属于光伏行业工作内容，保险人不承担任何赔偿责任。
							</span>
							8、建筑拆除（含钢结构）是指对已经建成或部分建成的建筑物或构筑物等进行拆除的工程作业。屋面防水、屋面防腐、屋面翻新维修、屋面更换均不属于建筑拆除范畴。
							9、
							<span class="red-bold">
								被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。如属于第7条特约的不承保工种，保险人不承担任何赔偿责任。
							</span>
							10、
							<span class="red-bold">在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡</span>
							（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							11、
							<span class="red-bold">
								在本保单有效期内，被保险人雇员在从事与本保单所载明的被保险人的业务工作而罹患与业务有关的国家规定的职业性疾病的，须提供县级以上医院或疾控中心出具的相关确诊证明。确诊证明资料载明职业病罹患时间在本保单保险责任起始日期之前的，保险人不承担任何赔偿责任。
							</span>
							12、如被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金。
							13、如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
							<span v-html="getFgkDoor"></span>
							15、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
							16、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							</span>
							17、
							<span class="red-bold">本保单不承担任何性质的精神损害赔偿责任。</span>
							18、
							<span class="red-bold">
								从事高处作业必须佩戴安全带，从事特种作业必须取得对应有效特种作业操作证（包括但不限于高处作业证、电工证等），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							高处作业证及其他特种作业操作证必须由应急管理部门颁发。 19、
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院，但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							</span>
							20、
							<span class="red-bold">
								在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							21、以下情形，保险人不得以保单上列明工种有误而拒赔或者减少承担赔偿责任：保单上列明工种对应的保费，不低于被保险人实际工种对应的保费。
							22、
							<span class="red-bold">
								兹经双方同意，本保单累计赔偿限额为1000万，每次事故赔偿限额为500万。若伤亡事故造成的实际损失超出赔偿限额，对于超出部分，保险人不承担任何赔偿责任。
							</span>
							23、
							<span class="red-bold">
								如被保险人投保了工伤保险，则由工伤保险先行赔付，本保险再赔付差额部分；而投保了其他商业保险，则依照保险法的重复保险要求，其他商业保险与本保险按比例承担赔偿保险金的责任。
							</span>
							24、
							<span class="red-bold">兹经双方确认，因保险合同纠纷提起的诉讼，由被告住所地的人民法院管辖。</span>
							25、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							26、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							1、保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							2、
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<!-- <div v-if="productId==31"> -->
		<div v-else-if="insureType == 10">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em; font-weight: bold">
						本产品由中国平安财产保险股份有限公司（以下简称“中国平安”）承保，由中国平安委托博维保险经纪有限公司（以下简称“博维”）进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						中国平安财产保险股份有限公司成立于1988年，总部位于深圳，旗下43家分公司及2700余家中心支公司、支公司、营销服务部及营业部遍布全国。截止2020年第4季度，公司综合偿付能力充足率241.39%，满足监管要求，最近一期的风险综合评级结果为B。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p style="font-weight: bold">订立本合同时，本公司应向投保人说明本合同的内容。</p>
						<p style="font-weight: bold">
							对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。
						</p>
						<p style="font-weight: bold">本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p style="font-weight: bold">
							如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。
						</p>
						<p style="font-weight: bold">
							如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。
						</p>
						<p style="font-weight: bold">
							如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">平安雇主责任保险（A款）</td>
								<td style="text-align: center">C00001730912018083014861</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>
							电梯/商业中央空调行业（单位）为保险合同的投保人/被保险人，被保险人的分销商、二级网点为保险合同的共同被保险人。
							<span style="font-weight: bold">（本产品仅限于电梯/商业中央空调行业销售）</span>
						</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限为一年。</p>
						<p style="font-weight: bold">3.3 保单形式</p>
						<p>
							本产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.4 发票形式</p>
						<p>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
						</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							出险后尽快拨打博维客服热线400-180-1616或中国平安客户服务及投诉热线95511进行报案，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							5.1
							我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。
						</p>
						<p>
							5.2
							您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95511。
						</p>
						<p>
							5.3
							若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或中国平安客户服务及投诉热线：95511，我们将安排专人跟进处理。
						</p>
					</div>
				</div>
			</el-card>
			<!--            <el-card header="保险条款">-->
			<!--                <el-link type="primary" href="pingan1.html" target="_blank">中国平安财产保险股份有限公司雇主责任保险条款（A款）</el-link>-->
			<!--            </el-card>-->
		</div>
		<!-- <div v-if="productId==20"> -->
		<div v-else-if="insureType == 8">
			<el-card header="投保须知及声明">
				<h2 style="color: red">【一、产品责任/保障方案介绍】</h2>
				<div style="line-height: 28px; margin-left: 20px">
					<span class="font_title">本产品相关保险条件：</span>
					<br />
					<span class="font_title">1、每一被保险人在同一保险期间内限投保壹份，多投保无效。</span>
					<br />
					<span class="font_title">2、保险期间</span>
					<br />
					<div style="margin-left: 20px">
						本产品保险期间为1年（含短期单：6个月、3个月、1个月，费率以条款短期费率为准），以保险合同载明的起讫时间为准。
						<br />
						<span style="font-weight: bold">
							本产品保单自您完成投保操作并成功支付保险费之日T+2日零时生效。保单生效后，保险人开始承担保险责任，保单生效前发生的保险事故，保险人不承担保险责任。
						</span>
					</div>
					<span class="font_title">3、医院机构就诊范围</span>
					<br />
					<span style="margin-left: 20px">
						本产品适用的就诊医疗机构范围为：中华人民共和国境内（不含港、澳、台地区）二级及以上医院或者保险人指定或认可的医疗机构。但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。
					</span>
					<br />
					<span class="font_title">4、医疗费用免赔额及给付比例</span>
					<br />
					<span style="margin-left: 20px">
						对被保险人所支出的必要、合理的且属于当地社会医疗保险报销范围的意外伤害医疗费用，保险人每次扣除绝对免赔额RMB0元后，在意外伤害医疗费用保险金额范围内按照100%比例给付。
					</span>
					<br />
					<span style="margin-left: 20px">
						保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。
					</span>
					<br />
					<span class="font_title">5、等待期</span>
					<br />
					<span style="margin-left: 20px">本产品无等待期（指自保险期间开始之日起至保险责任开始之日止的时段）。</span>
					<br />
					<span class="font_title">6、特别约定</span>
					<br />
					<div style="margin-left: 20px; font-weight: bold">
						(1)、
						<span class="red-bold">
							出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打本保单第11条特别约定中的电话号码，取得报案号后才是报案成功(否则报案失败)。
						</span>
						如果被保险人委托第三人/第三方报案，后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第11条特别约定扣除免赔，那么被保险人须自行承担相关损失。
						<br />
						(2)、本保单承保的职业类别按风险从低到高，可分为4-6类，6类风险最高。
						<br />
						(3)、
						<span class="red-bold">
							本保单拒绝承保职业（即保险人不承担任何赔偿责任）：农牧渔业、海上作业、地质矿产业、化工/军工制造业、影视及演艺业、建筑物外墙维护及玻璃幕墙安装维护人员、特别约定桥梁/隧道工程人员、凿岩工、防水工、水运工程施工、水坝工程人员、潜水工作人员、体育运动、各种杂技人员、驯兽师、涉及火药/炸药/爆破的相关工作、易燃易爆/危险化学品运输司机及随车工、特种兵/军人/武警/公安/警察/消防等治安人员、高压电工作人员、快递/外卖配送等。
						</span>
						<br />
						(4)、
						<span class="red-bold">
							兹保险双方协商并同意，若从事高处作业，必须投保5-6类职业，否则发生保险事故，保险人不承担赔偿责任。
						</span>
						高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。
						<span class="red-bold">
							从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔50%。
						</span>
						<br />
						(5)、
						<span class="red-bold">
							兹保险双方协商并同意，投保4类职业的人员，若从事高处作业发生保险事故，则保险人不承担赔偿责任；若从事其他5-6类职业工作（不涉及高处作业）发生保险事故，则保险人对按保单约定的应承担的保险责任，免赔50%。
						</span>
						<br />
						(6)、以下情形，保险人不得以保单上列明职业有误而拒赔或者减少承担赔偿责任：保单上列明职业类别对应的保费，不低于被保险人实际职业类别对应的保费。
						<br />
						(7)、兹保险双方协商并同意，本保单不支持批减被保险人、变更保额。保险期限为3个月以内（含）的保单不支持替换被保险人，6个月和1年的保单支持替换被保险人（已出险人员除外）。
						<br />
						(8)、保险人赔付标准如下：
						<br />
						① 对于身故：按限额100%赔付。
						<br />
						②
						对于伤残：经司法鉴定后，伤残按一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、10级10%的比例赔付。
						<br />
						③
						对于医疗费用：保险人按投保人营业执照注册地（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
						<span class="red-bold">
							保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。
						</span>
						<br />
						④
						<span class="red-bold">对于住院津贴：在保险期间内每次事故赔偿不超过90天，累计不超过180天，无免赔。</span>
						身故/伤残保额10-30万的方案，每人每天100元；40-70万的方案，每人每天150元；80-100万的方案，每人每天200元。
						<br />
						(9)、
						<span class="red-bold">
							本保单指定就诊医院为大陆境内二级及以上公立医院，或保险人认可的其他医疗机构（如被保险人所在乡镇的公立医疗机构），但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。
						</span>
						对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。
						<br />
						(10)、
						<span class="red-bold">保险人不赔偿如下责任：</span>
						<br />
						①
						<span class="red-bold">拒绝承保职业。</span>
						<br />
						②
						<span class="red-bold">保险条款责任免除部分。</span>
						<br />
						③
						<span class="red-bold">精神损害、猝死、疾病所致治疗和身故。</span>
						<br />
						(11)、
						<span class="red-bold">
							兹保险双方协商并同意，被保险人必须在保险事故发生后24小时内拨打电话400-180-1616进行报案（如属于死亡或重伤事故，须在12小时内报案），因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任；如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%；
						</span>
						如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权追究被保险人及相关人员的刑事责任。
						<br />
						(12)、兹保险双方协商并同意，本保单累计赔偿限额为1000万。若伤亡事故造成的实际损失超1000万，对于超过部分，保险人不承担赔偿责任。
						<br />
						(13)、本保单扩展年龄规范保险条款，本保单承保被保险人年龄区间须为十六周岁（含）至六十五周岁（含）。
					</div>
					<span class="font_title">7、责任免除</span>
					<br />
					<span class="font_head">
						“中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）”责任免除详情
					</span>
					<span class="font_head" style="color: red">
						以下内容请您务必认真阅读！以下内容涵盖了本产品保险合同约定的主要免除责任，即保险公司不承担给付保险金责任或仅赔付部分保险金的情形。详细的责任免除相关内容请见《保险条款》。
					</span>
					<span class="font_head font_center" style="color: red; text-align: center">
						★保险公司不予给付保险金的责任免除★
					</span>
					<span class="font_head" style="color: red">
						《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》
					</span>
					<span class="font_title">
						因下列原因造成被保险人身故、伤残、支出医疗费用、住院治疗、突发急性病身故或猝死的，保险人不承担给付保险金责任：
					</span>
					<br />
					<div style="margin-left: 20px">
						（一）投保人的故意或重大过失行为；
						<br />
						（二）被保险人自致伤害或自杀，但被保险人自致伤害或自杀时为无民事行为能力人的除外；
						<br />
						（三）因被保险人挑衅或故意行为而导致的打斗、被袭击或被谋杀；
						<br />
						（四）猝死或突发急性病（该被保险人已投保突发急性病身故或猝死保险责任的不在此限）、其他疾病(包括但不限于高原反应、中暑、过敏及由过敏引发的变态反应)或其他自身身体原因；
						<br />
						（五）投保前已有的残疾及其并发症；
						<br />
						（六）被保险人接受整容手术、其他内、外科手术或其他诊疗活动过程中发生的医疗意外和医疗损害；
						<br />
						（七）被保险人未遵医嘱，私自服用、涂用、注射药物；
						<br />
						（八）被保险人洗牙、洁齿、验光、装配假眼、假牙、假肢或者助听器等；
						<br />
						（九）投保人、被保险人故意导致发病或发病后故意不及时就医的，但被保险人为无民事行为能力人的除外。
						<br />
						发生上述情形，被保险人身故的，保险人对该被保险人的保险责任终止，向投保人退还该被保险人的未满期净保费，如投保人、被保险人故意制造保险事故的，不退还保险费。
						<br />
						<span class="font_title">
							出现下列任一情形，导致被保险人身故、伤残、支出医疗费用、住院治疗、突发急性病身故或猝死的，保险人不承担给付保险金责任：
						</span>
						<br />
						（一）被保险人妊娠、流产、分娩、不孕症、避孕及绝育手术、先天性畸形、变形或染色体异常；
						<br />
						（二）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；
						<br />
						（三）战争、军事行动、暴动或武装叛乱、恐怖袭击；
						<br />
						（四）被保险人从事非法、犯罪活动期间或被依法拘留、服刑期间；
						<br />
						（五）被保险人醉酒或受毒品、管制药物的影响期间；
						<br />
						（六）被保险人酒后驾驶、无有效驾驶证驾驶或驾驶无有效行驶证的机动车期间；
						<br />
						（七）被保险人从事潜水、跳伞、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险活动期间；
						<br />
						（八）被保险人在家自设病床治疗、健康保健治疗、康复疗养治疗和非医疗行为的治疗等；
						<br />
						（九）住院治疗的，无医院有效的转院证明而自行转院的；
						<br />
						（十）本条款中载明的保险期间外发病的；
						<br />
						（十一）突发急性病身故条款中载明的抢救期后身故的。
						<br />
					</div>
					<span class="font_title">
						根据本保险条款的相关约定，保险人应不承担或免除保险责任的各种情形下的损失、费用或责任，或保险人有权予以扣除、减少的部分，保险人不负责给付保险金。
					</span>
					<br />
					<span class="font_head" style="color: red">
						《中国人寿财产保险股份有限公司意外伤害保险（互联网专属）类附加年龄规范保险条款（注册编号：C00010832322021122437413）》
					</span>
					兹经保险合同双方同意，鉴于投保人已了解保险方案中对被保险人年龄的限制，对于不符合保险方案规定年龄的被保险人，保险人不予承保。
					<br />
					本保单承保被保险人年龄区间须为十六周岁（含）至六十五周岁（含）。
					<br />
					<span class="font_head font_center" style="color: red; text-align: center">
						★投保人、被保险人未履行义务导致的责任免除★
					</span>
					<span class="font_head" style="color: red">
						《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》
					</span>
					<span class="font_title">【未及时交清保险费】</span>
					<br />
					&emsp;除另有约定外，投保人应当在保险合同成立时交清保险费。未交清保险费的，保险合同不生效，保险合同生效前发生保险事故的，保险人不承担保险责任。
					<br />
					<span class="font_title">【未如实告知】</span>
					<br />
					&emsp;订立保险合同时，保险人就被保险人的有关情况提出询问的，投保人应当如实告知。
					<br />
					&emsp;投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。
					<br />
					&emsp;投保人故意不履行如实告知义务的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。
					<br />
					&emsp;投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。
					<br />
					<span class="font_title">【出险后未及时报案通知】</span>
					<br />
					&emsp;投保人、保险金申请人知道保险事故发生后，应当及时通知保险人。故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。
					<br />
					&emsp;上述约定，不包括因不可抗力而导致的迟延。
					<br />
					<span class="font_head" style="color: red; text-align: center">★按比例或部分赔付保险金的情形★</span>
					<span class="font_head" style="color: red">
						《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》
					</span>
					一、被保险人身故前保险人已给付本条款约定的伤残保险金的，身故保险金为保险金额扣除已给付伤残保险金后的余额。
					<br />
					二、被保险人自意外伤害发生之日起一百八十日内（含）因该事故身体伤残的，保险人根据本保险合同所附《人身保险伤残评定标准》（保监发[2014]6号，标准编号为JR/T
					0083-2013，以下简称“《伤残评定标准》”）的规定，按该标准所列伤残程度对应的保险金给付比例乘以本保险合同载明的保险金额给付伤残保险金。
					<br />
					三、被保险人如在本次意外伤害事故之前已有伤残，保险人按合并后的伤残程度在《伤残评定标准》中所对应的给付比例给付伤残保险金，但应扣除原有伤残程度在《伤残评定标准》中所对应的伤残保险金。
					<br />
					<span class="font_head" style="color: red; text-align: center">★其他责任免除★</span>
					<span class="font_title">【保险合同无效】</span>
					<br />
					&emsp;订立本保险合同时，投保人对被保险人不具有保险利益的，本保险合同无效，保险人退还净保费。
					<span class="font_head" style="color: red; text-align: center">★未尽事宜以条款和保险合同约定为准★</span>
					<br />
					<h2 style="color: red">【二、产品说明】</h2>
					<div style="line-height: 28px; margin-left: 20px">
						<span class="font_title">（一）产品名称、适用条款：</span>
						<br />
						&emsp;本产品名称为
						<span class="font_title">“美保-团体人身意外伤害保险“，</span>
						适用保险条款为如下，
						<span class="font_title">
							购买前请阅读保险条款，并特别就条款中有关责任免除和投保人、被保险人义务的内容进行详细了解，确认接受条款的全部内容：
						</span>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">条款名称</th>
								<th style="width: 50%">条款备案号/注册编号</th>
							</tr>
							<tr>
								<td style="text-align: center">
									中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款
								</td>
								<td style="text-align: center">C00010832312022042867271</td>
							</tr>
							<tr>
								<td style="text-align: center">
									中国人寿财产保险股份有限公司意外伤害保险（互联网专属）类附加年龄规范保险条款
								</td>
								<td style="text-align: center">C00010832322021122437413</td>
							</tr>
						</table>
						<div style="font-weight: bold">
							&emsp;作为投保人，您应当了解、同意并确认上述条款内容，特别是保险责任、责任免除及其他用粗体等方式显著提示的部分。
							<br />
							&emsp;作为投保人，您应当确认投保时对被保险人具有保险利益，为他人投保本产品的，需在满足具有保险利益要求的基础上，告知被保险人知悉本产品的相关信息（包含但不限于保险责任、责任免除、保险金额）。购买本产品即表示您及被保险人同意接受本产品条款、保险方案和投保须知的全部内容。
							<br />
						</div>
						<span class="font_title">（二）承保公司、销售区域</span>
						<br />
						<span style="font-weight: bold">
							&emsp;本产品由中国人寿财产保险股份有限公司（以下简称“国寿财险”或“我公司”）承保，国寿财险总部设立于北京，在全国除港澳台之外的所有省、自治区及直辖市均设有分公司。本保险产品面向全国（不含港澳台地区）销售，由中国人寿财产保险股份有限公司广州分公司出单。
						</span>
						<br />
						<span class="font_title">（三）适用对象</span>
						<br />
						&emsp;1.投保人：被保险人本人或对被保险人有保险利益的机关、企业、事业单位、社会团体、其他组织或者自然人，均可作为本保险合同的投保人。
						<br />
						&emsp;2.被保险人：年龄在十六周岁（含）至六十五周岁（含）、身体健康、能正常工作或正常生活的自然人，可作为本保险合同的被保险人，且被保险人的职业类别为
						4-6
						类，职业类别以《中国人寿财产保险股份有限公司年度意外伤害保险职业等级分类表》为准，保单被保险人数不少于5人。
						<br />
					</div>
					<h2 style="color: red">【三、重要提示】</h2>
					<div style="font-weight: bold; margin-left: 20px">
						（一）购买前请您阅读保险条款、并特别就条款中的有关责任免除和投保人、被保险人义务的内容进行详细了解,确认接受条款的全部内容。
						<br />
						（二）本产品除外责任详见《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款责任免除详情》。
						<br />
						（三）本产品仅适用于：年龄在十六周岁（含）至六十五周岁（含）、身体健康、能正常工作或正常生活的自然人，可作为本保险合同的被保险人，且被保险人的职业类别为
						4-6 类，职业类别以《中国人寿财产保险股份有限公司年度意外伤害保险职业等级分类表》为准。
						<br />
						（四）根据原中国保险监督管理委员会《关于父母为其未成年子女投保以死亡为给付保险金条件的人身保险有关问题的通知》（保监发[2015]90
						号）文件的规定，未满18周岁的未成年人，在各家保险公司的身故保险金总额(不含航空意外伤害或重大自然灾害意外伤害)将按照以下规定给付：
						<br />
						&emsp;&emsp;1.不满10周岁，给付总额不超过RMB20万元；
						<br />
						&emsp;&emsp;2.已满10周岁但未满18周岁，给付总额不超过RMB50万元。
						<br />
						（五）购买前请阅读保险条款，并特别就条款中的有关责任免除和投保人，被保险人义务的内容进行详细了解，确认接受条款的全部内容。
						<br />
						（六）投保人的如实告知义务，以及违反义务的后果：
						<br />
						&emsp;&emsp;1.除另有约定外，投保人应当在保险合同成立时交清保险费。未交清保险费的，保险合同不生效，保险合同生效前发生保险事故的，保险人不承担保险责任。
						<br />
						&emsp;&emsp;2.订立保险合同，保险人就被保险人的有关情况提出询问的，投保人应当如实告知。投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。
						<br />
						&emsp;&emsp;3.投保人故意不履行如实告知义务的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。
						<br />
						&emsp;&emsp;4.投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。
						<br />
						&emsp;&emsp;5.投保人、被保险人或者受益人知道保险事故发生后，应当及时通知保险人。故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。上述约定，不包括因不可抗力而导致的迟延。
						<br />
						（七）您在购买产品过程中，如发现本公司有关人员有违法，违规行为，或认为自身权益受到侵犯，请您保留相关证据向本公司投诉，投诉电话：020-95519或95519或400-180-1616。
						<br />
						（八）24 小时客户服务热线：020-95519 或 40086-95519或400-180-1616。
						<br />
					</div>
					<h2 style="color: red">【四、保单服务】</h2>
					<span class="font_title" style="color: red">（一）产品服务</span>
					<br />
					<div style="margin-left: 20px">
						<span class="red-bold">1.投保：</span>
						您可在投保页面填写个人投保信息并勾选需要的保险计划，核保通过后，您可通过支付宝、银行卡等支付方式将保险费缴纳至国寿财险公司（我公司，即保险人）指定的账户。
						<br />
						<span class="red-bold">2.承保：</span>
						我公司实时接收您的投保信息，并由系统实时完成核保，核保通过、我公司确认保险费到账后，保险合同成立。
						<br />
						<span class="red-bold">3.保单、发票查询：</span>
						本合同采用电子保单形式承保，在线上缴纳保险费，我公司将为您提供电子发票。
						<br />
						您可以通过中国人寿财险APP查看您的保单，或拨打客服电话4008695519进行查询。
						<br />
						根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式。您投保本保险时视为接受以国寿财险提供的电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						<br />
						<span class="red-bold">4.退保/批改：</span>
						<div style="font-weight: bold">
							（一）您可以拨打我公司客户服务电话40086-95519或博维经纪服务热线400-180-1616发起退保/批改保险合同的申请，并提供完整申请资料，我公司审核后，最晚于10个工作日内完成受理。如您办理退保，退保保险费会退还至您名下指定账户。
							<br />
							（二）退保规则
							<br />
							若您在本产品生效之前（起保日期之前）向我公司申请解除保险合同，则该保险合同自我公司接到您的申请后效力即终止，我公司将向您全额退还保险费；
							<br />
							若您在本产品生效之后向我公司申请解除保险合同，则该保险合同自我公司接到您的申请之日的次日零时起效力终止，我公司将在30日内向您退还未满期保费。未满期保费=净保费×（1-m/n），其中，m为已生效天数，n为保险期间的天数，经过日期不足一日的按一日计算。
							<br />
						</div>
						<span class="red-bold">5.报案及理赔：</span>
						<br />
						（1）被保险人出险后，须第一时间致电我公司服务热线95519或40086-95519或博维经纪服务热线400-180-1616进行报案，对保单信息、保险事故进行简要说明，准确描述出险地点，请留下联系电话，保持手机通畅；
						<br />
						（2）报案后，我公司查勘人员将在1个工作日内与您联系，告知理赔所需材料及索赔事宜；
						<br />
						（3）理赔资料准备齐全后，可通过联系查勘人员提交相关材料，申请理赔；
						<br />
						（4）我公司在接收到被保险人或者受益人的赔偿或者给付保险金请求及完整材料后，于5个工作日作出核定，并于作出核定后1个工作日内通知申请人；如遇复杂情形，核定期限将展延至30日；
						<br />
						（5）如果我公司对审核结果无异议，则理赔款将支付至被保险人/受益人指定的账户。
						<br />
						<span style="font-weight: bold">
							如果出现案件不在保险责任范围内或其他无法赔付的情形，我公司将于审核结果反馈后3个工作日内通过查勘人员向您出具拒赔通知书。
						</span>
						<br />
						<span class="red-bold">6、续保：</span>
						<br />
						本产品为一年期
						<span style="font-weight: bold">非保证续保产品</span>
						。保险期间届满前，投保人需要重新向我公司申请投保并交纳保险费，如我公司接受投保申请，并同意承保的，您可获得新的保险合同。
						<br />
						如果保险期间届满时，本保险产品已停止销售，则我公司将不再接受本产品的投保申请，但仍会向您提供投保其他同类保险产品的合理建议。
						<br />
						当中国人寿财险公司（我公司）更换本保险产品适用的保险条款，
						<span style="font-weight: bold">
							如您同意续保，则表示您确认接受变更后的条款，同意投保变更后的保险产品并认可该保险合同的效力。
						</span>
						<br />
						<span class="red-bold">7、客户服务及投诉：</span>
						<br />
						国寿财险公司（我公司）客户服务及投诉电话：如需变更保单信息、咨询保险产品相关事宜、理赔信息，请联系国寿财险客户服务热线：4008695519或博维经纪客户服务热线400-180-1616。
						<br />
					</div>
					<h2 style="color: red">【五、承保公司及偿付能力】</h2>
					&emsp;&emsp;1.本保险产品由中国人寿财产保险股份有限公司承保（即本投保须知所称“国寿财险”），国寿财险总部设立于北京，我公司在全国除港澳台之外的所有省、自治区及直辖市均设有分公司。本产品面向全国大陆地区销售（不含港澳台地区）。
					<br />
					&emsp;&emsp;2.公司偿付能力披露信息：
					<el-link href="http://www.chinalife-p.com.cn/chinalifeproperty/gkxxpl/zxxx/cfnl/index.html" type="primary">
						中国人寿财产保险
					</el-link>
					，我公司偿付能力充足率符合监管要求。
					<br />
					<h2 style="color: red">【六、如实告知、信息安全及相关授权】</h2>
					&emsp;&emsp;1.国寿财险公司（我公司）严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给国寿财险的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。在必要情形下第三方可能接触并使用您的个人信息，包括得到授权的国寿财险员工、以及不时执行与国寿财险的业务、营销活动和数据整理有关工作的其他公司或人员。所有此类人员及公司均需遵守相关保密协议，同时也需遵守国家关于个人信息保护有关法律法规，以确保您的个人信息随时得到保护。除上述用途外，国寿财险不会将您的个人信息用于任何未经您同意的用途。除了国寿财险的业务合作伙伴、法律顾问、外部审计机构或按照法律规定、监管规定或司法裁决之外，国寿财险不会将所接受的任何个人信息泄露、篡改、毁损、出售或者提供给任何第三方。
					<br />
					&emsp;&emsp;2.在投保本产品前您应履行相应的如实告知义务，具体如下：投保人或被保险人应如实填写投保信息，并就保险公司提出的询问据实告知，
					<span style="font-weight: bold">
						否则保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任；订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。
					</span>
					<br />
					&emsp;&emsp;
					<span style="font-weight: bold">
						基于提供保险服务、提高服务质量的需要，您授权：国寿财险及国寿财险的合作机构在承保前或承保后以多种方式核实投保信息的真实性、调查获取被保险人与保险有关的相关信息(包括但不限于健康情况、诊疗情况、既往病史等)
						，如国寿财险经前述核查发现您存在未如实告知情况的，国寿财险将依法解除保险合同；国寿财险向与具有必要合作关系的机构提供您的信息（包括但不限于投保、承保、理赔、医疗等）；国寿财险及国寿财险的合作机构可对您的信息进行合理使用，可通过知悉您信息的机构查询与您有关的全部信息。为确保信息安全，国寿财险及合作机构应采取有效措施，并承担保密义务。
					</span>
					<br />
					<h2 style="color: red">【七、投保声明】</h2>
					<div style="font-weight: bold; margin-left: 20px">
						1.
						本人已完整阅读并了解以上投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请
						与给付等），本人已充分理解并接受上述内容，同意以此作为订立保险合同的依据；
						<br />
						2. 当被保险人非本人时，本人确认已告知被保险人或其监护人本产品的相关内容，并 已征得其同意投保本产品；
						<br />
						3.
						投保单中所填写的内容均属实，如有隐瞒或不实告知，保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同，对于保险合同解除前发生的任何事故，保险公司可不承担任何责任。
						<br />
					</div>
					<h2 style="color: red">【八、其他】</h2>
					&emsp;
					<span class="font_title">本须知未尽事宜，以本产品适用的条款、保险合同约定为准。</span>
				</div>

				<!--        <div>-->
				<!--          <h3 style="display: flex; justify-content: center;">投保须知及重要事项告知</h3>-->
				<!--          <p style="text-align: left;text-indent: 2em;font-weight:bold">本产品由中国人寿财产保险股份有限公司（以下简称“国寿财险”）承保</p>-->
				<!--          <p style="text-align: left;text-indent: 2em;">中国人寿财产保险股份有限公司成立于2006年12月，总部位于北京，经营区域覆盖全国，已在全国设立了36家分公司、1家航运保险运营中心、331家中心支公司、1852家支公司、348家营销服务部，省级、地市和县区的行政区划覆盖率分别达到-->
				<!--            100%、98%、77%。截止2020年第3季度，国寿财险综合偿付能力充足率202.96%，满足监管要求。</p>-->
				<!--          <div>-->

				<!--            <div style="font-weight:bold">一、重要告知</div>-->
				<!--            <p>订立本合同时，本公司应向投保人说明本合同的内容。对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。</p>-->
				<!--            <p style="font-weight:bold">本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>-->
				<!--            <p class="red-bold">如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。</p>-->
				<!--            <p class="red-bold">如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。</p>-->
				<!--            <p class="red-bold">如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。</p>-->
				<!--            <p>本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。</p>-->

				<!--            <div style="font-weight:bold">二、产品信息</div>-->
				<!--            <table border="1" cellpadding="0" ellspacing="0" style="margin:15px" width="100%">-->
				<!--              <tr>-->
				<!--                <th style="width: 50%;">备案名称</th>-->
				<!--                <th style="width: 50%;">备案编号</th>-->
				<!--              </tr>-->
				<!--              <tr>-->
				<!--                <td style="text-align: center">人身意外伤害保险（2022版）（互联网专属）条款</td>-->
				<!--                <td style="text-align: center">C00010832312022042867271</td>-->
				<!--              </tr>-->
				<!--            </table>-->
				<!--            <div style="font-weight:bold">三、产品介绍</div>-->
				<!--            <p style="font-weight:bold">3.1 投保人/被保险人</p>-->
				<!--            <p>年满在十六周岁（含）至六十五周岁（含）、身体健康、能正常工作或正常生活的自然人，可作为本保险合同的被保险人。具有完全民事行为能力的被保险人本人、对被保险人有保险利益的其他人可作为投保人。</p>-->
				<!--            <p style="font-weight:bold">3.2 保险期限</p>-->
				<!--            <p>自生效日起，保险期限为一年，或者按月投保。</p>-->

				<!--            <p style="font-weight:bold">3.3 特别约定</p>-->

				<!--            <p style="line-height:32px">-->
				<!--              3.3.1、<span class="red-bold">出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打本保单第11条特别约定中的电话号码，取得报案号后才是报案成功(否则报案失败)。</span>-->
				<!--              如果被保险人委托第三人/第三方报案，后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第11条特别约定扣除免赔，那么被保险人须自行承担相关损失。<br/>-->
				<!--              3.3.2、本保单承保的职业类别按风险从低到高，可分为4-6类，6类风险最高。<br/>-->
				<!--              3.3.3、<span class="red-bold">本保单拒绝承保职业（即保险人不承担任何赔偿责任）：农牧渔业、海上作业、地质矿产业、化工/军工制造业、影视及演艺业、建筑物外墙维护及玻璃幕墙安装维护人员、特别约定桥梁/隧道工程人员、凿岩工、防水工、水运工程施工、水坝工程人员、潜水工作人员、体育运动、各种杂技人员、驯兽师、涉及火药/炸药/爆破的相关工作、易燃易爆/危险化学品运输司机及随车工、特种兵/军人/武警/公安/警察/消防等治安人员、高压电工作人员、快递/外卖配送等。</span><br/>-->
				<!--              3.3.4、<span class="red-bold">若从事高处作业，必须投保5-6类职业，否则发生保险事故，保险人不承担赔偿责任。高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔50%。</span><br/>-->
				<!--              3.3.5、<span class="red-bold">投保4类职业的人员，若从事高处作业发生保险事故，则保险人不承担赔偿责任；若从事其他5-6类职业工作（不涉及高处作业）发生保险事故，则保险人对按保单约定的应承担的保险责任，免赔50%。</span><br/>-->
				<!--              3.3.6、以下情形，保险人不得以保单上列明职业有误而拒赔或者减少承担赔偿责任：保单上列明职业类别对应的保费，不低于被保险人实际职业类别对应的保费。<br/>-->
				<!--              3.3.7、本保单不支持批减被保险人、变更保额。保险期限为3个月以内（含）的保单不支持替换被保险人，6个月和1年的保单支持替换被保险人（已出险人员除外）。<br/>-->
				<!--              3.3.8、保险人赔付标准如下：<br/>-->
				<!--              ① 对于身故：按限额100%赔付。<br/>-->
				<!--              ② 对于伤残：经司法鉴定后，伤残按一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、10级10%的比例赔付。<br/>-->
				<!--              ③ 对于医疗费用：保险人按投保人营业执照注册地（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。<span class="red-bold">保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。</span><br/>-->
				<!--              ④ <span class="red-bold">对于住院津贴：在保险期间内每次事故赔偿不超过90天，累计不超过180天，无免赔。</span>身故/伤残保额10-30万的方案，每人每天100元；40-70万的方案，每人每天150元；80-100万的方案，每人每天200元。<br/>-->
				<!--              3.3.9、<span class="red-bold">本保单指定就诊医院为大陆境内二级及以上公立医院，或保险人认可的其他医疗机构（如被保险人所在乡镇的公立医疗机构），但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。</span>对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。<br/>-->
				<!--              3.3.10、<span class="red-bold">保险人不赔偿如下责任：</span><br/>-->
				<!--              ① <span class="red-bold">拒绝承保职业。</span><br/>-->
				<!--              ② <span class="red-bold">保险条款责任免除部分。</span><br/>-->
				<!--              ③ <span class="red-bold">精神损害、猝死、疾病所致治疗和身故。</span><br/>-->
				<!--              3.3.11、<span class="red-bold">被保险人必须在保险事故发生后24小时内拨打电话400-180-1616进行报案（如属于死亡或重伤事故，须在12小时内报案），因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任；如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%；</span>如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权追究被保险人及相关人员的刑事责任。<br/>-->
				<!--              3.3.12、兹经双方同意，本保单累计赔偿限额为1000万。若伤亡事故造成的实际损失超1000万，对于超过部分，保险人不承担赔偿责任。<br/>-->
				<!--              3.3.13、本保单承保年龄段：十六周岁（含）至六十五周岁（含）。-->
				<!--            </p>-->

				<!--            <p style="font-weight:bold">3.4 保单形式</p>-->
				<!--            <p>本产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。</p>-->
				<!--            <p style="font-weight:bold">3.5 发票形式</p>-->
				<!--            <p>本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。</p>-->

				<!--            <div style="font-weight:bold">四、投保声明</div>-->
				<!--            <p style="font-weight:bold">4.1 本投保人已完整阅读并了解以上投保须知及投保险种的保险条款，<span class="red-bold">尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），</span>本人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。</p>-->
				<!--            <p style="font-weight:bold">4.2 投保时，本投保人已就该产品的保障内容及保险金额等向被保险人进行了明确说明，并征得其同意。</p>-->

				<!--            <div style="font-weight:bold">五、理赔</div>-->
				<!--            <p><span class="red-bold">出险后尽快拨打客服电话400-180-1616进行报案，</span>根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。</p>-->
				<!--            <div style="font-weight:bold">六、其他信息</div>-->
				<!--            <p>6.1 我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。</p>-->
				<!--            <p>6.2 您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95519。</p>-->
				<!--          </div>-->
				<!--        </div>-->
			</el-card>
			<!--            <el-card header="保险条款">-->
			<!--                <el-link type="primary" href="fgkclause1.html" target="_blank">中国人寿财产保险股份有限公司意外伤害保险（互联网专属）附加意外伤害医疗费用保险条款（注册编号：C00010832322021122729893）</el-link>-->
			<!--                <br>-->
			<!--                <el-link style="margin: 3px 0" type="primary" href="fgkclause2.html" target="_blank">中国人寿财产保险股份有限公司意外伤害保险（互联网专属）附加意外伤害生活津贴保险条款（注册编号：C00010832322021122729883）-->
			<!--                </el-link>-->
			<!--                <br>-->
			<!--                <el-link type="primary" href="fgkclause3.html" target="_blank">中国人寿财产保险股份有限公司人身意外伤害保险（互联网专属）条款（注册编号：C00010832312021122437293）</el-link>-->
			<!--            </el-card>-->
		</div>
		<!-- <div v-if="productId==29 || productId==30"> -->
		<div v-else-if="insureType == 9">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em; font-weight: bold">
						本产品由亚太财产保险有限公司（以下简称“亚太财险”）承保
					</p>
					<p style="text-align: left; text-indent: 2em">
						亚太财产保险有限公司成立于1943年，全国拥有280余家分支机构。注册资本金40亿元人民币，偿付能力充足（截止2021年第一季度末，偿付能力充足率为306.82%），2020年第四季度风险综合评级结果为A类，满足监管要求。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>订立本合同时，本公司应向投保人说明本合同的内容。</p>
						<p>
							对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。
						</p>
						<p style="font-weight: bold">本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p style="font-weight: bold">
							如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。
						</p>
						<p style="font-weight: bold">
							如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。
						</p>
						<p style="font-weight: bold">
							如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。
						</p>
						<p>
							本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。
						</p>

						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">备案编号</th>
							</tr>
							<tr>
								<td style="text-align: center">团体意外伤害保险条款</td>
								<td style="text-align: center">C00003832312019080106632</td>
							</tr>
							<tr>
								<td style="text-align: center">附加意外伤害医疗保险条款</td>
								<td style="text-align: center">C00003832522019110405042</td>
							</tr>
							<tr>
								<td style="text-align: center">附加意外伤害住院津贴保险条款</td>
								<td style="text-align: center">C00003832722019111100712</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>
							年满十六周岁至六十周岁、身体健康、能正常工作或正常劳动的自然人，可作为本保险合同的被保险人；对被保险人有保险利益的机关、企业、事业单位和社会团体均可作为投保人。
						</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限为一年，或者按月投保。</p>
						<p style="font-weight: bold">3.3 保单形式</p>
						<p>
							本产品提供电子保单，根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.4 发票形式</p>
						<p>
							本产品提供增值税普通发票（电子票）。电子发票是以电子方式存储的收付款凭证，其法律效力、基本用途、基本使用规定等与税务机关监制的纸质发票相同。
						</p>
						<div style="font-weight: bold">四、投保声明</div>
						<p style="font-weight: bold">
							4.1
							本投保人已完整阅读并了解以上投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本人已充分理解并接受上述内容，同意以此作为订立保险合同的依据。
						</p>
						<p style="font-weight: bold">
							4.2 投保时，本投保人已就该产品的保障内容及保险金额等向被保险人进行了明确说明，并征得其同意。
						</p>

						<div style="font-weight: bold">五、理赔</div>
						<p>
							出险后尽快拨打客服电话95506进行报案，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">六、其他信息</div>
						<p>
							6.1
							我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。
						</p>
						<p>
							6.2
							您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95506。
						</p>
					</div>
				</div>
			</el-card>
		</div>
		<!-- <div v-if="productId==38 || productId==39"> -->
		<div v-else-if="insureType == 11">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em; font-weight: bold">
						本产品由鼎和财产保险股份有限公司（以下简称“鼎和财险”）承保，由鼎和财险委托博维保险经纪有限公司（以下简称“博维”）进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						鼎和财产保险股份有限公司成立于2008年，总部位于深圳，旗下15家省级机构，162家三四级机构部遍布全国。注册资本金30.18亿元。截止2020年第4季度，公司综合偿付能力充足率270.27%，2020年第四季度风险综合评级结果为A类，满足监管要求。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>订立本合同时，本公司应向投保人说明本合同的内容。</p>
						<p>
							对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。
						</p>
						<p style="font-weight: bold">本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p style="font-weight: bold">
							如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。
						</p>
						<p style="font-weight: bold">
							如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。
						</p>
						<p style="font-weight: bold">
							如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。
						</p>
						<p>
							本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。
						</p>

						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">备案编号</th>
							</tr>
							<tr>
								<td style="text-align: center">鼎和财产保险股份有限公司个人人身意外伤害保险（互联网专属）条款</td>
								<td style="text-align: center">C0001292512021122224803</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>
							年满十六周岁至六十五周岁、身体健康、能正常工作或正常劳动的自然人，可作为本保险合同的被保险人；对被保险人有保险利益的机关、企业、事业单位和社会团体均可作为投保人。
						</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限为一年。</p>
						<p style="font-weight: bold">3.3 特别约定</p>
						<p>1、被保险人雇员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。</p>
						<p>2、猝死为可选项，猝死保额为身故保额的50%。（须单独加费扩展本保障）。</p>
						<p>3、在社保报销范围内的医疗费用每人每次免赔人民币100.00元后按照100.00%比例赔付。</p>
						<p>4、意外伤害住院补贴为100.00元/人/天，免赔天数0天，每次事故最多赔偿不超90天，累计赔付以180天为限。</p>
						<p>
							5、被保险人因遭受意外伤害，伤残赔付标准按保险合同所附《人身保险伤残评定标准》（行业标准）对伤残项目进行评定，伤残等级十至一级给付比例：十级10%，九级20%，八级30%，七级40%，六级50%，五级60%，四级70%，三级80%，二级90%，一级100%。
						</p>
						<p>
							6、被保险人必须按实际从事行业及职业投保，如在出险时被保险人实际从事的职业分类等级高于保单列明承保的职业分类等级，保险公司不承担保险责任。
						</p>
						<p>
							7、被保险人从事特种作业时，未取得对应的特种作业证书进行特种作业操作引起的意外事故，保险公司不承担保险责任。特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。
						</p>
						<p>8、被保险人年龄为16-65周岁，16周岁（含）至18周岁（不含）未成年人意外伤害身故保险责任最高保额 50万元。</p>
						<p>
							9、本保单指定医院范围为：中华人民共和国境内（不包括香港、澳门、台湾地区）二级以上（含二级）公立医院或保险人认可的其他医疗机构，但不包括以下地区的医疗机构：北京市平谷区、密云县、怀柔区所有医疗机构，辽宁省铁岭市所有医疗机构，河北省三河市、青龙县、廊坊市所有医疗机构，山东省禹城市所有医疗机构，河南省信阳市所有医疗机构，四川省宜宾市的所有医疗机构、四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、天津滨海区、静海区所有医疗机构，即上述地区医疗机构的发票保险人不予理赔。事发后因伤势情况危急需第一时间急救抢救的可以放宽至一级公立医院。经抢救伤势情况稳定的需及时转入公立二级以上医院做后续治疗。
						</p>
						<p>
							10、被保险人从事高处作业时因未系绑安全带导致的保险事故属除外责任。高处作业以《高处作业分级标准》（GB3608-2008）中的定义为准。
						</p>
						<p>11、包含以下关键字的单位不适用此方案：“拆、疏浚、危险品、石油、电梯、铁塔”。</p>
						<p>12、投保人、被保险人或者保险金受益人知道意外伤害保险事故发生后，应当在48小时内及时通知保险人。</p>
						<p>
							13、保险责任开始后，投保人要求解除保险合同的，保险人按日比例计算保险费，扣除未满期保费对应的手续费，退还未满期保险费与扣除手续费的差额部分。
						</p>
						<p>14、发生保单项下的死亡保险事故时，对于死因不明的案件，索赔方需要提供尸检报告给保险公司。</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							本产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
						</p>

						<div style="font-weight: bold">四、理赔</div>
						<p>
							出险后尽快拨打客服电话95393进行报案，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							5.1
							我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。
						</p>
						<p>
							5.2
							您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95393。
						</p>
					</div>
				</div>
			</el-card>
		</div>
		<div v-else-if="insureType == 12">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-indent: 2em">
						本产品由泰康在线财产保险股份有限公司（以下简称“泰康在线”）承保，由泰康在线委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401。
					</p>
					<p style="text-indent: 2em">
						泰康在线是世界500强泰康保险集团的全资子公司，成立于2015年，注册资本为人民币40亿元。截至2020年末，公司综合偿付能力充足率209%。泰康在线专注于互联网保险业务的创新开拓，致力于通过“保险+科技”、“保险+服务”的“双生态”战略，，实现保险与科技的深度融合保险金融属性和服务属性的深度结合，打造国际领先的科技型、服务型互联网保险公司。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p style="font-weight: bold">
							1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。
						</p>
						<p style="font-weight: bold">
							1.2
							<span style="color: red">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p style="font-weight: bold">1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p style="font-weight: bold">
							1.4
							<span style="color: red">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p style="font-weight: bold">
							1.5
							<span style="color: red">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p style="font-weight: bold">
							1.6
							<span style="color: red">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							1.7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">泰康在线财产保险股份有限公司安全生产责任保险条款</td>
								<td style="text-align: center">(泰康在线)(备-责任保险)【2021】(主) 005号</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>
							凡符合中华人民共和国法律（不包括港、澳、台地区法律）规定的具有完全民事行为能力的自然人和合法经营的单位均可作为本保险合同的投保人。
						</p>
						<p>
							凡在中华人民共和国境内（不包括港、澳、台地区）依法成立，具有合法生产、经营资格的生产经营单位，均可作为本保险合同的被保险人。
						</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月、6个月或12个月。</p>
						<p style="font-weight: bold">3.3 特别约定</p>
						<div style="white-space: pre-line">
							1.
							<span class="red-bold">
								本产品仅限在中国大陆注册的合法机构购买，实际经营地址在以下地区的单位本产品不予承保：青海省、新疆维吾尔自治区、西藏自治区、四川省甘孜藏族自治州，阿坝藏族羌族自治州、凉山彝族自治州、天津市、山东省临沂市。
							</span>
							2.
							<span class="red-bold">
								本产品可加人，按天收费，不可减人。保险期限1-3个月的保单不可替换，保险期限3个月以上的保单可替换，4类职业人员只能替换为新的4类职业人员，5-6类职业人员只能替换为新5-6类职业人员。
							</span>
							3.被保险人雇员的年龄限16-65周岁（不超65），本方案每人限投1份，超过部分无效。
							在保险期间内，被保险人在保险单载明的场所和区域范围内从事生产、储存、经营等活动过程中，因发生生产安全事故（指被保险人在生产经营活动过程中发生的人员伤亡事故，不包括自然灾害）导致其雇员或第三者死亡或伤残，依照中华人民共和国法律（不包括港、澳、台地区法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同的约定负责赔偿。
							4.累计事故责任限额：500万（10人及以下）/1000万（大于10人）
							每次事故责任限额：200万（10人及以下）/500万（大于10人） 每次事故及累计事故法律费用责任限额：10万
							每次事故及累计事故救援费用责任限额：10万 累计事故第三者人员伤亡责任限额：30万
							每次事故第三者人员伤亡责任限额：10万 5.雇员是指与
							<span class="red-bold">
								被保险人存在劳动关系（包括事实劳动关系）的各种用工形式、各种用工期限的劳动者及个体工商户的经营者本人，个体工商户经营者的直系亲属在生产经营活动中视为雇员。出险时保险人有权要求被保险人提供前述关系的证明，包括但不限于劳动合同、劳务合同、工资发放流水或打卡记录等材料。
							</span>
							<template v-if="isAnZeGang(productId)">
								6.本保单拒绝承保职业：
								<span class="red-bold">
									地下（露天打桩和挖地基除外）/水下/水上作业、渔业、船舶相关工作、邮政/快递/航空/水上运输业、地质矿产/石油/天然气/采石业、凿岩工、森林砍伐/防火人员、驯兽师、动物饲养、塔吊安装拆除和维修、窑炉/烟囱新建和拆除、高炉炉前/运转工人、钢缆生产加工、钢丝绳生产加工、石棉制造、水泥制造、化工/军工/火工相关工作、水电工（地下）、涉及危险品/有毒物品/防化器/烟花爆竹/火药/炸药/枪炮/爆破的相关工作、保镖、特种兵/军人/武警/公安/警察/消防等治安人员、警校/军校、体育运动、记者、演艺/娱乐业、各式垃圾处理场的场主和操作人员（包括但不限于垃圾堆、焚烧厂和有毒废物处理厂的承包商）、家具行业、楼宇拆除、桥隧工人。
								</span>
							</template>
							<template v-else>
								6.本保单拒绝承保职业：
								<span class="red-bold">
									地下（露天打桩和挖地基除外）/水下/水上作业、渔业、船舶相关工作、邮政/快递/航空/水上运输业、地质矿产/石油/天然气/采石业、凿岩工、森林砍伐/防火人员、驯兽师、动物饲养、塔吊安装拆除和维修、窑炉/烟囱新建和拆除、高炉炉前/运转工人、钢缆生产加工、钢丝绳生产加工、石棉制造、水泥制造、化工/军工/火工相关工作、水电工（地下）、涉及危险品/有毒物品/防化器/烟花爆竹/火药/炸药/枪炮/爆破的相关工作、保镖、特种兵/军人/武警/公安/警察/消防等治安人员、警校/军校、体育运动、记者、演艺/娱乐业、各式垃圾处理场的场主和操作人员（包括但不限于垃圾堆、焚烧厂和有毒废物处理厂的承包商）、家具行业、楼宇拆除、桥隧工人、钢结构安装工/钢骨结构工人/钢架架设工人。
								</span>
							</template>
							7.被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保职业）危险程度高于投保职业或营业范围的，则保险人对按保单约定的应承担的保险责任，免赔30%。从事高处作业的，必须投保5-6类职业。高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准，
							<span class="red-bold">
								高处作业定义：凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。
							</span>
							如属于拒绝承保职业，保险人不承担任何赔偿责任。
							8.以下情形，保险人不得以投保职业有误而拒赔或者减少承担赔偿责任：投保职业对应的保费，大于或等于被保险人实际职业对应的保费。
							9.
							<span class="red-bold">以下四种情况均不属于保险责任。</span>
							（1）
							<span class="red-bold">
								被保险人或其代表、雇用人员使用机动车辆造成第三者人身伤亡或财产损失的赔偿责任；
							</span>
							（2）
							<span class="red-bold">各种职业病、疾病、中暑、猝死等非意外事故；</span>
							（3）
							<span class="red-bold">被保险人及其雇员、第三者的财产损失；</span>
							（4）
							<span class="red-bold">雇员在上下班途中，受到的交通及意外事故伤害；</span>
							10.
							发生本保险责任范围内的生产安全事故，造成被保险人雇员及第三者人身伤亡的，对被保险人依法应承担的经济赔偿责任，保险人依照以下约定负责赔偿：
							（1）
							<span class="red-bold">
								死亡：被保险人雇员发生死亡时，保险人按工伤赔偿标准核算身故赔偿金；第三者发生死亡时按《最高人民法院关于审理人身损害赔偿案件适用法律若干问题的解释》在保险合同约定的每人限额内核算身故赔偿金。
							</span>
							<template v-if="isAnZeStandard(productId)">
								（2）伤残：如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=雇员每人伤残赔偿限额*伤残等级对应的赔付比例；如被保险人发生保险事故导致第三者伤残，每人可从保险人获得的伤残赔偿金=第三者每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照
								<span class="red-bold">
									《人体损伤致残程度分级》（2017年1月1日起施行版本）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例20%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。
								</span>
							</template>
							<template v-else>
								（2）伤残：如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=雇员每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的
								<span class="red-bold">
									《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例20%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。
								</span>
								<br />
							</template>
							（3）被保险人不得就其单个雇员因同一保险事故同时申请伤残赔偿金和死亡赔偿金。 11.就每次事故
							<span class="red-bold">
								被保险人对每名雇员承担的治疗费用赔偿责任，保险人按照《工伤保险条例》及相关司法解释规定的标准为准据实计算，每次事故免赔200元后，社保用药100%赔付；对第三者承担的治疗费用赔偿责任，保险人按照《最高人民法院管理审理人身损害赔偿案件适用法律若干问题的解释》规定的标准，按每次事故200元免赔额，社保用药100%赔付后，
							</span>
							在保险合同约定的每次事故每人医疗费用责任限额内进行赔偿。
							12.误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。
							<span class="red-bold">
								按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅需门诊治疗的，按本保单约定无误工费赔付。本保单误工费赔付仅适用被保险人雇员，第三者无误工费赔付。
							</span>
							13.
							<span class="red-bold">
								本保单指定就诊医院为大陆境内二级及以上公立医院。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，保险人对按保单约定的应承担的保险责任，免赔20%。
							</span>
							14.
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%。
							</span>
							如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							15.
							<span class="red-bold">
								本保单累计死亡人数2人（含）及以上的，须提供安监证明，否则保险人有权不承担赔偿责任。
							</span>
							<template v-if="isAnZeGang(productId)">
								16.
								<span class="red-bold">从事高处作业必须取得有效高处作业证且佩戴安全带</span>
								，否则发生
								<span class="red-bold">身故或伤残事故，保险人对按保单约定的应承担的保险责任免赔35%。</span>
								保险人对其他特种作业人员（除高处作业）无要求持有特种作业操作证。高处作业证必须由应急管理部门颁发。
							</template>
							<template v-else>
								16.
								<span class="red-bold">从事高处作业必须取得有效高处作业证且佩戴安全带</span>
								，否则发生
								<span class="red-bold">身故或伤残事故，保险人对按保单约定的应承担的保险责任免赔25%。</span>
								保险人对其他特种作业人员（除高处作业）无要求持有特种作业操作证。高处作业证必须由应急管理部门颁发。
							</template>
							17.如不幸发生事故，您可以通过以下两种途径进行报案： （1）拨打泰康在线官方理赔客服电话95522-3；
							（2）也可通过微信小程序“线上快赔”上传出险照片报案，需要报案服务咨询或咨询保险相关事宜，可拨打经纪公司服务热线：400-180-1616，获取工作人员的帮助，取得报案号后才是报案成功（否则报案失败）。
						</div>
						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
						</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							5.2
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或泰康在线服务及投诉热线：95522，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="isMeiYaB(insureType, productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p style="line-height: 28px">
							1、本保险为互联网专属产品，由美亚财产保险有限公司（以下简称“保险公司”）承保，面向全国（不含港澳台）进行销售，本保险支持在线投保、核保、保单查询和报案等服务，您可以通过“美亚保险客户服务”微信小程序线上办理退保、批改和理赔等业务。目前保险公司在上海、北京、广东省（含深圳市）、江苏省和浙江省设有分支机构。
							<span class="red-bold">
								保险公司无分支机构的地区，可能无法向您提供及时的面对面线下服务，保险公司将通过电话及互联网通道在线为您提供保单服务。如有任何疑问，可拨打保险公司客户服务热线400-820-8858。
							</span>
							<br />
							2、所有的保险责任及条款均以与保险公司正式订立保险合同的规定为准。
							<br />
							3、被保险人身故保险金受益人为被保险人的继承人。
							<br />
							4、本保险最早的生效时间为T+1零时，最晚为T+30零时（T是指投保成功日）。
							<br />
							5、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							6、
							<span class="red-bold">
								本保险约定的团体成员资格须同时满足以下要求：
								<br />
								（1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
								<br />
								本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇用的情形。约定的团体成员投保年龄限制：18-65周岁。
								<br />
								（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。
								<br />
								如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
								<br />
							</span>
							7、保险合同成立时投保人数不低于3人。
							<span class="red-bold">如被保险人含职业类别五或职业类别六，则被保险人人数应不低于5人。</span>
							单张保单最高投保人数为1000人。
							<br />
							8、
							<span class="red-bold">
								保险公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总赔偿限额为限。如在任一意外事故中，前述总赔偿限额低于按每一被保险人的保险金额给付的总赔偿金额，则保险公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							</span>
							<br />
							9、
							<span class="red-bold">每一意外事故总赔偿限额说明</span>
							：
							<br />
							每一意外事故总赔偿限额为以下两者较高者：
							<br />
							(1) 保险合同生效时，保险单所载单个被保险人在意外身故及伤残保障项下所适用的最高保险金额的10倍；
							<br />
							(1) 人民币500万元。
							<br />
							10、本保险计划项下计划一至计划八的被保险人职业类别限制为1类至6类，计划九和计划十的被保险人职业类别限制为1类至4类。
							<span class="red-bold">
								具体职业请以职业分类表为准。保险公司不接受职业分类表所列1类至6类职业以外的其他职业的人员投保保险计划的申请。
							</span>
							<br />
							11、投保人须按照任何约定团体成员的实际职业类别申请参保相应保险计划。如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准选择相应类别。
							<span class="red-bold">
								如任何约定团体成员的实际职业类别为本保险拒保职业类别或高于所申请参保保险计划对应的职业类别，则该团体成员不属于本保险所承保的参保人员，保险公司有权取消该团体成员的申报并在保险合同项下对该团体成员不承担任何保险责任。
							</span>
							<br />
							12、如被保险人在保险有效期内发生职业变化，投保人或被保险人应于十个工作日内向保险公司申请保全变更。如被保险人变更后的职业或工种依照职业分类表其危险程度降低时，则保险公司自被保险人变更职业或工种之日起，按日比例退还变更前后保险费的差额；如被保险人变更后的职业或工种依照职业分类表其危险增加时，投保人应自被保险人变更职业或工种之日起，按日比例补缴变更前后保险费的差额；如被保险人变更后的职业或工种为职业分类表的拒保职业，则自被保险人变更职业或工种之日起，保险公司对该被保险人所承担的保险责任终止，并按约定向投保人退还该被保险人对应的未满期保险费。
							<br />
							<span class="red-bold">
								若被保险人的职业或工种发生变化，依照职业分类表其危险程度增加而未依前项约定向保险公司申请变更而发生保险事故的，保险公司有权取消该被保险人的申报并在保险合同项下对该团体成员不承担任何保险责任。
							</span>
							<br />
							13、每位团体成员于保险公司投保的团体意外伤害保险仅限一份，多投无效，不同计划重叠购买的无效。若任一团体成员于保险公司投保多份团体意外伤害保险或购买多份计划，则保险公司仅以首次成功投保的计划为准，并退还其它保险计划项下已收取的保险费。
							<br />
							14、同一职业类别的被保险人必须选择相同的保险计划
							<br />
							15、本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。
							<span class="red-bold">若前述被保险人从事高处作业时未系绑安全带，则保险公司不承担任何保险责任。</span>
							<br />
							16、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。
							<span class="red-bold">
								若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，保险公司不承担任何保险责任。
							</span>
							特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。
							<br />
							17、
							<span class="red-bold">对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。</span>
							<br />
							18、
							<span class="red-bold">意外医药补偿保额说明：</span>
							<br />
							（1）若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							<br />
							（2）若任何被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额的105%为限，但须扣除该被保险人任何已取得的医药费用补偿。
							<br />
							19、
							<span class="red-bold">
								本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							</span>
							<br />
							20、
							<span class="red-bold">
								本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							</span>
							<br />
							21、
							<span class="red-bold">
								本保险所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。
							</span>
							<br />
							22、本保险为团体保险，投保人不得以任何方式销售给第三方（第三方包括但不限于被保险人本人）。
							<br />
							23、
							<span class="red-bold">
								若保险、公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							</span>
							<br />
							24、
							<span style="font-weight: bold">
								本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							25、被保险人的投保年龄以申请时被保险人的周岁年龄为准。
							<br />
							26、新增或减少被保险人的申报：保险合同有效期间，若有团体成员的新增或减少，投保人须将该新增及减少的成员资料申报至保险公司。对于新增团体成员，经保险公司确认同意承保后，该新增成员自投保人申报次日零时起获得被保资格。
							<br />
							27、保险凭证：保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							28、
							<span class="red-bold">
								投保人未能披露与本保险相关之重大事实（包括但不限于是否符合本投保申请上述所有投保前提条件，下同）可能导致保险公司不承担保险责任。
							</span>
							重大事实系指可能影响保险公司风险评估或接受投保申请与否之事实。如果投保人不能确定某些事实是否属于应披露之重大事实，请予以披露。
							<br />
							29、本保险
							<span class="red-bold">仅提供电子版本的保险单</span>
							，根据预留的电子邮件地址发送电子版本的保险单，投保人可登录
							<a
								href="https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp"
								style="color: DodgerBlue"
								target="_blank">
								美亚保险信息 自主查询系统
							</a>
							进行保单验真。
							<br />
							30、本保险适用条款：《美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）》《美亚附加不承保特定医院条款（2021年第二版）》《美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）》《美亚附加经济制裁责任免除条款》《美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）》《美亚附加特种作业限制条款（2021年第二版）（互联网专属）》《美亚团体意外伤害保险（2021年第一版）（互联网专属）》《美亚附加意外医药补偿团体医疗保险（2021年第五版）（互联网专属）》《美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）》
							<br />
							31、
							<span class="red-bold">重要提示：</span>
							<br />
							(1)请仔细阅读本保险所有投保前提条件，确认符合所列投保前提条件方可进行投保。
							<br />
							(2)为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，尤其是免除保险人责任的规定。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							(3)本投保申请、保险条款、保险单、批单或批注（如有）及其它约定书均为保险合同的构成部分。
							<br />
							(4)为了维护您的利益，投保人/被保险人需详细并如实填写投保申请上所列资料。
							<br />
							(5)美亚财产保险有限公司综合偿付能力充足率达到监管要求，且风险综合评级提示操作、战略、声誉和流动风险较小，具体偿付能力指标和风险综合评级结果请查询公司官方网站
							<a href="http://www.aig.com.cn" style="color: DodgerBlue" target="_blank">美亚财产保险有限公司官网</a>
							<br />
							(6)保险合同项下应付保险费含适用的增值税。
							<br />
						</p>
						<p style="font-weight: bold">二、重要提示</p>
						<p>1、投保人须获得被保险人的同意，方可为其投保本保险</p>
						<p>2、本保险为团体保险，投保人不得以任何方式销售给第三方(第三方包括但不限于被保险人本人)</p>
						<p>3、保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。</p>
						<p class="red-bold">
							4、任何已提出投保申请的人员或在保险期间内可能提出参保申请的人员，均须符合本保险约定的被保险人资格。如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
						</p>
						<p class="red-bold">
							5、
							投保人须按照任何约定团体成员的实际职业类别电请参保相应保险计划。如被保险人工作涉及多个职业类别则应以职业类别最高的职业为准选择相应类别。如任何约定团体成员的实际职业类别为本保险拒保职业类别或高于所申请参保保险计划对应的职业类别，则该团体成员不属于本保险所承保的参保人员，保险公司有权取消该团体成员的申报并在保险合同项下对该团体成员不承担任何保险责任。
						</p>
						<p>
							6、
							如被保险人在保险有效期内发生职业变化，投保人或被保险人应于十个工作日内向保险公司申请保全变更。如被保险人变更后的职业或工种依照职业分类表其危险程度降低时，则保险公司自被保险人变更职业或工种之日起按日比例退还变更前后保险费的差额:如被保险人变更后的职业或工种依照职业分类表其危险增加时，投保人应自被保险人变更职业或工种之日起，按日比例补缴变更前后保险费的差额;如被保险人变更后的职业或工种为职业分类表的拒保职业，则自被保险人变更职业或工种之日起，保险公司对该被保险人所承担的保险责任终止，并按约定向投保人退还该被保险人对应的未满期保险费。
							<span class="red-bold">
								若被保险人的职业或工种发生变化，依照职业分类表其危险程度增加而未依前项约定向保险公司申请变更而发生保险事故的，保险公司有权取消该被保险人的申报并在保险合同项下对该团体成员不承担任何保险责任。
							</span>
						</p>
						<p class="red-bold">7、被保险人的身故保险金受益人为被保险人的继承人。</p>
						<p class="red-bold">
							8、本公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总暗偿限额为限。如在任一意外事故中，前述总赔偿限额低干按每一被保险人的保险金额给付的总赔偿金额，则本公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
						</p>
						<p>
							9、
							若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则本公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							若任何被保险人
							<span class="red-bold">拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿</span>
							，则本公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应保险金额的百分之一百零五(105%)为限，但须扣除该被保险人任何已取得的医药费用补偿。
						</p>
						<p class="red-bold">
							10、
							本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》(中华人民共和国国家标准GB/T3608-2008)中规定的为准，如属于在距队落高度基准面5米及以上有可能落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。若前述被保险人从事高处作业时未系绑安全带，则本公司不承担任何保险责任。
						</p>
						<p class="red-bold">
							11、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。特种作业证书以国家(特种作业人员安全技术培训考核管理规定》规定的为准。
						</p>
						<p class="red-bold">
							12、对于职业类别为1类至4类的被保险人，本保险不承保其从事5米及以上的高处作业时发生的保险事故。
						</p>
						<p class="red-bold">
							13、本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
						</p>
						<p class="red-bold">
							14、本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上(含二级)公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
						</p>
						<p class="red-bold">
							15、
							本保险所称的医院不包括下列医院:北京市(平谷区、密云区、怀柔区)、天津市(滨海新区、静海区)、福建省南平市、安徽省宿州市、河北省(三河市、廊坊市、青龙县、兴隆县)的所有医院;福建省宁德市古田县医院;河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院;河南省(开封市、信阳市、新密市、内黄县、通许县)所有医院，河南省新乡市中医院、新乡市第二人民医院
							焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业(集团)有限责任公司总医院;山东省(莱州市栖霹市、威海市、金乡县、禹城)所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院;四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院
							泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院;甘肃省民勤县人民医院、宁县人民医院;山西省运城市盐湖区人民医院;黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院
							牡丹江市第二人民医院
							哈尔滨市第一医院、五大连池市第一人民医院;吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院;辽宁省铁岭市所有医院，辽宁省中医医院:海南省第三人民医院。
						</p>
						<p class="red-bold">
							16、本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
						</p>
						<p class="red-bold">
							17、若本保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致本保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则本保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
						</p>
						<p>18、本保险单与投保申请、保险条款、批单或批注(如有)及其它约定书均为保险合同的构成部分。</p>
						<p>
							19、为了保障您自身的权益，请在确认投保本保险前，任细阅读理解保险合同(包括但不限于保险条款等)的各项规定，
							<span class="red-bold">尤其是免除保险人责任的规定</span>
							。如有疑问，请致电:4008208858
							询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
						</p>
						<p>
							20、为了保障您的利益，请在收到本保险单一周内拨打我公司服务热线4008208858核实保险单资料，包括保险单所列示的销售人员或销售中介机构信息。
						</p>
						<p>21、保险合同项下应付保险费含适用的增值税。</p>
					</div>
				</div>
			</el-card>

			<rules :insure-type="insureType" :product-id="productId"></rules>
		</div>

		<div v-else-if="isMeiYaC(insureType, productId)">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p style="line-height: 28px">
							1、本保险为互联网专属产品，由美亚财产保险有限公司（以下简称“保险公司”）承保，面向全国（不含港澳台）进行销售，本保险支持在线投保、核保、保单查询和报案等服务，您可以通过“美亚保险客户服务”微信小程序线上办理退保、批改和理赔等业务。目前保险公司在上海、北京、广东省（含深圳市）、江苏省和浙江省设有分支机构。
							<span class="red-bold">
								保险公司无分支机构的地区，可能无法向您提供及时的面对面线下服务，保险公司将通过电话及互联网通道在线为您提供保单服务。如有任何疑问，可拨打保险公司客户服务热线400-820-8858。
							</span>
							<br />
							2、所有的保险责任及条款均以与保险公司正式订立保险合同的规定为准。
							<br />
							3、被保险人身故保险金受益人为被保险人的继承人。
							<br />
							4、本保险最早的生效时间为T+1零时，最晚为T+30零时（T是指投保成功日）。
							<br />
							5、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							6、本保险的约定投保资格须同时满足以下要求：
							<br />
							<span class="red-bold">
								（1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。前述雇员参保时的年龄限制：18-65周岁。
							</span>
							<br />
							<span class="red-bold">为明确起见，相关定义约定如下：</span>
							<br />
							<span class="red-bold">
								1）本保险所称的投保行业不包括任何提供人力资源服务的人力资源、劳务派遣公司及其他人力资源中介。
							</span>
							<br />
							<span class="red-bold">
								2）本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，且该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期劳动用工的情形。
							</span>
							<br />
							<span class="red-bold">
								3）本保险所称的“在岗全职雇员”须在与投保人存在劳动用工关系期间，不存在除投保人之外的其他用人单位或用工主体。为避免歧义，在岗全职雇员不包括与投保人存在劳动用工关系的非全职临时工、小时工、兼职实习生等非全职雇员以及培训学员、会员等不具备劳动用工关系的人员。
							</span>
							<br />
							（2）属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。
							<br />
							如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则
							<span class="red-bold">
								保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
							</span>
							<br />
							7、
							<span class="red-bold">
								如投保人名称中包含以下关键字，则保险公司不接受该投保申请：危险品、人力资源、拆、分包、外包、劳务派遣、幕墙、脚手架、爆破、爆炸、渔业、隧道。
							</span>
							<br />
							8、保险合同成立时投保人数不低于3人。
							<span class="red-bold">如被保险人含职业类别四或职业类别五或职业类别六，则被保险人人数应不低于5人。</span>
							单张保单最高投保人数为1000人。
							<br />
							9、
							<span class="red-bold">
								保险公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总赔偿限额为限。如在任一意外事故中，前述总赔偿限额低于按每一被保险人的保险金额给付的总赔偿金额，则保险公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							</span>
							<br />
							10、
							<span class="red-bold">每一意外事故总赔偿限额说明：</span>
							<br />
							每一意外事故总赔偿限额为以下两者较高者：
							<br />
							（1) 保险合同生效时，保险单所载单个被保险人在意外身故及伤残保障项下所适用的最高保险金额的10倍；
							<br />
							（2) 人民币500万元。
							<br />
							11、本保险所承保的被保险人的职业类别以投保时约定的为准（具体职业请以保险公司职业分类表为准）。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理
							<br />

							（1）
							<span class="red-bold">
								如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，保险公司不承担任何保险责任。
							</span>
							除本合同另有约定外，保险公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。
							<br />
							（2）如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%
							</span>
							<br />
							12、如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知保险公司。保险公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：
							<br />
							（1）如其变更后的职业类别相比变更前风险程度降低的，则保险公司按日比例退还自其变更职业类别之日起相应保险费的差额；
							<br />
							（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；
							<br />
							（3）如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，保险公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，保险公司将按承保日比例退还该被保险人未满期保险费。
							<br />
							投保人或被保险人未履行上述通知义务的，保险公司按照下列规定进行处理：
							<br />
							（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失，对于其丧失被保资格后所发生的保险事故，保险公司不承担任何保险责任；
							<br />
							（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%
							</span>
							<br />
							13、每位团体成员于保险公司投保的团体意外伤害保险仅限一份，多投无效，不同计划重叠购买的无效。若任一团体成员于保险公司投保多份团体意外伤害保险或购买多份计划，则保险公司仅以首次成功投保的计划为准，并退还其它保险计划项下已收取的保险费。
							<br />
							14、同一职业类别的被保险人必须选择相同的保险计划。
							<br />
							15、本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。
							<span class="red-bold">
								若5类和6类的被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。
							</span>
							<br />
							16、被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。
							<span class="red-bold">
								若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，保险公司不承担任何保险责任。
							</span>
							特种作业证书以国家《特种作业人员安全技术培训考核管理规定》规定的为准。
							<br />
							17、
							<span class="red-bold">意外医药补偿保额说明：</span>
							<br />
							（1）若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							<br />
							（2）若任何被保险人拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，则保险公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额的105%为限，但须扣除该被保险人任何已取得的医药费用补偿。
							<br />
							18、
							<span class="red-bold">
								本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							</span>
							<br />
							19、
							<span class="red-bold">
								本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上（含二级）公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							</span>
							<br />
							20、
							<span class="red-bold">
								《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。
							</span>
							<br />
							21、本保险为团体保险，投保人不得以任何方式销售给第三方（第三方包括但不限于被保险人本人）。
							<br />
							22、
							<span class="red-bold">
								若保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							</span>
							<br />
							23、
							<span class="red-bold">
								本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							24、被保险人的投保年龄以申请时被保险人的周岁年龄为准。
							<br />
							25、新增或减少被保险人的申报：保险合同有效期间，若有团体成员的新增或减少，投保人须将该新增及减少的成员资料申报至保险公司。对于新增团体成员，经保险公司确认同意承保后，该新增成员自投保人申报次日零时起获得被保资格。
							<br />
							26、保险凭证：保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							27、
							<span class="red-bold">
								投保人未能披露与本保险相关之重大事实（包括但不限于是否符合本投保申请上述所有投保前提条件，下同）可能导致保险公司不承担保险责任。
							</span>
							重大事实系指可能影响保险公司风险评估或接受投保申请与否之事实。如果投保人不能确定某些事实是否属于应披露之重大事实，请予以披露。
							<br />
							28、本保险
							<span class="red-bold">仅提供电子版本的保险单</span>
							，根据预留的电子邮件地址发送电子版本的保险单，投保人可登录
							<el-link href="https://www-401.aiginsurance.com.cn/CIRC/accident_policy_enquiry.asp" type="primary">
								美亚保险信息自主查询系统
							</el-link>
							进行保单验真。
							<br />
							29、本保险适用条款：
							<br />
							（1）
							<span class="red-bold">通用条款：</span>
							《美亚附加被保险人资格条款（2022年第一版）》《美亚附加仅承保境内意外事故条款（2021年第二版）（互联网专属）》《美亚附加被保险人职业类别处理规则条款（2022年第一版）》《美亚附加不承保特定医院条款（2022年第一版）》《美亚附加短期保险费条款（2022年第一版）》《美亚附加每一意外事故总赔偿限额条款（2021年第一版）（互联网专属）》《美亚附加经济制裁责任免除条款》《美亚附加特定职业类别人员高处作业条款（2021年第二版）（互联网专属）》《美亚附加特种作业限制条款（2021年第二版）（互联网专属）》《美亚团体意外伤害保险（2021年第一版）（互联网专属）》《美亚附加意外每日住院津贴团体收入保障保险（2021年第一版）》《美亚附加争议处理条款（2023年第一版）》
							<br />
							（2）
							<span class="red-bold">意外医药补偿保障适用条款：</span>
							<br />
							如投保的意外医药补偿保障仅限医保范围内的医疗费用，不承保全额自费费用，则适用《美亚附加意外医药补偿团体医疗保险（2022年第三版）（互联网专属）》；
							<br />
							如投保的意外医药补偿保障不限医保范围内的医疗费用，保障全额自费费用，则适用《美亚附加意外医药补偿团体医疗保险（2021年第三版）（互联网专属）》
							<br />
							30、
							<span class="red-bold">重要提示：</span>
							<br />
							（1）请仔细阅读本保险所有投保前提条件，确认符合所列投保前提条件方可进行投保。
							<br />
							（2）为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，
							<span class="red-bold">尤其是免除保险人责任的规定</span>
							。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							（3）本投保申请、保险条款、保险单、批单或批注（如有）及其它约定书均为保险合同的构成部分。
							<br />
							（4）为了维护您的利益，投保人/被保险人需详细并如实填写投保申请上所列资料。
							<br />
							（5）美亚财产保险有限公司综合偿付能力充足率达到监管要求，且风险综合评级提示操作、战略、声誉和流动风险较小，具体偿付能力指标和风险综合评级结果请查询公司官方网站
							<el-link href="www.aig.com.cn" type="primary">www.aig.com.cn</el-link>
							。
							<br />
							保险合同项下应付保险费含适用的增值税。
							<br />
						</p>

						<el-divider></el-divider>
						<h3>重要提示</h3>
						<p style="line-height: 32px">
							1、投保人须获得被保险人的同意，方可为其投保本保险。
							<br />
							2、本保险为团体保险，投保人不得以任何方式销售给第三方(第三方包括但不限于被保险人本人)。
							<br />
							3、保险公司将为保险合同项下各被保险人签发保险凭证，投保人应负责向各被保险人送达保险凭证。
							<br />
							4、
							<span class="red-bold">
								任何已提出投保申请的人员或在保险期间内可能提出参保申请的人员，均须符合本保险约定的投保资格。如任何投保人员在保险合同订立后或在保险合同有效期内发现不符合上述要求的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。
							</span>
							<br />
							5、本保险所承保的被保险人的职业类别以投保时约定的为准（具体职业请以保险公司职业分类表为准）。投保人在为被保险人申请投保时，应按被保险人的实际职业类别填写，如被保险人工作涉及多个职业类别，则应以职业类别最高的职业为准。若
							<span class="red-bold">
								申报的被保险人的职业类别不真实，则视为投保人故意未依法履行如实告知义务，并按照下列规定处理：
							</span>
							<br />
							<span class="red-bold">
								(1)
								如该被保险人的实际职业类别为申请投保时本合同约定不接受投保的职业类别，则其被保资格将被取消；对于取消其被保资格前所发生的保险事故，保险公司不承担任何保险责任。除本合同另有约定外，保险公司在前述取消该被保险人被保资格的情形下将退还其项下相应的未满期保险费。
							</span>
							<br />
							<span class="red-bold">
								(2)
								如该被保险人的实际职业类别为申请投保时本合同约定接受投保的职业类别，但高于为其所申报保险计划对应的职业类别，则该被保险人发生保险事故后，无论该保险事故是否与职业类别相关，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							</span>
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/实际职业类别对应的应交保险费）*70%。
							</span>
							<br />
							6、如任何被保险人在保险期间内职业类别发生任何变更，投保人或该被保险人应于变更后十个工作日内书面通知保险公司。保险公司收到投保人或该被保险人的通知后，有权按下列规定调整该被保险人的承保条件或拒绝接受该被保险人继续成为本合同的被保险人：
							<br />
							（1）如其变更后的职业类别相比变更前风险程度降低的，则保险公司按日比例退还自其变更职业类别之日起相应保险费的差额；
							<br />
							（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别的，投保人应按日比例补缴自该被保险人变更职业类别之日起相应保险费的差额；
							<br />
							（3）如其变更后的职业类别为本合同约定不接受投保的职业类别，则自该被保险人变更职业类别之日起，保险公司不再接受该被保险人继续成为本合同的被保险人，其被保资格将于变更职业类别之日二十四时丧失，保险公司将按承保日比例退还该被保险人未满期保险费。
							<br />
							<span class="red-bold">
								投保人或被保险人未履行上述通知义务的，保险公司按照下列规定进行处理：
								<br />
								（1）如其变更后的职业类别为本合同约定不接受投保的职业类别，则其被保资格于变更职业类别之日二十四时丧失，对于其丧失被保资格后所发生的保险事故，保险公司不承担任何保险责任；
								<br />
								（2）如其变更后的职业类别相比变更前风险增加但仍属于本合同约定接受投保的职业类别，则对于该被保险人在职业类别变更后发生的保险事故，保险公司根据保险合同约定对其承担的赔偿金额均按以下公式计算：
							</span>
							<br />
							<span class="red-bold">
								实际赔偿金额=按保险合同约定核定的赔偿金额*（实际交纳保险费/变更后职业类别对应的应交保险费）*70%。
							</span>
							<br />
							7、
							<span class="red-bold">被保险人的身故保险金受益人为被保险人的继承人。</span>
							<br />
							8、
							<span class="red-bold">
								本公司在意外身故及伤残保障项下对所有被保险人于任一次意外事故中累计所给付的赔偿金额以不超过保险单所载的每一意外事故总暗偿限额为限。如在任一意外事故中，前述总赔偿限额低干按每一被保险人的保险金额给付的总赔偿金额，则本公司将根据前述总赔偿限额与按每一被保险人的保险金额计算的赔偿总额的比例赔偿每一被保险人。
							</span>
							<br />
							9、若任何被保险人没有公费医疗、社会基本医疗保险、其他费用补偿型医疗保险或被保险人未从公费医疗、社会基本医疗保险、其他费用补偿型医疗保险取得医药费用补偿，则本公司对该被保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应的保险金额为限。
							<br />
							若任何被保险人
							<span class="red-bold">
								拥有且已从公费医疗、社会基本医疗保险或其他费用补偿型医疗保险取得医药费用补偿，
							</span>
							则本公司对该保险人在意外医药补偿保障项下支付的赔偿金额最高以上表所载该保障项下该被保险人相应
							<span class="red-bold">
								保险金额的百分之一百零五(105%)为限，但须扣除该被保险人任何已取得的医药费用补偿。
							</span>
							<br />
							10、
							<span class="red-bold">
								本保险承保合同约定职业类别为5类和6类的被保险人在从事高处作业的职业活动期间所发生的保险事故。本保险所称的高处作业以《高处作业分级》（中华人民共和国国家标准GB/T
								3608-2008）中规定的为准，如属于在距坠落高度基准面5米及以上有可能坠落的高处进行作业，前述被保险人应依法取得规定的特种作业证书。若5类和6类的被保险人在从事5米及以上高处作业时未系绑安全带，则保险公司不承担任何保险责任。对于职业类别为1类至4类的被保险人，本保险不承保其任何5米及以上的高处作业。
							</span>
							<br />
							11、
							<span class="red-bold">
								被保险人在保险期间内进行任何特种作业操作前，应依法取得规定的特种作业证书。若被保险人未依法取得规定的特种作业证书而进行特种作业操作的，则对于其因该特种作业操作导致的任何保险事故，本公司不承担任何保险责任。特种作业证书以国家(特种作业人员安全技术培训考核管理规定》规定的为准。
							</span>
							<br />
							12、
							<span class="red-bold">
								本保险仅承保于境内发生的意外事故。本合同所称的境内是指中国大陆地区，不包括台湾省、香港及澳门特别行政区。
							</span>
							<br />
							13、
							<span class="red-bold">
								本保险所称的医院仅指境内经国家卫生部门评审确定的二级以上(含二级)公立医院，不包括任何精神病院、养老机构、康复医院、诊所、天然治疗所，以及主要作为护理、疗养、戒酒、戒毒或类似目的的医疗机构。
							</span>
							<br />
							14、
							<span class="red-bold">
								《美亚附加意外每日住院津贴团体收入保障保险》项下所称的医院不包括下列医院：北京市（平谷区、密云区、怀柔区）、天津市（滨海新区、静海区）、福建省南平市、安徽省宿州市、河北省（三河市、廊坊市、青龙县、兴隆县）的所有医院；福建省宁德市古田县医院；河北省承德市第六医院、邯郸市第一医院、馆陶县人民医院、元氏县中医院；河南省（开封市、信阳市、新密市、内黄县、通许县）所有医院，河南省新乡市中医院、新乡市第二人民医院、焦作市第五人民医院、许昌县人民医院、商水县人民医院、濮阳县第二人民医院、鹤壁煤业（集团）有限责任公司总医院；山东省（莱州市、栖霞市、威海市、金乡县、禹城）所有医院，山东滨州市中心医院、鱼台县人民医院、青岛市即墨区中医院、荣成市中医院、烟台市中医医院、聊城市中医医院；四川省宜宾市所有医院、雅安市雨城区人民医院、雅安市第二人民医院、富顺县中医医院、绵阳市人民医院、泸州市纳溪区人民医院、内江市第四人民医院、阿坝州林业中心医院、遂宁市大英县中医院；甘肃省民勤县人民医院、宁县人民医院；山西省运城市盐湖区人民医院；黑龙江鸡西市所有医院，黑龙江省中医医院、牡丹江市中医院、牡丹江市第二人民医院、哈尔滨市第一医院、五大连池市第一人民医院；吉林省四平市所有医院，吉林省中医医院、通化市人民医院、长春市中心医院；辽宁省铁岭市所有医院，辽宁省中医医院；海南省第三人民医院。
							</span>
							<br />
							15、
							<span class="red-bold">
								本保险不承保任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。
							</span>
							<br />
							16、
							<span class="red-bold">
								若本保险公司在本保险项下提供任何保险保障、利益或支付任何保险赔偿金会导致本保险公司违反联合国决议项下的任何制裁、禁止性或限制性规定，或者违反中华人民共和国或美国颁布的任何经济贸易制裁、法律法规时，则本保险公司在本保险项下不提供前述保险保障、利益，亦不支付前述保险赔偿金。
							</span>
							<br />
							17、本保险单与投保申请、保险条款、批单或批注（如有）及其它约定书均为保险合同的构成部分。
							<br />
							18、为了保障您自身的权益，请在确认投保本保险前，仔细阅读理解保险合同（包括但不限于保险条款等）的各项规定，
							<span class="red-bold">尤其是免除保险人责任的规定</span>
							。如有疑问，请致电：4008208858询问，并听取保险公司客服人员的说明。请确保您对保险公司客服人员的说明完全理解，没有异议。如未询问，则视同已经对合同内容完全理解并无异议。
							<br />
							19、为了保障您的利益，请在收到本保险单一周内拨打我公司服务热线4008208858核实保险单资料，包括保险单所列示的销售人员或销售中介机构信息。
							<br />
							20、保险合同项下应付保险费含适用的增值税。
							<br />
						</p>
					</div>
				</div>
			</el-card>
			<el-card header="保险条款">
				<rules :insure-type="insureType" :product-id="productId"></rules>

				<br />
			</el-card>
		</div>

		<div v-else-if="insureType == 15">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-indent: 2em">
						本产品由新疆前海联合财产保险股份有限公司（以下简称“前海财险”）承保，由前海财险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-indent: 2em">
						新疆前海联合财产保险股份有限公司（简称“前海财险”）于2016年05月19日正式开业，由深圳市钜盛华股份有限公司、深圳粤商物流有限公司、深圳市深粤控股股份有限公司、凯信恒有限公司、深圳建业工程集团股份有限公司5家实力雄厚、管理规范的股东共同发起设立，公司股东实力雄厚，管理规范，经营范围涉及金融投资、建筑地产、仓储物流、文化商贸等多产业，经营区域覆盖全国。注册资本10亿元，是首家注册于新疆、总部位于深圳前海蛇口自贸区的全国性财产保险公司。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p style="font-weight: bold">
							1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。
						</p>
						<p style="font-weight: bold">
							1.2
							<span style="color: red">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p style="font-weight: bold">
							1.3
							<span class="red-bold">保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</span>
						</p>
						<p style="font-weight: bold">
							1.4
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p style="font-weight: bold">
							1.5
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p style="font-weight: bold">
							1.6
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
							</span>
						</p>
						<p style="font-weight: bold">
							1.7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">新疆前海联合财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">(前海财险)(备-责任保险)【2019】(主) 014号</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>
							凡中华人民共和国境内依法设立的企业、事业单位、社会团体、民办非企业单位、基金会、律师事务所、会计师事务所等组织、有雇工的个体工商户，均可作为本保险合同的投保人和被保险人。
						</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月、6个月或1年。</p>
						<p style="font-weight: bold">3.3 特别约定</p>

						<p style="line-height: 32px">
							3.3.1、鉴于被保险人营业性质包括
							<span class="red-bold">
								个体工商户等形式，本保险所指的工作人员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员等
							</span>
							。被保险人雇员年龄范围为16周岁-65周岁（
							<span class="red-bold">截至65岁生日当天</span>
							），不在本年龄段范围内，所发生的事故，保险人均不承担保险责任。
							<br />
							3.3.2、被保险人雇员遭受意外伤害时，实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，如仍在保险人承保职业类别范围内，则保险人对按保单约定的应承担的保险责任，绝对免赔率为损失金额的20%，
							<span class="red-bold">并且</span>
							，投保人需补交对应的保费；如非在承保职业类别范围内，则不予赔付。若投保职业对应的保费，大于或等于被保险人实际职业类别对应的保费，保险人不得以投保职业有误而拒赔或者减少承担赔偿责任。
							<br />
							3.3.3、
							<span class="red-bold">
								本保单记名投保，本项目所有保单可加人（不足1个月的按1个月收费），不可减人。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。换人规则：原1-2类职业人员可替换为新的1-2类职业人员；原3类职业人员可替换为新的3类职业人员；原4类职业人员可替换为新的4类职业人员；不同职业人员之间不可互换。已发生理赔的人员不可以被更换。
							</span>
							<br />
							3.3.4、
							<span class="red-bold">
								本保单雇员必须与被保险人存在实际雇佣关系，否则，保险人有权拒绝赔偿。本保单不承保承揽关系。
							</span>
							<br />
							3.3.5、被保险人雇员遭遇保险事故导致身故，保险人按工伤赔偿标准核算身故赔偿金，在不超过保单列明的每人死亡赔偿限额内赔付。
							<br />
							3.3.6、①
							<span class="red-bold">若不扩展伤残赔偿比例十级标准</span>
							，如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金限额=每人伤残赔偿限额*伤残等级对应的赔付比例。本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）进行伤残等级鉴定，一级到十级伤残的比例分别为：100%，80%，70%，60%，50%，40%，30%，
							<span class="red-bold">20%，10%，5%。</span>
							<br />
							②
							<span class="red-bold">若扩展伤残赔偿比例十级标准</span>
							，如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金限额=每人伤残赔偿限额*伤残等级对应的赔付比例。本保单按国家社保《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）进行伤残等级鉴定，一级到十级伤残的比例分别为：100%，80%，70%，60%，50%，40%，30%，
							<span class="red-bold">25%，15%，10%。</span>
							<br />

							3.3.7、医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内。按社保内用药100%赔付。按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。被保险人均应在二级以上（含二级）公立医院或保险人认可的医疗机构就诊。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。
							<br />
							但以下地区或指定医疗机构发生的费用不在赔偿范围内：
							<br />
							①以下地区的所有医疗机构发生的费用不在赔偿范围内:
							<br />
							北京平谷区、密云县、怀柔区；
							<span class="red-bold">河北省三河市、沧州市、河北青龙县、廊坊市；天津市</span>
							；辽宁铁岭；江苏徐州、南通、
							<span class="red-bold">连云港、常州</span>
							；山东德州、禹城市、临沂、山东金乡县；河南信阳市；湖北黄冈市、荆州市；四川宜宾市；
							<br />
							②以下医疗机构发生的费用不在赔偿范围内：
							<br />
							四川省雅安市雨城区人民医院、四川省雅安市第二人民医院、河南省新乡市中医院、吉林省四平市第一人民医院、吉林省四平市梨树县第一人民医院、吉林省四平市中医医院、中国医科大学附属盛京医院、山东省莱州市人民医院、山东齐鲁医院、莱州市中医院、莱州市郭家店中心卫医院、山东滨州市中心医院。河北省保定市第一医院.
							<br />
							以上地区的医院和指定的医院均不在保险公司认可医院范围内，即上述的医疗机构的发票保险公司不予理赔。
							<br />

							3.3.8、误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
							<br />
							3.3.9、
							<span class="red-bold">本保单不承保高处作业时发生的意外事故</span>
							，因高空作业导致的任何损失，保险公司不承担赔偿责任。所谓高处作业是指人在一定位置为基准的高处进行的作业。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。
							<br />
							3.3.10、被保险人雇员如果有工伤保险的，则由工伤保险先行赔付，此保单再补充赔付。
							<br />
							3.3.11、在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡,保险人承担赔偿责任，赔款限额=每人身故赔偿限额*20%，且该赔偿金额包含在身故赔偿限额范围内。但雇员因
							<span class="red-bold">职业病以外的</span>
							疾病、分娩、流产原因
							<span class="red-bold">以及因上述原因接受医疗、诊治</span>
							不在保单赔偿责任范围内。
							<br />
							<br />
							3.3.12、
							<span class="red-bold">
								在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							</span>
							<br />
							3.3.13、
							<span style="font-weight: bold">
								本保单可承保1-4类职业：餐饮业（不含外卖送餐、跑腿代购人员）、旅游业/商业、服务业/
								<span class="red-bold">物业/家政服务/室内装修、室内保洁</span>
								、室内电器安装（不含空调）/
								<span class="red-bold">能源开发利用业</span>
								/纺织及纺织制品业 ，具体职业以《前海财险职业类别分类表》为准。
							</span>
							<br />
							3.3.14、被保险人拒保职业范围：农畜渔牧业/木材森林业/矿业采石业/交通运输业/建筑工程业（
							<span class="red-bold">不含室内项目</span>
							）/职业运动员/娱乐业/公共事业/家用空调安装/电梯行业/军人/金属冶炼/高压电相关职业/水泥石膏石灰行业/化工制造行业/火药、炸药、烟花业/邮政/快递、窑炉/烟囱建设及拆除、石油天然气开发、危险品/危化品、家具/家私业、船舶/造船业。
							<br />
							3.3.15、
							<span style="font-weight: bold">
								被保险人的雇员无有效驾驶证驾驶机动车或无国家有关部门核发的有效资格证书而使用各种专用机械、
								<span style="color: red">特种设备</span>
								、特种车辆或类似设备装置发生意外事故导致伤害，
								<span style="color: red">不在保单赔偿范围内。</span>
							</span>
							<br />
							3.3.16、
							<span class="red-bold">
								一旦发生保险事故，被保险人应在事故发生48小时内及时通过保险公司服务热线4008110110，并书面说明事故发生的原因、经过和损失情况；因延迟报案影响保险人查勘、定损的，保险人对无法核实部分不承担任何赔偿责任。
							</span>
							<br />
							3.3.17、
							<span class="red-bold">
								本保单禁止承保以下地区业务：黑龙江、辽宁、吉林、新疆、西藏、青海、宁夏、甘肃、天津、河北、山东荣成、山东青岛、北京平谷区、北京密云区。对于在被保险人实际用人所在地在以上地区的，保险公司不承担赔偿责任。
							</span>
							<br />
							3.3.18、
							<span style="font-weight: bold">法律费用每次事故赔偿限额10万，累计赔偿限额10万。</span>
							<br />
						</p>
						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<span class="red-bold">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</span>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
						</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">出险后请您尽快拨打保司客服热线4008110110进行报案</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							5.2
							若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或前海财险客户服务及投诉热线：4008-110-110，我们将安排专人跟进处理。
						</p>
					</div>
				</div>
			</el-card>
			<!--            <el-card header="保险条款">-->
			<!--                <el-link type="primary" href="https://mbtest.meibaokeji.com.cn/employer/static/2022images/pdf/qianhai.pdf" target="_blank">新疆前海联合财产保险股份有限公司雇主责任保险条款</el-link>-->
			<!--            </el-card>-->
		</div>

		<div v-else-if="insureType == 14">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由阳光财产保险股份有限公司（以下简称“阳光财险”）承保，由阳光财险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：
						<a href="http://icid.iachina.cn/?columnid_url=201509301401" style="color: DodgerBlue" target="_blank">
							http://icid.iachina.cn/?columnid_url=201509301401
						</a>
						）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						阳光财产保险股份有限公司（以下简称“阳光财险”）成立于2005年7月28日，是阳光保险集团股份有限公司旗下的全国性专业财险公司，注册资本金57.46亿元。目前已有36家二级机构开业运营，三四级分支机构超1800家，服务网络实现全国覆盖。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							1.2
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>
							1.3
							<span class="red-bold">保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</span>
						</p>
						<p>
							1.4
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							1.5
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							1.6
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
							</span>
						</p>
						<p style="font-weight: bold">
							1.7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">阳光财产保险股份有限公司驾乘人员团体意外伤害保险（互联网专属）条款</td>
								<td style="text-align: center">C00009332312021122839663</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>
							对被保险人具有保险利益的机动车辆所有人和管理人可作为投保人。凡驾驶或乘坐机动车辆，且身体健康、能正常工作或正常生活的自然人均可作为被保险人。
						</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限为1年。</p>
						<p style="font-weight: bold">3.3 特别约定</p>

						<p style="line-height: 32px">
							3.3.1、特定团体是指法人、非法人组织以及其他不以购买保险为目的而组成的团体。特定团体属于法人或非法人组织的，投保人应为该法人或非法人组织；特定团体属于其他不以购买保险为目的而组成的团体的，该特定团体中对被保险人具有保险利益的机动车辆所有人和管理人可作为投保人。
							<br />
							3.3.2、
							<span class="red-bold">
								被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%。
							</span>
							如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
							<br />

							3.3.3、
							<span class="red-bold">
								出险后，被保险人必须在72小时内拨打95510取得报案号后才是报案成功（否则报案失败）。如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第2条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							<br />
							3.3.4、若
							<span class="red-bold">出险时为交通事故，索赔时须提供公安部门出具的证明</span>
							（列明当事人、出险时间、地点、原因及经过等事故信息）
							<span class="red-bold">或交警部门出具的事故责任认定书，发生交通事故需先行车险理赔，</span>
							若
							<span class="red-bold">上述材料未提供或提供信息不完整的案件，保险人有权予以拒赔。</span>
							<br />
							3.3.5、每车仅能投保一种方案，限投一份，多投无效。
							<br />
							3.3.6、本保单
							<span class="red-bold">不保装卸车，本保单</span>
							所指机动车辆为货车、专用车，专用车为用于清障、清扫、清洁、起重、升降、挖掘、推土和保温用途等装载有专用设备、仪器与器具，具有专项用途的车辆。
							<br />
							3.3.7、出险时，车辆实际载人数与核定载人数不一致时，按车辆实际载人数进行赔付。车辆实际载人数小于或等于核定载人数，各保障项目的每人保险金额限额为每座保额；出险时若车辆实际载人数大于核定载人数，各保障项目的每人保险金额为：车辆总保险金额/实际载人数。
							<br />
							3.3.8、出险时，
							<span class="red-bold">
								若车辆载物大于核定载质量50%以上的，保险人对按保单规定的应承担的保险责任，免赔50%；若车辆载物大于核定载质量30%以上未达50%，保险人对按保单规定的应承担的保险责任，免赔30%。
							</span>
							<br />
							3.3.9、保险期间内，被保险人在乘坐或驾驶保险单中载明的机动车辆行驶过程中或为维护车辆继续运行（包括加油、加水、故障修理、换胎等）的临时停放过程中或作业中（
							<span class="red-bold">除外装卸作业责任</span>
							），因遭受意外伤害事故导致身故、残疾的，保险人依照下列约定给付保险金，且给付各项保险金之和不超过意外伤害保险金额。
							<br />
							3.3.10、对于医疗费用：保险人按投保人营业执照注册地（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。社保行政部门公布的城镇职工医疗保险的范围及标准赔付。保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任，
							<span class="red-bold">
								自保险期间届满30日内（含第30日）且最长不超过该次意外伤害事故发生之日起180日的医疗费用承担保险金给付责任。
							</span>
							<br />
							3.3.11、对于住院津贴：按100元/天/座进行赔偿，每次事故赔偿不超过90天，累计不超过180天，无免赔。（
							<span class="red-bold">
								但最长延续至本附加险保险期间届满日后第 30 日，且保险人对该次住院累计给付住院津贴的日数不超过 90 日
							</span>
							）
							<br />
							3.3.12、
							<span class="red-bold">
								本保单不承担车辆及车上任何货物损失，不承担由于职业病或任何性质的精神损害赔偿责任。不承保装卸工与不承担车上人员装卸作业事故责任
							</span>
							<br />
							3.3.13、本保单被保险人意外伤害残疾以《人身保险伤残评定标准》(标准编号为JR/T0083－2013）所列残疾标准的对应比例进行赔付。《人身保险伤残评定标准》对功能和残疾进行了分类和分级，将人身保险伤残程度划分为一至十级，经司法鉴定后，伤残按一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、十级10%的比例赔付。如自该意外伤害事故发生之日起第180日治疗仍未结束，按第180日的身体情况进行残疾鉴定，并据此给付残疾保险金。
							<br />
							3.3.14、
							<span class="red-bold">
								车辆驾驶员或操作员需持国家有关部门核发的有效操作证，否则保险人对按保单规定的应承担的保险责任，免赔20%，若车辆驾驶员驾驶证无效或车辆行驶证无效，则保险人不承担保险责任。
							</span>
							<br />
							3.3.15、高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。
							<span class="red-bold">
								从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔20%。
							</span>
							<br />
							3.3.16、本保单指定就诊医院为
							<span class="red-bold">大陆境内二级及以上公立医院，</span>
							但
							<span class="red-bold">
								不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。
							</span>
							如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。
							<span class="red-bold">
								对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
							</span>
							<br />
							3.3.17、（若扩展猝死责任）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（
							<span class="red-bold">
								雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内
							</span>
							），保险人承担赔偿责任。
							<br />
							3.3.18、意外伤害医疗免赔额为100元，给付比例为100%。
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
						</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">出险后请您尽快拨打保司客服热线95510进行报案</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							5.2
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或阳光财险客户服务及投诉热线：95510，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="insureType == 16">
			<el-card header="投保须知及声明">
				<div>
					<h3>保险条款及须知</h3>
					<p style="line-height: 32px">
						1. 本保险适用以下保险条款： 2、本保险由中国太平洋财产保险股份有限公司承保，
						<span class="red-bold">承保区域为广东省范围内、仅限承保营业执照注册地址在广东的企业和组织</span>
						<br />
						3、新市民是指：指因本人创业就业、子女上学、投靠子女等原因来到城镇常住,未获得当地户籍或获得当地户籍不满三年的各类群体,包括但不限于进城务工人员、新就业大中专毕业生等。
						<br />
						4、新就业形态人员是指：是指以非全日制、临时性、季节性、弹性工作等灵活多样形式实现就业的人员。
						<br />
						5、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
						<br />
						6、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；
						<span class="red-bold">
							故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；
						</span>
						因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
						<br />
						7、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
						<br />
						8、本保险根据投保单位的需求提供电子发票或纸质专票。
						<br />
						9、本保险由博维保险经纪有限公司面向
						<span class="red-bold">广东省内销售并提供服务</span>
						，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
						<br />
						10、
						<span class="red-bold">
							如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
						</span>
						<br />
					</p>
					<el-divider></el-divider>
					<h3>特别约定</h3>
					<p style="line-height: 32px">
						<span style="font-weight: bold">1、保障期限：</span>
						<br />
						<span>只允许投保1、3、6、12个月。</span>
						<br />
						<span style="font-weight: bold">2、特约：</span>
						<br />
						（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人
						<span class="red-bold">超过72小时</span>
						才报案，则保险人对按保单约定的应承担的保险责任，
						<span class="red-bold">免赔50%</span>
						。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
						<br />
						（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
						<br />
						（3）
						<span class="red-bold">本保单可加人（不足1个月的按1个月收费），不可减人</span>
						。保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。
						<br />
						（4）如被保险人未有员工出险，则保险人收取最低保费后，允许保单退保，并退还剩余保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
						<br />
						（5）本保单仅承保建筑相关行业，1-3类职业不保高空作业，4-6类职业可保高空作业。
						<br />
						（6）
						<span class="red-bold">
							本保单拒绝承保职业：地下作业、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除、钢结构、钢骨结构、涉及火药/炸药/爆破的相关工作和建筑拆除。
						</span>
						<br />
						（7）被保险人从业人员遭受伤害时，
						<span class="red-bold">
							实际从事的工作（不属于拒绝承保职业）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如属于拒绝承保职业，保险人不承担任何赔偿责任。
						</span>
						<br />
						（8）在工作时间和工作岗位，
						<span class="red-bold">突发疾病死亡或者在48小时之内经抢救无效死亡</span>
						（从业人员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），
						<span class="red-bold">保险人承担赔偿责任，赔款=每人身故赔偿限额*20%</span>
						。
						<br />
						（9）如被保险人从业人员遭遇保险事故导致身故，保险人根据《民法典》及《最高人民法院关于审理人身损害赔偿案件适用法律若干问题的解释》等相关法律法规计算从业人员的赔偿金额。
						<br />
						（10）如被保险人从业人员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。
						<br />
						（11）按伤残鉴定机构出具的伤残程度鉴定书，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例50%，七级伤残给付比例40%，
						<span class="red-bold">八级伤残给付比例20%，九级伤残给付比例10%，十级伤残给付比例5%。</span>
						<br />
						（12）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准100%赔付。
						<br />
						（13）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
						<span class="red-bold">被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付</span>
						。
						<br />
						（14）被保险人从业人员
						<span class="red-bold">无安全带或者无特种作业操作证（包括但不限高处作业证）</span>
						，保险人承诺不拒赔；从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，
						<span class="red-bold">免赔25%</span>
						。
						<br />
						（15）本保单
						<span class="red-bold">指定就诊医院为大陆境内二级及以上公立医院</span>
						。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
						<br />
						（16）在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
						<br />
						（17）
						<span class="red-bold">
							本保单仅承保施工地址在广东省内的工程项目。如施工地址在广东省外，保险人不承担任何赔偿责任。
						</span>
						<br />
						（18）本保单承保法律费用责任，
						<span class="red-bold">累计赔偿限额为RMB10万元，</span>
						每次事故赔偿限额为RMB10万元。
					</p>
				</div>
			</el-card>
		</div>

		<!-- 泰康电梯雇主险 -->
		<div v-else-if="insureType == 18">
			<el-card header="投保须知及声明">
				<el-row>
					<el-col :span="23">
						<p style="line-height: 32px">
							<span>
								本产品由泰康在线财产保险股份有限公司（以下简称“泰康在线”）承保，由泰康在线委托博维保险经纪（以下简称“博维”）有限公司进行销售。互联网保险信息披露访问链接：
								<a href="http://icid.iachina.cn/?columnid_url=201509301401" style="color: DodgerBlue" target="_blank">
									http://icid.iachina.cn/?columnid_url=201509301401
								</a>
							</span>
							<br />
							<span>
								泰康在线是世界500强泰康保险集团的全资子公司，成立于2015年，注册资本为人民币40亿元。截至2020年末，公司综合偿付能力充足率209%。泰康在线专注于互联网保险业务的创新开拓，致力于通过“保险+科技”、“保险+服务”的“双生态”战略，，实现保险与科技的深度融合保险金融属性和服务属性的深度结合，打造国际领先的科技型、服务型互联网保险公司。
							</span>
						</p>
						<div style="line-height: 32px">
							<p style="font-weight: bold">一、重要告知</p>
							1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。
							<br />
							1.2
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
							<br />
							1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。
							<br />
							1.4
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
							<br />
							1.5
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
							<br />
							1.6
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
							<br />
							1.7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
							<br />
							1.8 保险公司全国统一的客户服务及投诉方式详见链接：
							<a href="http://www.tk.cn/sales/feedback-pc/page/" style="color: DodgerBlue" target="_blank">
								http://www.tk.cn/sales/feedback-pc/page/
							</a>
							<br />
							1.9
							本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							2.0 本保险根据投保单位的需求提供电子发票或纸质专票。
							<br />
							2.1
							<span class="red-bold">
								本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							</span>
							<br />
							<p style="font-weight: bold">二、产品信息</p>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%">备案名称</th>
									<th style="width: 50%">注册号或备案号</th>
								</tr>
								<tr>
									<td style="text-align: center">泰康在线财产保险股份有限公司雇主责任保险（B款）</td>
									<td style="text-align: center">C00019930912022082623901</td>
								</tr>
								<tr>
									<td style="text-align: center">
										AZR00209泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）
									</td>
									<td style="text-align: center">C00019930922021092202223</td>
								</tr>
								<tr>
									<td style="text-align: center">AZR00202泰康在线财产保险股份有限公司附加第三者责任保险（B款）</td>
									<td style="text-align: center">C00019930922021090314923</td>
								</tr>
								<tr>
									<td style="text-align: center">AZR00191泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险</td>
									<td style="text-align: center">C00019930922021063099022</td>
								</tr>
							</table>
							<p style="font-weight: bold">三、产品介绍</p>
							<p style="font-weight: bold">3.1 投保人/被保险人</p>
							依法设立的各类机关、企事业单位、社会团体、个体工商户及其他经济组织均可作为本保险合同的投保人和被保险人。投保人和被保险人必须为同一单位。
							<br />
							<p style="font-weight: bold">3.2 保险期限</p>
							该产品有1个月-12个月等12种保险期限可选择，支持企业根据实际用工需求按月购买。
						</div>
						<p style="font-weight: bold">3.3 特别约定</p>
						<div style="line-height: 32px">
							3.3.1、本产品承保的雇员年龄范围为16周岁-65周岁，其中电梯安装和电梯维修人员的年龄范围为16周岁-55周岁。
							<br />
							3.3.2、本保单扩展24小时人身意外伤害扩展保险条款，该附加险项下每人责任限额为5万元人民币。
							<br />
							3.3.3、本保单扩展第三者责任保险，该附加险项下每次事故责任限额为5万元人民币。
							<br />
							3.3.4、本保单赔偿范围包括雇员误工费，
							<span class="red-bold">
								经医院证明，对于超过五天期间的误工损失按100元/天的标准赔偿误工费用，赔偿公式为：100x(实际暂时丧失工作能力天数
								- 5天)，每次不超过90天，累计不超过180天。
							</span>
							<br />
							3.3.5、
							<span class="red-bold">
								主险条款第四条第七款（雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡）赔偿限额为每人每次死亡伤残赔偿限额的20%。
							</span>
							<br />
							3.3.6、保单累计责任限额为实际投保人数*每人伤亡责任限额，
							<span class="red-bold">累计责任限额最高不超过1000万，每次事故责任限额最高不超过500万；</span>
							法律费用另计，不含在内
							<br />

							3.3.7、工伤事故身故、残疾理赔约定：理赔时提供投保人所在地劳动保障行政部门出具的工伤认定证明、劳动能力鉴定委员会做出的劳动能力鉴定结论，劳动能力鉴定材料（
							<span class="red-bold">
								如无法提供劳动保障行政部门出具的工伤认定证明，则伤残赔付标准为保单约定赔付金额的50%）。
							</span>
							<br />
							3.3.8、除受伤当日紧急抢救外，必须在二级以上（含）公立医院就诊，急诊客户除受伤当日因紧急救治可就近送医外，后续治疗均需转至二级（或二级以上）公立医院。未遵循前述约定的，保险人有权拒绝赔付。
							<br />
							3.3.9、
							<span class="red-bold">
								对于进行电梯井道与结构作业的安装工人，本保单只承保其在进行电梯施工工作发生的保险事故，
							</span>
							进行其他施工过程中发生的保险事故为除外责任。
							<br />
							3.3.10、从事高空作业人员，必须定期进行身体检查，被保险人的雇员无妨碍从事相应特种作业的器质性心脏病、癫痫病、美尼尔氏症、眩晕症、癔病、震颤麻痹症、精神病、痴呆症以及其它不适应高空作业的人，不得从事高空作业；
							<span class="red-bold">
								从事高空作业必须配带安全带、安全帽、孔洞须加强围栏或防滑措施，如存在前述疾病或未遵守签署高空作业防范措施，保险公司有权拒绝赔付。
							</span>
							<br />
							3.3.11、
							<span class="red-bold">
								出险索赔时，对于电梯维修人员，需提供电梯操作证，对于电梯安装工人，需提供岗前培训通过证明文件，否则保险人有权拒绝赔偿。
							</span>
							<br />
							3.3.12、
							<span class="red-bold">
								北京平谷区密云区、河北省承德市兴隆县中医院、河北省三河市、天津市、辽宁铁岭、河北青龙县、廊坊市、山东禹城、河南信阳下辖的各医疗机构，不在保险公司认可医院范围内，即上述地区医疗机构的发票保险公司不予理赔。
							</span>
							<br />
							3.3.13、
							<span class="red-bold">已出险人员（含已报案未理赔和已理赔）不允许变更。</span>
							<br />
							3.3.14、伤残鉴定及给付标准：
							<br />
							1）因工作原因导致的意外事故，提供工伤认定并根据《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定的伤残程度，给付比例表如下：
							<table border="1" cellpadding="10">
								<tr>
									<th v-for="(item, index) in leavelData" :key="index">
										{{ item }}
									</th>
								</tr>
								<tr>
									<td v-for="(item, index) in leavelValueData" :key="index">
										{{ item }}
									</td>
								</tr>
							</table>
							2）非工作时间发生的意外事故，按照《人身保险伤残评定标准及代码》（标准编号为JR/T0083-2013)
							确定的伤残程度，给付比例如下：
							<table border="1" cellpadding="10">
								<tr>
									<th v-for="(item, index) in leavelData" :key="index">
										{{ item }}
									</th>
								</tr>
								<tr>
									<td v-for="(item, index) in leavelValueData" :key="index">
										{{ item }}
									</td>
								</tr>
							</table>

							<div style="font-weight: bold">四、理赔</div>
							<p>
								<strong style="color: red">出险后请您尽快拨打保司客服热线95522-3-3-1进行报案</strong>
								，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							</p>
							<div style="font-weight: bold">五、其他信息</div>
							<p>
								5.1
								保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
							</p>
							<p>
								5.2
								<span class="red-bold">
									若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或泰康在线客户服务及投诉热线：95522-3-3-1，我们将安排专人跟进处理。
								</span>
							</p>
						</div>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<div v-else-if="insureType == 17">
			<el-card header="投保须知及声明">
				<el-row>
					<el-col :span="20">
						<div style="line-height: 26px; white-space: pre-line">
							<span style="font-weight: bold">
								本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪有限公司（以下简称“博维”）进行销售
							</span>
							（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
							太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2022年2季度，公司综合偿付能力充足率225.2%，满足监管要求，最近一期的风险综合评级结果为AA。
							<h3>一、重要告知</h3>
							<span style="font-weight: bold">
								1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。 1.2
								<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
								1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。 1.4
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
								1.5
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
								1.6
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
								1.7
								保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
							</span>
							<h3>二、产品信息</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">备案名称</th>
									<th style="width: 50%; padding: 5px 0">注册号</th>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">中国太平洋财产保险股份有限公司雇主责任保险（2016版）条款</td>
									<td style="padding: 5px 0">C00001430912016110806772</td>
								</tr>
							</table>
							<h3>三、产品介绍</h3>
							<span class="red-bold"></span>
							<h4>
								3.1本保险为“雇主责任保险”
								<span class="red-bold">（具体承保内容以保单及保险条款为准）</span>
								，针对家电行业的特征，我们对您投保本份保险作以下重要提示：
							</h4>
							3.1.1
							投保人或被保险人为中华人民共和国境内注册的企业或个体工商户，获得当地市场监督管理局颁发的《营业执照》。
							3.1.2
							<span class="red-bold">保障人员必须为接受被保险人（或保单约定的共同被保险人）派工及管理的人员。</span>
							<h4>3.2 投保人/被保险人</h4>
							家电行业企业为保险合同的投保人/被保险人。
							<h4>3.3 保险期限</h4>
							自所投保雇主责任保险生效日起，保险期限为一年。
							<h4>3.4 特别约定</h4>
							3.4.1本保险方案仅限家电行业企业投保。被保险人须按投保人员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保人员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。
							3.4.2在保险期间内，被保险人的在保人员因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.4.3本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、第三者责任、法律费用，每项保障项目的赔偿限额以保单载明为准。
							3.4.4本保单采用记名承保，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表、个体工商户经营者本人，以及被保险人的其他事实用工人员。保险人仅对记名投保人员清单中保障已生效的人员承担保险责任，对于不在保障已生效人员清单中的人员保险人不承担赔偿任何责任。
							3.4.5鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。在保单生效后申请退保或批减在保人员的，
							<span class="red-bold">可退保费为0。</span>
							3.4.6国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业”。保险人仅对投保高空方案的被保人员承担高处作业的保险责任，投保高空方案的在保人员从事高处作业发生的保险事故，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.4.7鉴于家电售后移动作业的行业特性，被保险人须在发生保险事故48小时内向保险人报案，且须提供包含派工单位、服务人员、服务时间、用户姓名、联系电话、服务地址等信息在内的不可逆的真实派工记录。否则，保险人有权拒赔或对无法核实保险责任的损失不承担赔偿责任。
							3.4.8在保险期间内，发生保险责任范围内的保险事故，导致在保人员死亡或伤残，保险人按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家及当地社保部门规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿以死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人可提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。如出险人员可从工伤保险或其他途径获得伤残赔偿的，保险人将不承担该部分的赔偿责任或只承担工伤保险或其他赔偿不足部分。
							3.4.9
							<span class="red-bold">本保单特约伤残等级赔付限额比例：</span>
							一级100%；二级90%；三级80%；四级70%；五级60%；六级50%；七级40%；八级30%；九级20%；十级10%。该伤残等级赔付限额比例适用于本保单主险及附加险的各个部分。伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。
							3.4.10医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。
							3.4.11医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，
							<span class="red-bold">
								但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。
							</span>
							对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）保险人均按100%比例给付。
							<span class="red-bold">
								如被保险人或出险人员已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。
							</span>
							3.4.12自费药品赔付特别约定：本保单在医疗费用项下扩展承保合理且必要的自费药品，保单约定的每人医疗费用责任限额不变。自费药品定义为：除社保甲、乙类用药以外的，合理且必须药品的自费部分，不包括各种营养滋补类的药品、保健品。
							3.4.13误工费赔付特别约定：在保险期间内，发生保险责任范围内的保险事故，导致在保人员暂时丧失工作能力并住院治疗的，经二级（含）以上或保险人认可的医疗机构提供合理的建议休息证明或由保险人依据《人身损害误工期、护理期、营养期评定规范》GA/T
							1193-2014，核定误工天数，保险人按照人民币100元/人/天的标准，以最长180天为限计算误工费。误工费计算包含住院期间以及出院后的休息误工时间，其中出院后休息误工时间取医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中最短的时间，且一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据前述伤残赔付约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险人员的工资证明。
							<span class="red-bold">出险人员仅在门诊治疗的，无误工费赔付。</span>
							3.4.14扩展工伤事故：被保险人的在保人员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。
							3.4.15扩展承保第三者责任：本保单扩展承保被保险人的在保人员在从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）过程中，
							<span class="red-bold">
								因安装维修服务作业现场发生意外事故，并现场发现造成第三者的人身伤亡或直接财产损失，
							</span>
							根据《中华人民共和国民法典》及有关法律法规中关于民事侵权责任赔偿的相关规定，被保险人依法应承担的经济赔偿责任，保险人按照本条特别约定，在保险合同载明的本项扩展责任限额内负责赔偿。因火灾、爆炸、触电造成的意外事故，必须提供机器检测证明或厂家出具的事故原因鉴定结果。
							本项扩展责任下，保单累计赔偿限额RMB100万元，每次事故赔偿限额RMB60万元，其中每次事故人身伤亡赔偿限额RMB50万元，每次事故财产损失赔偿限额RMB10万元。同一网点投保多份保单，本项扩展责任的累计赔偿限额和每次事故赔偿限额均以单份保单限额为限，赔偿限额不可叠加。
							本扩展责任项下，每次事故财产损失绝对免赔额
							<span class="red-bold">为RMB1000元或损失金额的10%（两者取高者为准），</span>
							每次事故人身伤亡无免赔。
							<span class="red-bold">以下情况不属于第三者责任的保障范围：</span>
							(1)服务工单机器的损坏； (2)因服务工单机器本身及辅材的产品质量问题导致的第三者人身伤亡及财产损失；
							(3)冷库、冷却塔，以及非家电范畴的机电设备作业导致的财产损失；
							(4)因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡及财产损失；
							(5)装卸、运输货物期间发生意外事故导致的第三者人身伤亡及财产损失；
							(6)第三者直接财产损失不包含第三者要求被保险人赔偿的间接损失，例如交通费、住宿费等；
							(7)因机器安装维修不合格，导致二次上门服务所产生的机器安装维修费用；以及因安装设计和规范问题（开孔尺寸、安装位置、预留尺寸等）造成吊顶拆装、二次装修、破坏美观、客户退货等间接损失；
							(8)以下的第三者财产损失，保险公司不负赔偿责任：手机、手提电脑、相机等移动数码产品；珠宝、玉器、首饰、古玩、字画、艺术品、收藏品、稀有金属等珍贵财物以及无法鉴定价值的财产；动物、植物。
							<span class="red-bold">
								(9)无论工单是否完成，在保人员离开用户家后发生或发现的因安装维修导致的意外事故造成的第三者人身伤亡及财产损失。
							</span>
							本项扩展责任下，第三者是指除被保险人及其关联单位和关联人员以外的，被保险人的工作服务对象；或与被保险人、投保人员毫无任何关联关系(包括但不限于亲属、朋友、同事、合作伙伴等关系)的陌生人。
							3.4.16扩展法律费用条款：在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
							3.4.17扩展24小时意外条款：扩展承保被保人员因主险条款第五条约定情形以外的意外伤害事故导致死亡、伤残和医疗费赔偿，保险人在对应保障项目的赔偿限额之内以被保险人实际赔偿金额为限承担赔偿责任；其中，伤残评定标准参照《人身保险伤残评定标准》（中保协发〔2013〕88号）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。对于涉及第三方责任的情形，本扩展责任仅作为补充保障，按被保人员所承担的责任比例进行补充赔偿。
							除外责任:
							<span class="red-bold">(1)非工作原因（如游泳、戏水、游玩、娱乐和旅行等原因）导致的个人意外；</span>
							<span class="red-bold">(2)发生保险事故时被保人员实际工作的危险程度高于本产品适用情况的；</span>
							(3)本保单对以下原因直接或间接导致被保人员死亡或人身伤害不负赔偿责任：
							<span class="red-bold">战争、战乱、</span>
							反叛、罢工、暴乱、动乱以及核辐射等；疾病、传染病、生育、怀孕、医疗以及手术等；故意自残、自杀以及因药物或酒精导致的犯罪或失常行为；打架、酗酒、吸毒、以及精神错乱。
							本项扩展责任与主险条款内容相悖之处，以本条扩展责任的特约为准；未尽之处，以主险条款为准。
							<h4>3.5 责任免除</h4>
							<span class="red-bold">由于下列原因造成的任何损失、费用或赔偿责任，保险人不负责赔偿：</span>
							(1)投保人、被保险人或其法人、代理人的违法行为、犯罪行为、故意行为或重大过失行为；
							(2)战争、敌对行动、军事行动、武装冲突、罢工、暴动、民众骚乱、恐怖活动；
							(3)核辐射、核爆炸、核污染，或其他放射性、有毒、易爆物质的污染或影响； (4)行政行为、司法行为；
							(5)接触、使用石棉（包括石棉制品、石棉纤维等含有石棉成份的物质）或硅（包括硅产品、硅石粉尘等以任何形态存在的硅）；
							(6)传染病、分娩、流产、保单已承保的职业病以外的其他疾病（包括免疫系统疾病及精神疾病），以及因前述原因而接受医疗、诊疗。
							<span class="red-bold">
								保险事故发生时，被保险人的雇员存在下列情形之一，并因此导致人身损害的，保险人不承担赔偿责任：
							</span>
							（一）自杀、自残、打架、斗殴、受酒精或毒品的影响； （二）故意行为、违法行为、犯罪行为；
							（三）进行下列高风险运动、活动：
							1、从事潜水、登山、滑水、滑雪、滑冰、滑板、滑翔、跳伞、攀岩、蹦极或其他类似的极限运动； 2、进行探险活动；
							3、进行摔跤、柔道、空手道、跆拳道、拳击或其他类似的搏击运动； 4、进行需要经过特别训练的特技表演；
							5、参与任何职业、半职业或专业的体育运动；
							6、进行赛马、各种车辆表演、车辆竞赛或练习、驾驶卡丁车等高风险运动。
							（四）未遵医嘱，私自过量或不足量服用、涂用、注射药物或进行任何非治疗工伤所必须的手术；
							（五）无驾驶证，驾驶证失效或者被依法扣留、暂扣、吊销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车；
							（六）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的；
							<span class="red-bold">下列损失、费用和责任，保险人不承担赔偿责任：</span>
							（一）被保险人对本合同生效前已发生事故的赔偿责任；
							（二）除本合同列明负责赔偿的项目外，其他超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；
							（三）精神损害赔偿及任何性质的罚款、罚金、惩罚性赔偿；
							（四）被保险人因合同或协议（含劳动合同、用工协议等）的约定而应承担的赔偿责任，但无该合同或协议的存在被保险人依法仍应承担的赔偿责任不受此限；
							（五）被保险人的任何间接损失； （六）被保险人应自行承担的免赔额。
							（七）被保险人员工因驾驶各种机动车辆（仅指领有公共牌照在公路上行驶的机动车辆）造成第三者人身伤亡或财产损失所引起的赔偿责任；
							（八）被保险人员工因从事医师、律师、会计师、建筑师、美容师等其他专门职业造成第三者人身伤亡或财产损失，所引起的赔偿责任。
							<span class="red-bold">其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。</span>
							<h4>3.6 保单形式</h4>
							本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
							<h4>3.7 发票形式</h4>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
							<h3>四、理赔</h3>
							出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							<h3>五、其他信息</h3>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
							5.2
							若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
						</div>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<div v-else-if="insureType == 7">
			<el-card header="投保须知及声明">
				<el-row>
					<el-col :span="23">
						<div style="line-height: 26px; white-space: pre-line">
							<span style="font-weight: bold">
								本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪有限公司（以下简称“博维”）进行销售
							</span>
							（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
							太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2022年2季度，公司综合偿付能力充足率225.2%，满足监管要求，最近一期的风险综合评级结果为AA。
							<h3>一、重要告知</h3>
							<span style="font-weight: bold">
								1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。 1.2
								<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
								1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。 1.4
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
								1.5
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
								1.6
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，但应当退还保险费。
								1.7
								保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
							</span>
							<h3>二、产品信息</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">备案名称</th>
									<th style="width: 50%; padding: 5px 0">注册号</th>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">中国太平洋财产保险股份有限公司雇主责任保险（2016版）条款</td>
									<td style="padding: 5px 0">C00001430912016110806772</td>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">中国太平洋财产保险股份有限公司雇主责任保险附加法律费用额外增加条款</td>
									<td style="padding: 5px 0">H00001430922017052494811</td>
								</tr>
							</table>
							<h3>三、产品介绍</h3>
							<h4>3.1 投保人/被保险人</h4>
							售后服务网点（单位）为保险合同的投保人/被保险人。
							<h4>3.2 保险期限</h4>
							自生效日起，保险期限可选择1个月、2个月或（最长）3个月。
							<h4>3.3 特别约定</h4>
							3.3.1在保险期间内，被保险人的在保雇员因从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）而遭受意外事故，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.3.2本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、法律费用，每项保障项目的赔偿限额以保单载明为准。
							3.3.3本保单的共同被保险人包括保单约定的被保险人及其分销商、二级网点，应在投保时列明在保单中。对于未列明的，在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料，如不能提供证明材料的则不视为共同被保险人。
							3.3.4本保单采用记名承保，可承保人员包括正式在册职工、短期工、临时工、季节工、学徒工、负责人、法人代表和个体工商户经营者本人。
							3.3.5鉴于被保险人的行业风险特性，本保单所定的保险费率已为最低收费，即短期保费等于保单保费。本保单申请退保可退保费为0，本保单不可进行人员批增、替换和批减。
							3.3.6被保险人须按投保雇员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保雇员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。
							3.3.7
							国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业”。保险人仅对投保高空方案的被保人员承担高处作业的保险责任，投保高空方案的在保雇员从事高处作业发生的保险事故，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.3.8鉴于家电售后移动作业的行业特性，被保险人须在发生保险事故48小时内向保险人报案，且须提供包含派工单位、服务人员、服务时间、用户姓名、联系电话、服务地址等信息在内的不可逆的真实派工记录。否则，保险人有权拒赔或对无法核实保险责任的损失不承担赔偿责任。
							3.3.9被保险人的在保雇员从事高处作业时，因未系挂安全带导致的死亡事故，须免赔10%。
							3.3.10在保险期间内，发生保险责任范围内的保险事故，导致在保雇员死亡或伤残，保险人按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。
							伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家及当地社保部门规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿以死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人应提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。
							3.3.11本保单特约伤残等级赔付限额比例：一级100%；二级90%；三级80%；四级70%；五级60%；六级50%；七级40%；八级30%；九级20%；十级10%。伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。
							3.3.12医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。
							3.3.13医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按100%比例给付医疗保险金。如被保险人或出险人员已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。
							3.3.14自费药品赔付特别约定：本保单在医疗费用项下扩展承保合理且必要的自费药品，保单约定的每人医疗费用责任限额不变。自费药品定义为：除社保甲、乙类用药以外的，合理且必须药品的自费部分，不包括各种营养滋补类的药品、保健品。
							3.3.15误工费赔付特别约定：在保险期间内，发生保险责任范围内的保险事故，导致被保雇员暂时丧失工作能力并住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的建议休息证明或由保险人依据《人身损害误工期、护理期、营养期评定规范》GA/T
							1193-2014，核定误工天数，保险人按照人民币100元/人/天的标准，以最长180天为限计算误工费。误工费计算包含住院期间以及出院后的休息误工时间，其中出院后休息误工时间取医嘱建休时间、实际误工时间及人身损害误工费评定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据前述第(10)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险员工的工资证明。出险员工仅在门诊治疗的，无误工费赔付。
							3.3.16扩展工伤事故：被保险人的在保雇员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。
							3.3.17上下班途中扩展：兹经双方同意，对于被保险人的在保雇员在境内，不包括我国香港、澳门和台湾地区，因工外出期间由于工作原因遭受意外事故及上下班途中遭受意外事故而导致被保险人依法应承担的经济赔偿责任，保险人按照主险条款规定负责赔偿。
							3.3.18扩展法律费用条款：在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
							3.3.19扩展24小时个人意外：在保险期间内，被保险人的在保雇员发生主险条款第五条约定情形以外的意外事故而导致的死亡(或自人身伤害发生之日起在180个日内发生死亡)、伤、残，保险人以主险各保障项目的赔偿限额为限承担赔偿责任。其中，伤残评定标准参照《人身保险伤残评定标准》（中保协发〔2013〕88号）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。本保单所载其他条件均不变。
							除外责任: 本保单对以下原因直接或间接导致被保人员死亡或人身伤害不负赔偿责任：
							(1)战争、战乱、反叛、罢工、暴乱、动乱以及核辐射等； (2)疾病、传染病、生育、怀孕、医疗以及手术等；
							(3)故意自残、自杀以及因药物或酒精导致的犯罪或失常行为； (4)打架、酗酒、吸毒、精神错乱以及高危险运动；
							高危险运动包括但不仅限于： -航空飞行，乘坐民航飞机除外； -使用呼吸器具的潜水活动；
							-足球，以业余身份参加除外； -滑翔运动； -冰上曲棍球； -摩托车竞赛； -登山、攀岩、攀崖； -跳伞；
							-地穴探险； -汽车竞赛； -以运动为职业； -滑水、跳水及水上竞技； -冬季运动，冰上溜石活动和溜冰除外；
							本附加险条款与主险条款内容相悖之处，以本附加险条款为准；未尽之处，以主险条款为准。
							<h4>3.4 保单形式</h4>
							本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
							<h4>3.5 发票形式</h4>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
							<h3>四、理赔</h3>
							出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							<h3>五、其他信息</h3>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
							5.2
							若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
						</div>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<div v-if="insureType == 19">
			<el-card header="投保须知及声明">
				<div style="line-height: 26px; white-space: pre-line">
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<div style="line-height: 32px; white-space: pre-line">
						1、本保险适用以下保险条款： 2、本保险由中国太平洋财产保险股份有限公司承保，
						<span class="red-bold">仅限承保营业执照注册地址在广东的企业和组织</span>
						。
						3、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
						4、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；
						<span class="red-bold">
							故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；
						</span>
						因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
						5、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
						6、本保险根据投保单位的需求提供电子发票或纸质专票。 7、本保险由博维保险经纪有限公司面向
						<span class="red-bold">广东省内销售并提供服务</span>
						，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。 8、
						<span class="red-bold">
							鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。在保单生效后申请退保或批减在保人员的，可退保费为0。
						</span>
						9、中途可以增加保障人员。
						<span class="red-bold">保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。</span>

						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr style="text-align: center">
								<th>批增收费比例</th>
								<th v-for="item in 12">{{ item }}个月</th>
							</tr>
							<tr style="text-align: center">
								<td>1-3类</td>
								<td v-for="item in questionDataRate">{{ item }}</td>
							</tr>
							<tr style="text-align: center">
								<td>4-5类</td>
								<td v-for="item in questionDataRate">{{ item }}</td>
							</tr>
							<tr style="text-align: center">
								<td>6类</td>
								<td v-for="item in questionDataRate">{{ item }}</td>
							</tr>
						</table>
						10、
						<span class="red-bold">
							本保单不承保职业：船舶制造人员
							、玻璃、陶瓷、搪瓷制造业人员、涉及爆破的相关工作人员，如作业内容含有保险人不承保的职业类别，保险人不承担任何赔偿责任。
						</span>
					</div>
					<el-divider></el-divider>
					<h3>特别约定</h3>
					<div>
						<h4>1、保障期限：</h4>
						自所投保雇主责任保险生效日起，保险期限为一年。
						<h4>2、特别特约：</h4>
						（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人
						<span class="red-bold">超过72小时才报案</span>
						，则保险人对按保单约定的应承担的保险责任，
						<span class="red-bold">免赔50%</span>
						。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
						（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
						（3）鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。
						<span class="red-bold">在保单生效后申请退保或批减在保人员的，可退保费为0。</span>
						（4）本保单仅承保制造相关行业。 （5）被保险人从业人员遭受伤害时，
						<span class="red-bold">
							实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，则保险人根据实际从事工作职业类别与保单约定职业类别的级差，按每一个级差扣减保额20%免赔（比如实际6类投保4类，需扣减40%免赔，以此类推）。如实际工作属于拒绝承保职业，保险人不承担任何赔偿责任。
						</span>
						（6）在工作时间和工作岗位，
						<span class="red-bold">
							突发疾病死亡或者在48小时之内经抢救无效死亡（从业人员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔款=每人身故赔偿限额*20%。
						</span>
						（7）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准100%赔付。
						（8）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
						<span class="red-bold">被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付。</span>
						（9）
						<span class="red-bold">
							被保险人从业人员从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证）
						</span>
						，否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，
						<span class="red-bold">免赔25%。</span>
						（10）
						<span class="red-bold">本保单指定就诊医院为大陆境内二级及以上公立医院。</span>
						如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
						（11）兹经双方协商同意，鉴于投保人已支付相应保费，保险人扩展承保被保险人雇员在24小时内因意外事故到医院治疗被保险人依法应承担的经济赔偿责任，
						<span class="red-bold">
							24小时意外事故医疗责任与雇主工伤医疗责任共用限额，最高不超过保单列明的工伤医疗责任限额。
						</span>
						24小时意外事故医疗责任
						<span class="red-bold">
							不负责赔偿误工费、住院伙食费、生活护理费、转院就医食宿交通费、残疾辅助器具费用等其他费用。
						</span>
						（12）本保单伤残赔偿金：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级而支付相应赔偿金。相应的赔偿限额为该伤残等级所对应的下列“伤残等级赔偿限额比例表”的比例乘以每人死亡赔偿限额所得金额。本保单适用伤残赔付比例按：一级伤残 100％，二级伤残 80％，三级伤残 70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，
						<span class="red-bold">八级伤残20％，九级伤残10％，十级伤残 5％。</span>
						（13）本保单附加24小时个人意外事故条款，扩展承保被保险人的雇员在24小时内遭受意外事故造成的永久性伤残和死亡。其中，伤残评定标准参照《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。
						<span class="red-bold">
							24小时个人意外事故死亡伤残责任与雇主工伤死亡伤残责任共用限额，每人最高不超过保单列明的雇主工伤死亡伤残责任限额的50%。对由于被保险人直接承担的因为被保险人的雇员从事的下列活动引起的责任，本保险不负责赔偿:打猎、登山、任何形式的竞赛、滑雪、酗酒、服用药物或狂欢。
						</span>
						（14）本保单承保法律费用责任，
						<span class="red-bold">累计赔偿限额为RMB10万元</span>
						，每次事故赔偿限额为RMB10万元。 （15）太平洋产险全国统一客户投诉电话：95500语音提示或按#号键-3-2-4。
						<h4>3、责任免除：</h4>
						<span style="font-weight: bold">
							第一条 由于下列原因造成的任何损失、费用或赔偿责任，保险人不负责赔偿：
							（一）投保人、被保险人或其法人、代理人的违法行为、犯罪行为、故意行为或重大过失行为；
							（二）战争、敌对行动、军事行动、武装冲突、罢工、暴动、民众骚乱、恐怖活动；
							（三）核辐射、核爆炸、核污染，或其他放射性、有毒、易爆物质的污染或影响； （四）行政行为、司法行为；
							（五）接触、使用石棉（包括石棉制品、石棉纤维等含有石棉成份的物质）或硅（包括硅产品、硅石粉尘等以任何形态存在的硅）；
							（六）传染病、分娩、流产、保单已承保的职业病以外的其他疾病（包括免疫系统疾病及精神疾病），以及因前述原因而接受医疗、诊疗，但主条款第五条第（七）款不受此限。
							第二条 保险事故发生时，被保险人的雇员存在下列情形之一，并因此导致人身损害的，保险人不承担赔偿责任：
							（一）自杀、自残、打架、斗殴、受酒精或毒品的影响； （二）故意行为、违法行为、犯罪行为；
							（三）进行下列高风险运动、活动：
							1．从事潜水、登山、滑水、滑雪、滑冰、滑板、滑翔、跳伞、攀岩、蹦极或其他类似的极限运动； 2．进行探险活动；
							3．进行摔跤、柔道、空手道、跆拳道、拳击或其他类似的搏击运动； 4．进行需要经过特别训练的特技表演；
							5．参与任何职业、半职业或专业的体育运动；
							6．进行赛马、各种车辆表演、车辆竞赛或练习、驾驶卡丁车等高风险运动。
							（四）未遵医嘱，私自过量或不足量服用、涂用、注射药物或进行任何非治疗工伤所必须的手术；
							（五）无驾驶证，驾驶证失效或者被依法扣留、暂扣、吊销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车；
							（六）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的。 第三条
							下列损失、费用和责任，保险人不承担赔偿责任： （一）被保险人对本合同生效前已发生事故的赔偿责任；
							（二）除本合同列明负责赔偿的项目外，其他超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；
							（三）精神损害赔偿及任何性质的罚款、罚金、惩罚性赔偿；
							（四）被保险人因合同或协议（含劳动合同、用工协议等）的约定而应承担的赔偿责任，但无该合同或协议的存在被保险人依法仍应承担的赔偿责任不受此限；
							（五）被保险人的任何间接损失； （六）被保险人应自行承担的免赔额。 第四条
							其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。
						</span>
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="insureType == 21">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<p style="text-align: left; text-indent: 2em">
						本产品由中国太平洋财产保险股份有限公司（以下简称“太平洋产险”）承保，由太平洋产险委托博维保险经纪（以下简称“博维”）有限公司进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
					</p>
					<p style="text-align: left; text-indent: 2em">
						太平洋产险成立于1991年，总部设在上海，注册资本为人民币194.70亿元。公司在拥有41家分公司，1家航运保险事业营运中心。截至2019年末，公司综合偿付能力充足率293%，满足监管要求。公司标准普尔的发行人信用评级及财务实力评级结果为A，穆迪投资者服务公司的保险财务实力评级结果为A1，中诚信国际信用评级的主体信用等级为AAA。
					</p>
					<div>
						<div style="font-weight: bold">一、重要告知</div>
						<p>1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。</p>
						<p>
							1.2
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
						</p>
						<p>1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。</p>
						<p>
							1.4
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
						</p>
						<p>
							1.5
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
						</p>
						<p>
							1.6
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
						</p>
						<p style="font-weight: bold">
							1.7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
						</p>
						<div style="font-weight: bold">二、产品信息</div>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">注册号</th>
							</tr>
							<tr>
								<td style="text-align: center">中国太平洋财产保险股份有限公司雇主责任保险条款</td>
								<td style="text-align: center">H00001430912017052483431</td>
							</tr>
						</table>
						<div style="font-weight: bold">三、产品介绍</div>
						<p style="font-weight: bold">3.1 投保人/被保险人</p>
						<p>电梯行业企业</p>
						<p style="font-weight: bold">3.2 保险期限</p>
						<p>自生效日起，保险期限可由企业根据实际用工需求，选择1个月、3个月、6个月、12个月。</p>
						<p style="font-weight: bold">3.3 特别约定</p>

						<p style="line-height: 32px; white-space: pre-line">
							1、
							<span class="red-bold">
								本保单被保险人应在保险事故发生后 48 小时内报案，如超出
								48小时报案导致保险人无法核实事故真实情况，则保险人有权拒赔。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，
							</span>
							扣除绝对免赔50%后赔付。 2、
							<span class="red-bold">出险后，被保险人必须在72小时内报案，报案服务咨询可拨打本保单</span>
							400-180-1616或太平洋产险全国统一客服电话95500，
							<span class="red-bold">
								取得报案号后才是报案成功（否则报案失败）。如果被保险人委托第三人/第三方报案，事后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第1条特别约定扣除免赔，那么被保险人须自行承担相关损失。
							</span>
							3、本保单被保险人雇员为电梯安装、维修保养人员，投保年龄限16-65周岁（含），与被保险人签订有劳动合同或存在事实劳动关系，接受被保险人给付薪金、工资，包括正式在册职工、短期工、临时工、季节工和徒工等相关工作人员。本保单采用记名承保，投保人数不少于3人。
							4、本保单仅承保以下工种（含高处作业）：电梯安装工、电梯维修保养工(含立体车库工程人员）。
							5、本保单不可减人，可加人。保单可换人，已出险人员不得批减、替换、退保。
							<span class="red-bold">
								保险期限1-3个月（含）的保单不可换人，保险期限超过3个月的保单可以换人，换人规则：电梯安装维修人员可替换为新的电梯安装维修人员。
							</span>
							6、本保单批增按以下年单保费的比例进行收费：不足一个月按一个月收费。
							<avue-crud :data="dataAddFeeRate" :option="optionAddFeeRate" style="padding: 10px"></avue-crud>
							7、保单未到期前，如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。
							8、
							<span class="red-bold">
								本保单仅承保电梯安装维修行业人员（含高处作业、含立体车库工程人员）。本保单承保的电梯工程如家用电梯、商业楼宇和旧楼改造的载人载货电梯、自动手扶梯、自动人行道的电梯安装、维修工程和立体车库工程。具体承保工种为：电梯安装维保工。本产品可承保工种以太保职业分类表为准，本保单雇员投保的工种以保单的雇员清单为准。
							</span>
							9、
							<span class="red-bold">
								本保单只承保在进行电梯安装维修、立体车库工程施工中发生的保险事故，进行其他施工过程中发生的保险事故为除外责任。
							</span>
							10、
							<span class="red-bold">
								本保单不承保电梯安装前的工程（如土建工程、钢结构工程、幕墙安装工程）、电梯拆除工程、工地升降机安装维修工程。如施工合同中的项目名称含有保险人不承保的工程字眼，如“钢结构”、“电梯拆除”等或施工项目包含钢结构相关作业、电梯拆除作业等保险人不承保的工程作业，保险人不承担该保单的任何赔偿责任。
							</span>
							11、本保单指定就诊医院为大陆境内二级及以上公立医院，如因危及生命的紧急抢救（达到住院标准）无法前往本保单指定就诊医院的，经急救、情况基本稳定后72小时内，须转入本保单指定就诊医院治疗。
							12、在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔付金额=每人身故赔偿限额*20%。
							13、在保险期间内，被保险人的在保员工在受雇过程中因从事被保险人所安排的企业经营范围内的
							<span class="red-bold">电梯安装维修、立体车库工程工作</span>
							（不限电梯品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							14、在上下班途中，受到非员工本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的，属于保险责任。
							15、在保险期间内，发生保险责任范围内的意外事故，保险人按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。
							伤残：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度：永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残
							给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。
							16、医疗费用:本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用，但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。每次医疗费用在社保用药内100%比例赔付。
							17、自费药：医疗费用如有其他第三方先行赔付的，本保险医疗费用项下扩展自费药；如医药费用无其他第三方先行赔付的，则本保单不予扩展赔付自费药：
							（1）每次事故赔偿限额为2000元； （2）我司和第三方赔付金额合计不超过医疗费发票总额；
							（3）每次事故自费药赔付金额不超过第三方赔付的医疗费用金额；
							（4）自费药为超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品
							目录、医疗服务设施范围和支付标准的合理且必要的医疗费用。
							18、误工费用：误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，免赔天数0天，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算仅依据住院期间、出院后的休息误工期间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且自伤残鉴定结果日期起停止误工费的计算。被保险人雇员仅接受门诊治疗的，无误工费赔付。
							19、电梯安装、电梯维修保养过程中从事高处作业必须配带安全带、安全帽，孔洞须加强围栏或防滑措施。出险时如未系绑安全带导致发生身故或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							20、
							<span class="red-bold">
								电梯安装人员须经过岗前安全培训，合格后方可上岗,发生伤残和死亡时须提供企业培训记录；电梯维保工作人员发生伤残和死亡时须提供电梯修理T证（由市场监督管理局或质量技术监督局颁发），否则保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。
							</span>
							21、本保单不承担任何性质的精神损害赔偿责任。
							22、兹经合同双方同意，因保险合同纠纷提起的诉讼，由被告住所所在地的人民法院管辖。 23、
							<span class="red-bold">
								如您不幸发生事故，或需要咨询保险相关事宜，请及时拨打服务热线：400-180-1616，获取工作人员的帮助。
							</span>
							24、
							<span class="red-bold">太平洋产险全国统一客户投诉电话：95500语音提示或按＃号键-3-2-4。</span>
						</p>

						<p style="font-weight: bold">3.4 保单形式</p>
						<p>
							<strong style="color: red">
								本产品提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。
							</strong>
							投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
						</p>
						<p style="font-weight: bold">3.5 发票形式</p>
						<p>本产品提供电子发票。</p>
						<div style="font-weight: bold">四、理赔</div>
						<p>
							<strong style="color: red">
								出险后请您尽快通过微信小程序“线上快赔”，或拨打博维客服热线400-180-1616进行报案
							</strong>
							，根据指示提交理赔资料，保险公司将审核案件并对于属于保险公司的保险责任的进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
						</p>
						<div style="font-weight: bold">五、其他信息</div>
						<p>
							5.1
							保险人将严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，确保投保人提供的个人信息、数据和隐私不受到非法的泄露或未经投保人/被保险人同意披露给未授权的第三方。
						</p>
						<p>
							5.2
							<span class="red-bold">
								若投保及后续服务和理赔过程中出现争议情况，可致电博维客服热线400-180-1616或太平洋产险客户服务及投诉热线：95500，我们将安排专人跟进处理。
							</span>
						</p>
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="insureType == 22">
			<el-card header="投保须知及声明">
				<div>
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<div style="line-height: 32px; white-space: pre-line">
						<span class="red-bold">1、投保地区</span>
						本产品仅限在中国大陆注册的合法机构购买，
						<span class="u-font-weight-bold">实际注册或经营地址在以下地区的单位本产品不予承保</span>
						：天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。
						<span class="red-bold">2、生效时间</span>
						线上投保成功后，最早T+2生效。
						<span class="red-bold">3、保单保全</span>
						<span class="red-bold">已发生理赔的人员不可以被替换和批减。线上保全次日生效。</span>
						<span class="red-bold">4、年龄结构</span>
						<span class="red-bold">
							本产品3人起保，投保年龄：16-65周岁身体健康、能正常工作或正常生活的自然人。如无法证明合法劳动或雇佣关系，本保单不承担赔偿责任；
						</span>
						61（含）-65周岁（含）雇员占比不得超过总投保人数的10%，若雇员年龄超过60岁（含），各项责任限额为50%。
						<span class="red-bold">5、行业限制</span>
						本产品仅承保1-5类职业类别雇员，职业分类表以我司为准，具体可承保职业以保险公司核保结果为准。
						5类职业雇员每人伤亡责任限额最高可投50万。
						<span class="red-bold">6、承保公司及适用条款</span>
						本产品由泰康在线财产保险股份有限公司承保，泰康在线财产保险股份有限公司为在线经营的互联网保险公司，无线下分支机构，各项保险服务流程均可线上操作，不影响您的理赔，但在您所在的地区，可能无法直接提供及时的面对面线下服务。
						本产品适用条款如下:
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px">
							<tr>
								<th style="width: 50%">备案名称</th>
								<th style="width: 50%">备案编号</th>
							</tr>
							<tr>
								<td style="text-align: center">《泰康在线财产保险股份有限公司雇主责任保险（C款）》</td>
								<td style="text-align: center">C00019930912022120268661</td>
							</tr>
							<tr>
								<td style="text-align: center">《泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险》</td>
								<td style="text-align: center">C00019930922021063099022</td>
							</tr>
							<tr>
								<td style="text-align: center">《泰康在线财产保险股份有限公司附加行业十级伤残鉴定标准保险》</td>
								<td style="text-align: center">C00019930922019062517642</td>
							</tr>
							<tr>
								<td style="text-align: center">
									《泰康在线财产保险股份有限公司雇主责任保险附加每日住院津贴保险（互联网专属）》
								</td>
								<td style="text-align: center">C00019932522021122225403</td>
							</tr>
							<tr>
								<td style="text-align: center">《泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）》</td>
								<td style="text-align: center">C00019930922021092202223</td>
							</tr>
						</table>

						<span class="red-bold">7、保单形式</span>
						网上投保为您提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。您可以登录www.tk.cn自助查询对电子保单的真实性进行验证。产品保险合同将以电子保单和电子普通发票的形式提供，专票出具后进行邮寄。
						<span class="red-bold">8、如实告知</span>
						<span class="red-bold">
							您应如实填写投保信息，并就保险公司提出的询问据实告知,否则保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任：
							（1）订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。
							（2）投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。
							（3）投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
							（4）投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。
						</span>
						<span class="red-bold">9、相关授权</span>
						如您投保此保险，视为您本人授权泰康在线出于提升保险服务质量之目的，合法的从任何单位、组织和个人获取您有关的资料和证明，作为审核投保、处理理赔及提供与本保险有关其他服务的依据。
						<span class="red-bold">10、信息变更</span>
						如果您的邮件地址、通信地址、邮编、联系电话发生变化，请与本公司客户服务电话95522-3联系，办理变更事宜。
						<span class="red-bold">11、偿付能力信息披露</span>
						保险公司最新季度综合偿付能力充足率、风险综合评级评价结果等信息，请登录保险公司偿付能力信息披露页面http://channel.tk.cn/page/notice/index.html进行查询。
						<span class="red-bold">12、增值税告知</span>
						本保险产品您所缴纳的保费为含税保费，其中包含6%增值税。
						<span class="red-bold">13、反洗钱告知</span>
						本保险产品保费超过人民币20万元时，需提供单位负责人身份证明。 1）企业营业执照； 2）法人身份证正反面照片；
						3）负责人身份证正反面照片； 4）经办人身份证正反面照片； 5）受益人身份证正反面照片；
						6）泰康在线非自然人客户受益所有人信息采集表。
						<span class="red-bold">14、信息安全</span>
						泰康在线严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。
						<span class="red-bold">15、投诉渠道</span>
						您在购买产品过程中，如发现泰康在线有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向泰康在线投诉，投诉电话：95522-3。
						<span class="red-bold">16、争议处理</span>
						因履行本合同发生的争议，由当事人协商解决，协商不成的，提交武汉仲裁委员会仲裁。
					</div>
					<el-divider></el-divider>
					<h3>特别约定</h3>
					<span class="red-bold"></span>
					<p style="line-height: 32px; white-space: pre-line">
						1、
						<span class="red-bold">
							本产品仅限在中国大陆注册的合法机构购买，实际注册或经营地址在以下地区的单位本产品不予承保：
						</span>
						天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。
						2、投保人及被保人名称中含有以下所列关键词的:钢铁、建筑、钢丝绳、钢绳、危险品、渔业、爆破、幕墙、脚手架、建设、石材、拆、矿业、采石、劳联、产联、疏浚、铁塔、电梯、造船、船舶维修、船舶修造、船舶工程、船务、重工，保险公司不予承保。
						3、本方案3人起保，承保雇员需为16周岁（含）-65周岁（含）身体健康、能正常工作或正常生活的自然人，雇员需提供清单记名投保，61（含）-65周岁（含）雇员占比不得超过总投保人数的10%，若雇员年龄超过60岁（含），各项责任限额为50%。
						4、本保险所指的雇员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员、个体工商户的负责人、法人代表或个体工商户营业执照上列明的经营者等与被保险人存在实际雇佣关系的工作人员。
						5、被保险雇员必须与被保险人存在实际雇佣关系，否则，保险公司有权拒绝赔偿。
						6、同一保险期间内，同一雇员只允许购买一份保单。
						7、本保险承保雇员的职业范围：《职业分类表》中的1-5级职业等级（标注拒保的除外）；雇员是否涉高以保单中雇员清单信息约定为准，如保单中约定雇员不涉高，出险时雇员从事高处作业，保险人不承担赔偿责任。高处作业以《高处作业分级标准》(中华人民共和国国家标准GB3608-2008)中的定义为准(在距坠落高度基准面2m或2m以上有可能坠落的高处进行作业)。若不属于本保险承保雇员的职业范围请勿投保；
						<span class="red-bold">
							如出险时被保险人的雇员工作类型所对应的职业属于本产品拒保职业的，保险人不承担赔偿责任，拒保职业清单详见保单。
						</span>
						8、本保险医疗费用每次免赔200元，赔付比例100%。
						9、经医院证明，误工费每次事故免赔3天，赔偿公式为：每日赔偿限额（每日赔偿限额在保单中约定）×(实际暂时丧失工作能力天数-3天)，每次不超过90天，累计不超过180天，该雇员在评定伤残等级后，本项赔偿责任终止。
						10、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承担赔偿责任。对身故、伤残案件，能核实事故真实情况，但报案超过案发时间72小时（含）以上的，按损失金额的50%免赔后进行赔付；对非身故、伤残的其他案件，能核实事故真实情况，但报案超过案发时间1个月以上（含1个月）的，按损失金额的50%免赔后进行赔付。本特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准。
						11、本保险项下，医疗费用的赔付范畴依据被保险人所在省份的基本医疗保险的相关药品目录及诊疗项目目录及其相应比例执行。除紧急抢救外，被保险人均应在二级以上（含二级）医院或保险人认可的医疗机构就诊。未在保险人认可的医疗机构就诊的，保险人有权拒绝赔付。北京平谷区、密云区，河北省廊坊市、青龙县、三河市，天津滨海区、静海区，辽宁铁岭市，山东禹城市、招远市、荣成市，河南信阳市下辖的各医疗机构，不在保险公司认可医院范围内，即上述地区医疗机构的医疗发票、伤残鉴定报告、死亡事故说明等均不属于保险公司理赔范畴，且不承担任何保单责任。
						12、本保单承保被保险人雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（既往症原因除外），本保单项下雇员赔偿限额不超过30万。既往症原因导致的猝死不属于本保单赔偿范围。既往症指如下情况：被保险人的雇员患有恶性肿瘤、心脏病（心功能不全II级及II级以上）、心肌梗塞、白血病、高血压病（2级以上）、肝硬化、慢性阻塞性肺疾病、脑血管疾病、慢性肾脏疾病、糖尿病、再生障碍性贫血、先天性畸形、变形和染色体异常、精神和行为障碍（依照世界卫生组织《疾病和有关健康问题的国际统计分类（ICD-10）》确定）、《中华人民共和国传染病防治法》规定的甲类及乙类传染病(含艾滋病)、癫痫病及正患病住院及全休、半休状态。
						13、本产品承保的雇员因交通事故发生的死亡、伤残、医疗案件，对出险的雇员属于工伤保险认定范围内的交通事故进行赔偿。
						14、本产品承保雇员以附件上传名单为准，若本保单被保险人雇员实际职业类别高于保单人员清单列明职业类别的，保险人退还保险费，不承担保险责任。
						15、从事5类及以上特种作业岗位和高空岗位，按照国家规定须具有特种作业证和高空作业证，出险时如未能提供特种作业证和高空作业证，免赔率为80%。
						16、本保单可以增人，增人按日计费。保险期限1-3个月的保单不可减人和换人，保险期限超过3个月的保单可以减人或换人，换人规则：
						<span class="red-bold">
							替换的人员职业等级需一致，不同职业等级人员之间不可互换；已替换出的人员不允许再次替换或批增。已批减的人员不允许替换或再次批增。已出险人员（含已报案未理赔和已理赔）不可以被替换和批减。线上保全次日生效。
						</span>
						17、如附加《泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）》保险时，该附加险项下评残标准同样适用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014），按照工伤伤残赔偿标准确定残疾赔偿金，最高以每人伤亡责任限额乘以伤残等级对应的比例为限，伤残等级赔偿限额比例表：一级伤残100%、二级伤残80%、三级伤残70%、四级伤残60%、五级伤残40%、六级伤残30%、七级伤残20%、八级伤残15%、九级伤残7%、十级伤残5%。（如未附加，本条无效）
						18、如附加《泰康在线财产保险股份有限公司附加行业十级伤残鉴定标准保险》保险时，该附加险项下评残标准同样适用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014），按照工伤伤残赔偿标
						准确定残疾赔偿金，最高以每人伤亡责任限额乘以伤残等级对应的比例为限，伤残等级赔偿限额比例表：一级伤残100%、二级伤残90%、三级伤残80%、四级伤残70%、五级伤残60%、六级伤残50%、七级伤残40%、八级伤残30%、九级伤残20%、十级伤残10%。（如未附加，本条无效）
						19、如附加《泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险》保险时，该附加险项下：包含死亡伤残、意外医疗费和误工费保障；每人死亡伤残、医疗费和误工费赔偿限额与主险责任限额相同。该附加险项下意外伤残事故评残标准为人身保险伤残评定标准（行业标准）（中保协发（2013）88号）。（如未附加，本条无效）.
						20、每日住院津贴保险责任每次事故免赔3天，单次不超90天，累计不超180天，对于雇员的挂床行为，保险人不承担住院津贴给付的保险责任。
					</p>
					<el-divider></el-divider>
					<h3>投保声明</h3>
					<p style="line-height: 32px; white-space: pre-line">
						1、
						<span class="red-bold">
							本公司已完整阅读并了解以上投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本公司已充分理解并接受上述内容，同意以此作为订立保险合同的依据。
						</span>
						2、投保单中所填写的内容均属实，如有隐瞒或不实告知，保险公司有权解除保险合同，对于合同解除前发生的任何事故，保险公司可不承担任何责任。
						3、保险责任开始后，投保人要求解除保险合同的，自通知保险人之日起，保险合同解除，保险人收取自保险责任开始之日起至合同解除之日止期间的按日比例计收的保险费，并退还剩余部分保险费。
						4、本公司同意保险公司通过手机（包括手机短信）、E-mail适时提供保险信息服务。
					</p>
				</div>
			</el-card>
		</div>

		<div v-if="insureType == 23">
			<el-card header="投保须知及声明">
				<div style="line-height: 26px; white-space: pre-line">
					<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
					<div style="line-height: 32px; white-space: pre-line">
						1、本保险适用以下保险条款：
						<el-link
							href="https://mbtest.meibaokeji.com.cn/employer/static/2022images/pdf/sunlight.pdf"
							target="_blank"
							type="primary">
							阳光财产保险股份有限公司雇主责任保险B款条款
						</el-link>
						2、本保险由阳光财产保险股份有限公司承保，
						<span class="red-bold">仅限承保营业执照注册地址在广东的企业和组织</span>
						。 3、投保要求：企业名称
						<span class="red-bold">不含“装卸”、“搬运”</span>
						。
						4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
						5、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；
						<span class="red-bold">
							故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；
						</span>
						因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
						6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
						7、本保险根据投保单位的需求提供电子发票或纸质专票。 8、本保险由博维保险经纪有限公司面向
						<span class="red-bold">广东省内销售并提供服务</span>
						9、
						<span class="red-bold">
							鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。保单可批增人员（不足1个月的按1个月收费）；在保单生效后申请退保或批减在保人员的，可退保费为0。
						</span>
						10、中途可以增加保障人员。
						<span class="red-bold">保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。</span>
						<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
							<tr style="text-align: center">
								<th>批增收费比例</th>
								<th v-for="item in 12">{{ item }}个月</th>
							</tr>
							<tr style="text-align: center">
								<td>支付比例</td>
								<td v-for="item in questionDataRate">{{ item }}</td>
							</tr>
						</table>
						11、
						<span class="red-bold">
							如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。
						</span>
						12、
						<span class="red-bold">
							本保单不承保以下职业：外卖配送员、快递配送员、平台骑手、平台跑腿人员，如作业内容含有保险人不承保的职业类别工作内容，保险人不承担任何赔偿责任。
						</span>
					</div>
					<el-divider></el-divider>
					<h3>特别约定</h3>
					<div>
						<h4>1、保障期限：</h4>
						自所投保雇主责任保险生效日起，保险期限为一年。
						<h4>2、特别特约：</h4>
						（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人
						<span class="red-bold">超过72小时才报案</span>
						，则保险人对按保单约定的应承担的保险责任，
						<span class="red-bold">免赔50%。</span>
						如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
						（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
						（3）鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。保单可批增人员（不足1个月的按1个月收费）；
						<span class="red-bold">在保单生效后申请退保或批减在保人员的，可退保费为0。</span>
						（4）
						<span class="red-bold">
							如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。
						</span>
						（5）
						<span class="red-bold">
							（可选）本保单不承保货车司机和随车人员参与装卸货物有关工作发生的工伤和意外伤害的赔偿责任。
						</span>
						（6）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准，每次事故医疗费用超过人民币0元部分按100%的比例赔付。
						（7）
						<span class="red-bold">
							被保险人从业人员从事高空（高处）作业时，必须按照国家相关安全管理规定（包括但不限于必须佩戴安全绳、安全带或者安装防护网等安全设施设备）执行；从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），
						</span>
						否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，
						<span class="red-bold">免赔25%。</span>
						（8）本保单承保法律费用责任，累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
						（9）被保险人从业人员遭受伤害时，
						<span class="red-bold">
							实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如实际工作是装卸工或货车司乘人员投保了文员、仓管工种，保险人不承担任何赔偿责任。
						</span>
						（10）在工作时间和工作岗位，
						<span class="red-bold">
							突发疾病死亡或者在48小时之内经抢救无效死亡，保险人承担赔偿责任，每人最高赔偿限额=每人身故赔偿限额*20%。
						</span>
						（11）本保单伤残赔偿金：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级而支付相应赔偿金。相应的赔偿限额为该伤残等级所对应的下列“伤残等级赔偿限额比例表”的比例乘以每人死亡赔偿限额所得金额。本保单适用伤残赔付比例按：一级伤残100％，二级伤残80％，三级伤残70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，
						<span class="red-bold">八级伤残20％，九级伤残10％，十级伤残5％。</span>
						（12）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GA/T1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
						<span class="red-bold">被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付。</span>
						（13）
						<span class="red-bold">本保单指定就诊医院为大陆境内二级及以上公立医院。</span>
						如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
						（14）本保单附加24小时意外险特别扩展B（2022版）条款，扩展承保被保险人雇员在全天24小时内因意外事故而导致的死亡赔偿金、伤残赔偿金(或自伤残发生之日起在180日内发生死亡)以及因此而引起的意外医药费用（社保范围内用药）。其中，伤残鉴定标准按照《人身保险伤残评定标准（行业标准）》，伤残赔付比例按：一级伤残100％，二级伤残80％，三级伤残70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，
						<span class="red-bold">
							八级伤残20％，九级伤残10％，十级伤残5％。24小时意外险死亡伤残责任与雇主工伤死亡伤残责任共用限额，每人最高不超过保单列明的雇主工伤死亡伤残责任限额的50%；24小时意外险医疗责任与雇主工伤医疗责任共用限额，每人最高不超过保单列明的工伤医疗责任限额。
						</span>
						（15）本特别约定与主条款内容相悖之处，以本特约为准；未尽之处，以主条款为准。
					</div>
				</div>
			</el-card>
		</div>

		<div v-else-if="insureType == 3">
			<el-card header="投保须知及声明">
				<el-row>
					<el-col :span="23">
						<div style="line-height: 26px; white-space: pre-line">
							<span style="font-weight: bold">
								本产品由中国平安财产保险股份有限公司（以下简称“中国平安”）承保，由中国平安委托博维保险经纪有限公司（以下简称“博维”）进行销售（互联网保险信息披露访问链接：http://icid.iachina.cn/?columnid_url=201509301401）。
							</span>
							中国平安财产保险股份有限公司成立于1988年，总部位于深圳，经营区域覆盖全国，在国内各省市、自治区设有35家二级机构，1100多个营业网点。截止2022年第4季度，公司综合偿付能力充足率为220%，满足监管要求。公司最近一期的风险综合评级结果为BBB。
							<h3>一、重要告知</h3>
							<span style="font-weight: bold">
								1、订立本合同时，本公司应向投保人说明本合同的内容。
								2、对保险条款中免除本公司责任的条款，本公司在订立合同时应当在投保界面、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容向投保人作出明确说明，未作提示或者明确说明的，该条款不产生效力。
								3、本公司就投保人和被保险人的有关情况提出询问，投保人应当如实告知。
								4、如果投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响本公司决定是否同意承保或者提高保险费率的，本公司有权解除本合同。
								5、如果投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，并不退还保险费。
								6、如果投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，本公司不承担给付保险金的责任，但应当退还保险费。
								7、本公司在合同订立时已经知道投保人未如实告知的情况的，本公司不得解除合同；发生保险事故的，本公司承担给付保险金的责任。
							</span>
							<h3>二、产品信息</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">备案名称</th>
									<th style="width: 50%; padding: 5px 0">注册号</th>
								</tr>
								<tr style="text-align: center">
									<td style="padding: 5px 0">平安雇主责任保险（A款）</td>
									<td style="padding: 5px 0">C00001730912018083014861</td>
								</tr>
							</table>
							<h3>三、产品介绍</h3>
							<h4>
								3.1 本保险为“雇主责任保险”
								<span class="red-bold">（具体承保内容以保单及保险条款为准）</span>
								，针对家电行业的特征，我们对您投保本份保险作以下重要提示：
							</h4>
							3.1.1
							投保人或被保险人为中华人民共和国境内注册的企业或个体工商户，获得当地市场监督管理局颁发的《营业执照》。
							3.1.2 保障人员必须为接受被保险人（或保单约定的共同被保险人）派工及管理的人员。
							<h4>3.2 投保人/被保险人</h4>
							家电、家居用品、充电桩售后服务网点（单位）为保险合同的投保人/被保险人，被保险人的分销商、二级网点为保险合同的共同被保险人。（本产品仅限于家电、家居用品、充电桩行业销售）
							<h4>3.3 保险期限</h4>
							自生效日起，保险期限为一年。
							<h4>3.4 特别约定</h4>
							下列特别约定/条款适用于保单的各个部分，均在每份保单当中载明。若其与保单的其他规定相冲突，则以下列特别约定/条款为准。
							3.4.1本保单被保险人雇员为从事家电、家居、充电桩的安装、维护、修理等工作相关人员，投保年龄限16-60周岁（不超60），与被保险人签订有劳动合同或存在事实劳动合同关系，接受被保险人给付薪金、工资，包括正式在册职工、短期工、临时工、季节工和学徒工等相关工作人员。本保单采用记名承保，在保员工以投保人提供的人员名单及其身份证号码为准。
							3.4.2在保险期间内，被保险人的在保人员因从事被保险人所安排的企业经营范围内的工作（不限家电、家居用品、充电桩品牌、品类）而遭受意外事故（包括上下班途中遭受意外事故），或患与业务有关的国家规定的职业性疾病，所致伤、残或死亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照保险合同约定在赔偿限额内负责赔偿。
							3.4.3本保单保障项目分为死亡赔偿、伤残赔偿、医疗费用、误工费、第三者责任、法律费用，每项保障项目的赔偿限额应在保单明确载明。
							3.4.4本保单的共同被保险人包括但不限于保单约定的被保险人及其分销商、二级网点。但是其分销商、二级网点在理赔时需要提供与被保险人的相关合作协议、银行结算清单等关系证明材料。
							3.4.5鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保，本保单所定的保险费率已为最低收费，即短期保费等于保单保费。被保险人申请退保或在保人员批减时，可退保费为0。
							3.4.6被保险人须按雇员实际工作中危险程度最高的情况选择投保方案，若被保险人的在保人员在发生保险事故时实际工作的危险程度高于投保方案适用情况的，保险人将不承担任何赔偿责任。
							3.4.7本保险方案仅适用于非高空作业人员，被保险人的在保人员从事高空作业时发生的损失事故，保险人将不承担保险赔偿责任。国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。
							3.4.8在保险期间内，发生保险责任范围内的意外事故，保险人根据被保险人投保的人员名册，对发生死亡、伤残的人员按下列标准赔偿：
							死亡：依据国家规定的工伤死亡赔偿标准计算，并在保单约定的死亡赔偿限额内赔偿。对本保单项下发生的猝死事故，赔付金额以保单约定死亡限额的50%为限。猝死的定义如下：在工作时间和工作岗位上，突发疾病死亡或在48小时之内经抢救无效死亡。
							伤残：根据伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级后，依据国家规定的工伤伤残赔偿标准计算，并在保单约定的伤残赔偿限额内赔偿。保单约定的伤残赔偿限额为死亡、伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例。为确保伤残鉴定结果准确无争议，在进行伤残鉴定前被保险人可提前联系保险人，确定保险人认可的伤残鉴定机构。对于伤残鉴定结果存在争议的，被保险人应前往当地劳动保障行政部门或保险人认可的伤残鉴定机构重新进行伤残鉴定。
							<h3 style="display: flex; justify-content: center; font-weight: bold">伤残等级赔偿限额比例表</h3>
							<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
								<tr>
									<th style="width: 50%; padding: 5px 0">伤残等级</th>
									<th style="width: 50%; padding: 5px 0">比例</th>
								</tr>
								<tr style="text-align: center">
									<td>一级</td>
									<td>100%</td>
								</tr>
								<tr style="text-align: center">
									<td>二级</td>
									<td>80%</td>
								</tr>
								<tr style="text-align: center">
									<td>三级</td>
									<td>70%</td>
								</tr>
								<tr style="text-align: center">
									<td>四级</td>
									<td>60%</td>
								</tr>
								<tr style="text-align: center">
									<td>五级</td>
									<td>50%</td>
								</tr>
								<tr style="text-align: center">
									<td>六级</td>
									<td>40%</td>
								</tr>
								<tr style="text-align: center">
									<td>六级</td>
									<td>40%</td>
								</tr>
								<tr style="text-align: center">
									<td>七级</td>
									<td>30%</td>
								</tr>
								<tr style="text-align: center">
									<td>八级</td>
									<td>20%</td>
								</tr>
								<tr style="text-align: center">
									<td>九级</td>
									<td>10%</td>
								</tr>
								<tr style="text-align: center">
									<td>十级</td>
									<td>5%</td>
								</tr>
							</table>
							伤残项目对应《伤残鉴定标准》两项者，如果两项不同级，以级别高者确定伤残等级，如果两项同级，以该级别的上一等级确定伤残等级；伤残项目对应《伤残鉴定标准》三项以上者（含三项），以所有伤残项目中最高级别的上一等级确定伤残等级。但无论如何，伤残等级不得高于《伤残等级赔偿限额比例表》中所规定的一级。
							3.4.9医疗机构特别约定：本保单认可的医疗机构指经中华人民共和国卫生部门评审确定的二级或二级以上的医院，但不包括主要作为诊所、康复、护理、休养、静养、戒酒、戒毒等或类似的医疗机构。该医院必须具有符合国家有关医院管理规则设置标准的医疗设备，且全天二十四小时有合格医师及护士驻院提供医疗及护理服务。如因紧急抢救无法前往本保单指定的定点医院救治的，应在情况允许的条件下，于72小时内转入本保单认可的医疗机构就诊。
							3.4.10医疗费用特别约定：本保单所约定的医疗费用赔偿责任仅包含在本保单认可的医疗机构发生且被保险人实际支出的，符合就诊地社会医疗保险主管部门规定的必要、合理、可报销的医疗费用（其中检查费以累计2000元为限），但不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。对被保险人所支出的符合本保单约定的医疗费用（包含门诊及住院）均按80%比例给付医疗保险金。如果被保险人已从其他途径获得补偿的，保险人只承担符合本保单约定的医疗费用剩余部分的保险责任。
							3.4.11自费药赔付特别约定：兹经双方同意并约定，在其它规定以保单、批单及保险条款为准的同时，被保险人的在保人员因本保险合同列明的原因所致受伤、残、死亡时，本保单扩展承保医疗费用项下必要的、合理的自费药品部分，但是，每人年累计赔偿限额在保单约定的每人医疗费用责任限额内计算。
							自费药品定义为：除社保甲、乙类用药以外的必须药品，包括乙类药品的自付部分，不包括各种营养类、滋补类药品、保健品、中药和中药饮片，也不包括受伤人员的陪护费、伙食费、营养费、交通费、取暖费、空调费及安装假肢、假牙、假眼和残疾用具费用。
							3.4.12误工费赔付特别约定：暂时丧失工作能力且需住院治疗的事故，经二级（含）以上或保险人认可的医疗机构提供合理的证明，保险人按照人民币100元/人/天的标准乘以住院天数（以最长365天为限）计算误工费。但是，一旦确定伤残程度后即刻停止误工费计算。如经过医疗机构诊断确定为永久丧失全部/部分工作能力的，应赔付误工费与根据(8)款约定所确定的伤残赔付金额合并在本保单赔偿限额内进行赔付，超出保单赔偿限额的部分保险人将不予赔付。误工费赔付无需被保险人提供出险人员的工资证明。出险人员仅需门诊治疗的，按本保单约定无误工费赔付。
							3.4.13扩展工伤事故：被保险人的在保人员在工作期间，由于工作原因受到伤害，依照《工伤保险条例》应当认定为工伤或视同工伤时，对于被保险人依法应承担的经济赔偿责任，保险人予以赔付。
							3.4.14扩展承保第三者责任：本保单扩展承保在保险期间内，被保险人的在保人员在从事被保险人所安排的企业经营范围内的工作（不限家电品牌、品类）时，因意外或疏忽，造成第三者的人身伤亡，依照中华人民共和国法律应由被保险人承担的经济赔偿责任，保险人按照本条特别约定，在保险合同载明的本项扩展责任限额内负责赔偿。
							本项扩展责任下，第三者是指除被保险人及其关联单位和关联人员以外的被保险人的工作服务对象，或与被保险人及其投保人员毫无关联关系和亲属、朋友关系的陌生人。
							本项扩展责任下，保单累计赔偿限额RMB100万元，每次事故赔偿限额RMB50万元。同一网点投保多份保单，本项扩展责任的累计赔偿限额和每次事故赔偿限额均以单份保单限额为限，赔偿限额不可叠加。
							以下情况不属于第三者责任的保障范围：
							（1）因驾驶各种机动车辆（包括电动车）发生意外事故导致的第三者人身伤亡；
							（2）装卸、运输货物期间发生意外事故导致的第三者人身伤亡；
							（3）第三者要求被保险人赔偿的间接损失，例如误工费、住宿费等。 （4）第三者的各类财物损坏和财务损失。
							（5）第三者实际从事或协助从事被保险人的工作过程中发生意外事故导致的人身伤亡。
							3.4.15扩展法律费用条款:在保险期间内，发生可能引起本保险合同项下赔偿的情形时，被保险人被提起诉讼或仲裁，事先经保险人书面同意支付的合理的、必要的诉讼费、鉴定费、取证费、案件受理费、评估费、公证费、律师费、仲裁费及其他相关费用等，保险人依照本合同约定承担赔偿责任。保单累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
							3.4.16本保单不承保高空作业人员。
							3.4.17本保单不承保投保人、被保险人及雇员工作地点属于下述地区的企业：北京市平谷区/密云区/怀柔区、河北省三河市/青龙县/廊坊市、天津市滨海区/静海区、辽宁省铁岭市、山东省禹城/莱州市/滨州市/德州市/临沂市，河南省信阳市/焦作市/新乡市/郏县、四川省宜宾市/雅安市、吉林省四平市、福建省南平下辖、江苏省常州市/连云港市、湖北省黄冈市。
							3.4.18被保险人须在保险事故发生后的48小时内向保险人报案，报案电话95511。超48小时报案，视为延迟报案，保险人对保险责任范围内的损失按绝对免赔率30%定损。因延迟报案致使保险人对保险事故的性质、原因、损失程度等难以查勘定损确定的，保险人对于无法核实确定的部分，不承担赔偿责任。
							以上各条特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准。
							<h4>3.5 保单形式</h4>
							本产品提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，与纸质合同具有相同的法律效力。投保人投保本保险时视为接受电子保单作为本投保书成立的合法有效凭证，具有完全证据效力。
							<h4>3.6 发票形式</h4>
							本产品根据投保人的需求提供增值税普通发票（电子票）或增值税专用发票（纸质发票）。电子发票效力等同于纸质发票。
							<h3>四、理赔</h3>
							出险后请您尽快通过微信小程序“美保理赔助手”，或拨打博维客服热线400-180-1616进行报案，根据指引提交理赔资料，保险公司将审核案件，并对于属于保险公司的保险责任的损失进行理赔金支付，理赔金将直接转账至被保险人名下的指定银行卡账户。
							<h3>五、其他信息</h3>
							5.1
							我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未授权的第三方。
							5.2
							您在购买产品过程中，如发现本公司有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向本公司投诉，投诉电话：95511。
							5.3
							若投保及后续服务和理赔过程中出现争议情况，您可致电博维客服热线400-180-1616或中国平安客户服务及投诉热线：95511，我们将安排专人跟进处理。
						</div>
					</el-col>
				</el-row>
			</el-card>
		</div>

		<div v-else-if="insureType == 29">
			<el-card header="投保须知及声明">
				<el-row>
					<el-col :span="20">
						<h3>一、产品基本信息</h3>
						<div style="white-space: pre-line">
							1、被保险人须符合如下要求: (1) 被保险人年龄范围 18 周岁（含）-65
							周岁（含），外籍人士及港澳台人士不支持投保； (2) 身体健康的，在中国大陆常住或生活的人员； (3)
							根据《中国人民财产保险股份有限公司意外伤害保险职业分类表》，被保险人职业类别限5-6类，其他职业不可投保。
							2、投保人须符合如下要求: (1)
							投保人应对被保险人具有可保利益，可以为被保险人本人或被保险人的父母、配偶、子女投保； (2)
							年龄18周岁的具有完全民事行为能力的自然人可作为投保人。 3、身故受益人：本产品受益人为法定受益人。
							4、本产品每人限购一份，多投无效。 5、保险期间：1年。 6、等待期：无等待期。
							7、生效日：本产品自投保之日起，最早
							<span class="red-bold">T+2日零时</span>
							生效。 8、赔付比例：
							<span class="red-bold">
								在保险期间内，被保险人遭受意外伤害事故，保险人就被保险人自事故发生之日起实际支出的按照当地(保单签发地)
								社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，每次免赔 100 元，剩余部分按
								80%赔付；未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，每次免赔
								300 元，剩余部分按
								60%赔付；并且，保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长
								15 日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以 90
								日为限。
							</span>
							9、本产品为一年期产品，不保证续保。 10、
							<span class="red-bold">
								退保规则：若投保人申请解除保险合同，保险人支持退保并退还本保险合同的现金价值，按下述公式计算现金价值：
							</span>
							<br />
							<span class="red-bold">
								现金价值=净保费×（1-m/n），其中，m为已生效天数，n为保险期间的天数，经过日期不足一日的按一日计算。
							</span>
						</div>

						<span class="red-bold"></span>

						<el-divider></el-divider>
						<h3>二、保险机构信息</h3>
						<div style="white-space: pre-line">
							1、承保公司、销售主体：本产品由中国人民财产保险股份有限公司（简称中国人保财险）承保，目前中国人保财险在北京、上海、天津、重庆、河北、陕西、内蒙古、山西、辽宁、吉林、黑龙江、江苏、安徽、浙江、福建、江西、山东、湖北、湖南、河南、广东、广西、海南、四川、云南、贵州、甘肃、宁夏、青海、西藏、新疆、大连、青岛、宁波、厦门、杭州、广州、深圳设有分支机构。本产品由博维保险经纪有限公司广东分公司代理销售。
							2、销售范围：本产品的销售范围为全国。 3、条款适用：本产品适用条款为
							4、保单形式：网上投保为您提供电子保单，根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。你可以登录中国人保财险官网“http://www.epicc.com.cn”或关注“中国人保财险”微信公众号自助查询，对电子保单的真实性进行验证。
							5、发票形式：本产品仅提供电子发票，电子发票效力等同于纸质发票，报销可将电子发票打印后直接报销。
							6、如实告知：投保时，投保人应如实填写投保信息，并如实告知被保人的健康及职业状况。如未履行如实告知义务的，保险公司有权依法解除保险合同，并对合同解除前发生的保险事故不承担保险责任。
							7、客户授权：如您投保此保险，视为您本人授权中国人保财险和博维保险经纪有限公司广东分公司出于提升保险服务质量之目的，合法的从任何单位、组织和个人获取您本人有关的资料和证明，作为审核投保、处理理赔及提供与本保险有关其他服务的依据。
							8、信息安全：我们严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供给我们的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。
							9、公司偿付能力信息公开披露查询地址：
							<el-link href="https://www.picc.com/xwzx/gkxx/ndxx/" type="primary">公司偿付能力信息公开披露查询</el-link>
							。 10、7*24小时服务热线/投诉热线：4006-366-366。
						</div>
						<h3>三、特约约定</h3>
						<div style="white-space: pre-line">
							1、每人
							<span class="red-bold">仅限投保一份，多投无效。</span>
							2、本保单被保险人年龄范围18周岁-65周岁，外籍人士及港澳台人士不支持投保。 3、
							<span class="red-bold">
								被保险人职业类别：本保单仅承保《中国人民财产保险股份有限公司意外伤害保险职业分类表》中5-6类职业人员，其他职业类别人员不在本保险合同的投保范围。被保险人职业类别以出险时的行为状态确定，从事不可保职业的人员为本保险不可保对象，本公司不承担保险责任；非不可保职业人员但从事不可保职业相关活动时发生的事故也不属于保险责任范围。其中下列职业被保险人不予投保：石材加工制造、矿业、采石业、炸药业、危险化工行业、直升机飞行人、飞行训练人、楼宇拆除工人爆破工作人员、潜水工作人员、火药、炸药制造人员、有关高压电工作人员、石棉瓦工作人员、特技演员、驯兽师、空中飞人、走钢丝人员、动物园驯兽师、保镖、炸药处理警察、防爆警察、警校学生、拳击运动员、各类赛车手、跳伞、登山运动人员、现役军人、煤矿业、油矿业。
							</span>
							4、意外医疗费用补偿责任：
							（1）医院范围：本保单意外医疗相关保障指定就诊医院为中华人民共和国境内(不包括香港、澳门、台湾地区)
							<span class="red-bold">二级或二级以上公立医院</span>
							，且应符合下列所有条件:1)拥有合法经营执照；2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。
							<span class="red-bold">
								但不包括以下医院：1）北京市的平谷区、密云区、怀柔区所有医院；2）江苏省的徐州市、南通市、连云港市所有医院；3）天津市的滨海、静海地区所有医院；4）辽宁省的铁岭市所有医院、辽宁中医药大学附属第二医院、中国人民解放军第二0五医院、辽宁省中医医院、营口市所有医院；5）吉林省的长春市、四平市所有医院、吉林省中医医院、吉林通化市人民医院、抚松县中医院；6）黑龙江省佳木斯市富锦市中心医院、中医医院、鸡西市所有医院；7）河北省的青县、青龙县、东光县、三河市、承德市兴隆县、廊坊市固安县所有医院、邯郸市馆陶县人民医院、南皮县中医医院；8）河南省的信阳市、洛阳市、郑州市、开封市、新乡市、商丘市、焦作市、安阳市黄县所有医院、通许县中医院；9）山东省的禹城市、栖霞市、莱州市、德州禹城、潍坊市高密县的所有医院、滨州市中心医院、青岛市即墨区中医医院、莱阳市中医医院、济宁市金乡县人民医院、鱼台县人民医院、荣成市中医院、烟台市中医院、富顺县中医院、曹县人民医院、济南市长清区人民医院；10）山西省运城市、阳泉市所有医院、太原市迎泽区中医院；11）四川省的宜宾市、内江市、雅安市所有医院、邛崃市医疗中心医院；12）内蒙古的扎兰屯市、赤峰市所有医院；13）广东省的湛江市第二中医医院、茂名市电白区人民医院；14）湖南省的衡阳市中医正骨医院、衡阳市中心医院；15）安徽省毫州市所有医院；16）甘肃省民勤县人民医院、庆阳市中医医院；17）福建南平的所有医院；18）所有私营社保定点医院。请注意：被保险人在上述医院进行治疗的保险人均不予以理赔，建议您去其他区域的
								<span class="red-bold">二级或二级以上公立医院</span>
								就医。
							</span>
							（2）赔付标准：
							<span class="red-bold">
								在保险期间内，对于被保险人遭受意外伤害之日起实际支出的当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，在扣除社会基本医疗保险、公费医疗已经补偿或给付部分后，保险人按每次事故绝对免赔额100元，对其余额按80%比例给付；若被保险人未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，保险人扣除每次事故绝对免赔额300元后，对其余额按60%比例给付。保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长15日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以90日为限。
							</span>
							5、本产品意外伤害医疗保障，
							<span class="red-bold">
								不承担普通针刺治疗、针炙治疗、红外线治疗、可见光治疗、紫外线治疗、激光疗法、光敏疗法、直流电治疗、低频脉冲电治疗、中频脉冲电治疗、超短波短波治疗、微波治疗、射频电疗、静电治疗、空气负离子治疗、超声波治疗、电子生物反馈疗法、磁疗、水疗、蜡疗、泥疗、牵引、气压治疗、冷疗、电按摩、场效应治疗、中频脉冲电治疗、穴位贴敷治疗、中医定向透药疗法等中医治疗、理疗行为产生的医疗费用。
							</span>
							6、意外住院津贴责任：意外住院津贴责任100元/天，
							<span class="red-bold">单次最高给付津贴日数30天，总给付日数180天，免赔天数0天。</span>
							7、在本保单可承保高空作业，
							<span class="red-bold">
								被保险人若从事高处作业【凡在坠落高度基准面2m以上(含2m)有可能坠落的高处进行的作业，高处作业以《高处作业分级标准》(中华人民共和国国家标准GB/T3608-2008)中的定义为准】，须按照相关行业安全管理规定取得由应急管理部门颁发《高处作业操作证》，否则发生死亡或伤残事故，保险人按照保单约定应承担保险责任的
								75%计算赔偿金额。
							</span>
							8、被保险人
							<span class="red-bold">
								如系涉及特种行业岗位，根据《中华人民共和国安全生产法》之规定，必须持有国家安全生产监管局签发的特种作业操作证（不含高处作业操作证），或国家质量技术监督局签发的特种设备作业证上岗，否则本保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。
							</span>
							四、责任免除 *《中国人民财产保险股份有限公司意外伤害保险（互联网专属）条款》责任免除*
							<span class="red-bold">
								因下列情形之一，导致被保险人意外身故或意外伤残的，保险人不承担给付保险金的责任：
							</span>
							<span class="red-bold">
								（1）投保人对被保险人的故意杀害、故意伤害；
								（2）被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；
								（3）被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀；
								（4）被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限；
								（5）被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限；
								（6）疾病，包括但不限于高原反应、中暑、猝死； （7）非因意外伤害导致的细菌、病毒或其他病原体导致的感染；
								（8）过敏及由过敏引发的变态反应性疾病；
								（9）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；
								（10）战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （11）被保险人故意犯罪或抗拒依法采取的刑事强制措施；
								（12）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；
								（13）被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；
								（14）被保险人妊娠、流产、分娩； （15）被保险人感染艾滋病病毒或患艾滋病（见释义）；
								（16）被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限；
								（17）被保险人酒后驾驶（见释义）、无合法有效驾驶证（见释义）驾驶或驾驶无合法有效行驶证（见释义）的机动交通工具。
							</span>

							*《中国人民财产保险股份有限公司附加意外伤害医疗保险A款（互联网专属）条款》责任免除*
							<span class="red-bold">
								1. 因下列情形之一，导致被保险人支出医疗费用的，保险人不承担给付保险金责任：
								（1）投保人对被保险人的故意杀害、故意伤害；
								（2）被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外；
								（3）被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀； （4）被保险人妊娠、流产、分娩；
								（5）被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外；
								（6）被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限；
								（7）被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限；
								（8）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；
								（9）战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （10）被保险人故意犯罪或抗拒依法采取的刑事强制措施；
								（11）被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；
								（12）被保险人感染艾滋病病毒或患艾滋病（见释义）；
								（13）被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限；
								（14）被保险人酒后驾驶（见释义）、无有效驾驶证（见释义）驾驶或驾驶无有效行驶证（见释义）的机动交通工具；
								（15）疾病，包括但不限于高原反应、中暑、猝死（见释义）；
								（16）非因意外伤害导致的细菌、病毒或其他病原体感染； （17）过敏及由过敏引发的变态反应性疾病；
								（18）被保险人非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容；
								（19）被保险人非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；
								（20）被保险人进行一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗、心理治疗或预防性治疗；
								（21）被保险人在获得被保资格前已有残疾的治疗和康复； （22）被保险人在家自设病床治疗；
								（23）被保险人不符合入院标准住院、挂床住院（见释义）或应当出院但拒不出院而造成的延长住院。
							</span>
							<span class="red-bold">2. 对于本附加险合同载明的免赔额，保险人不承担给付保险金的责任。</span>

							*《中国人民财产保险股份有限公司附加意外伤害住院津贴保险A款（互联网专属）条款》责任免除*
							<span class="red-bold">
								1、因下列情形造成被保险人住院治疗的，保险人不承担给付保险金的责任： （1）
								投保人对被保险人的故意杀害、故意伤害； （2）
								被保险人故意自伤或自杀，但被保险人自杀时为无民事行为能力人的除外； （3）
								被保险人因挑衅或故意行为而导致的打斗、被袭击或被谋杀； （4）
								被保险人接受包括美容、整容、整形手术在内的任何医疗行为而造成的意外； （5）
								被保险人未遵医嘱服用、涂用、注射药物，但按使用说明的规定使用非处方药不在此限； （6）
								被保险人受酒精、毒品、管制药物的影响，但遵医嘱使用药物的情形不在此限； （7）
								任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射； （8）
								战争、军事冲突、暴乱或武装叛乱、恐怖袭击； （9） 被保险人故意犯罪或抗拒依法采取的刑事强制措施； （10）
								被保险人存在精神和行为障碍（以世界卫生组织颁布的《疾病和有关健康问题的国际统计分类（ICD-10）》为准）；
								（11） 被保险人从事高风险运动（见释义），但被保险人作为专业运动员从事其专业运动不在此限； （12）
								被保险人酒后驾驶（见释义）、无合法有效驾驶证（见释义）驾驶或驾驶无合法有效行驶证（见释义）的机动交通工具；
								（13） 疾病，包括但不限于高原反应、中暑、猝死（见释义）； （14）
								非因意外伤害导致的细菌、病毒或其他病原体导致的感染； （15） 过敏及由过敏引发的变态反应性疾病； （16）
								被保险人非因意外伤害而进行的整容、整形手术，以及因任何原因进行的美容； （17）
								被保险人非因意外伤害而进行的牙科治疗或手术、视力矫正、因矫正视力而作的眼科验光检查，以及任何原因导致的牙齿修复或牙齿整形、安装及购买残疾用具（如轮椅、假肢、假眼、假牙或者助听器等）；
								（18） 被保险人进行一般身体检查、疗养、特别护理、静养、康复性治疗、物理治疗、心理治疗或预防性治疗；
								（19） 被保险人妊娠、流产、分娩； （20） 被保险人在投保前已有残疾的治疗和康复。
								2、对于以下情形，保险人也不承担给付保险金的责任： （1）
								被保险人在家自设病床治疗，或在门诊观察室、急诊观察室、其他非正式病房、联合病房的治疗； （2）
								被保险人不符合入院标准住院、挂床住院（见释义）或住院病人应当出院但拒不出院而造成的延长的住院日数。
								3、对于按本附加险合同载明的免赔日数计算出的免赔金额，保险人不承担赔偿责任。
							</span>
						</div>
					</el-col>
				</el-row>
			</el-card>
		</div>
	</div>
</template>

<script>
import {insureConfig_6} from '@/const/crud/insurance/product'
import {
	isAnZeGang,
	isAnZePower,
	isAnZeStandard,
	isFgkCommon,
	isFgkCommonYear,
	isFgkDoor,
	isFgkGangCommon,
	isFgkGangZungui,
	isFgkGuangfu,
	isFgkGuangfuDoorCustom,
	isFgkZungui,
	isMeiYaB,
	isMeiYaC,
} from '@/util/productUtil'
import {optionAddFeeRate} from '@/const/crud/insurance/productDetail'

export default {
	name: 'InsuredNotice',
	props: {
		productId: {
			type: Number | String,
			required: true,
		},
		insureType: {
			type: Number | String,
			required: true,
		},
	},
	data() {
		return {
			config6Data: insureConfig_6,
			leavelData: ['一级', '二级', '三级', '四级', '五级', '六级', '七级', '八级', '九级', '十级'],
			leavelValueData: ['100%', '80%', '70%', '60%', '40%', '30%', '20%', '15%', '7%', '5%'],
			questionDataRate: ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			dataAddFeeRate: [
				{
					category: '比例',
					month1: '20%',
					month2: '25%',
					month3: '35%',
					month4: '45%',
					month5: '55%',
					month6: '65%',
					month7: '75%',
					month8: '80%',
					month9: '85%',
					month10: '90%',
					month11: '95%',
				},
			],
			optionAddFeeRate: this.deepClone(optionAddFeeRate),
		}
	},
	created() {
		let categoryTemp = this.findObject(this.optionAddFeeRate.column, 'category')
		categoryTemp.hide = true
	},
	methods: {
		isFgkCommonYear,
		isAnZeGang,
		isFgkCommon,
		isFgkZungui,
		isFgkGangZungui,
		isFgkGuangfu,
		isFgkDoor,
		isMeiYaB,
		isMeiYaC,
		isFgkGangCommon,
		isAnZePower,
		isAnZeStandard,
	},
	computed: {
		//光伏
		getGuangfu() {
			let tempHint =
				'六级伤残给付比例50%，七级伤残给付比例40%，八级伤残给付比例20%，九级伤残给付比例10%，十级伤残给付比例5%。'
			if (isFgkGuangfuDoorCustom(this.productId)) {
				tempHint =
					'六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例10%，九级伤残给付比例7%，十级伤残给付比例5%。'
			}
			return `12、按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，<span
      class="red-bold">${tempHint}</span>`
		},
		//门窗
		getFgkDoor() {
			let tempHint = isFgkGuangfuDoorCustom(this.productId)
				? '六级伤残给付比例40%，七级伤残给付比例30%，八级伤残给付比例10%，九级伤残给付比例7%，十级伤残给付比例5%。'
				: '六级伤残给付比例50%，七级伤残给付比例40%，八级伤残给付比例20%，九级伤残给付比例10%，十级伤残给付比例5%。'
			return `14、（投保尊贵版）按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，<span class="red-bold">${tempHint}</span>`
		},
		getSpecialContent() {
			return isAnZeStandard(this.productId)
				? `（2）<span class="red-bold">伤残：如被保险人雇员遭遇保险事故导致伤残或被保险人发生保险事故导致第三者伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照《人体损伤致残程度分级》（2017年1月1日起施行版本）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例20%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。</span><br/>`
				: `（2） <span class="red-bold">伤残：如被保险人雇员遭遇保险事故导致伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例15%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。</span><br/><span class="red-bold">如被保险人发生保险事故导致第三者伤残，每人可从保险人获得的伤残赔偿金=每人伤残赔偿限额*伤残等级对应的赔付比例。按伤残鉴定机构出具的伤残程度鉴定书，并对照《人体损伤致残程度分级》确定伤残等级而支付相应赔偿金，伤残程度为永久丧失工作能力或一级伤残给付比例100%，二级伤残给付比例90%，三级伤残给付比例80%，四级伤残给付比例70%，五级伤残给付比例60%，六级伤残给付比例30%，七级伤残给付比例20%，八级伤残给付比例15%，九级伤残给付比例7%，十级伤残给付比例5%。</span>`
		},
	},
}
</script>

<style lang="scss" scoped>
span.link {
	display: block;
	text-indent: 1em;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.list_content {
	margin-left: 30px !important;
}

.red-bold {
	font-weight: bold;
	color: red;
}

.font_title {
	font-weight: bold;
	font-size: 1.05em;
}

.font_head {
	font-weight: bold;
	font-size: 1.4em;
	margin: 20px 0;
	display: block;
}

.font_center {
	text-align: center;
}
</style>
